import { useState, useEffect, useRef, useMemo } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { canAccessFatturazioneElettronica } from "../utils/fatturazioneAccess";
import { escapeHtml } from "../utils/escapeHtml";
import { canAccessCentroDiurno } from "../utils/centroDiurnoAccess";
import { canAccessFamily } from "../utils/familyAccess";
import { toast } from "sonner";
import { AuditLogViewer } from "../components/AuditLogViewer";
import { SectionMetadata } from "../components/SectionMetadata";
import WithingsPressione from "../components/WithingsPressione";
import MonitoraggioVitale from "../components/MonitoraggioVitale";
import FatturazioneOspite from "../components/FatturazioneOspite";
import PreferenzeFatturazioneRetta from "../components/PreferenzeFatturazioneRetta";
import DestinatarioFatturazioneSection from "../components/fascicoli/DestinatarioFatturazioneSection";
import FamilyFascicoloPanel from "../components/fascicoli/FamilyFascicoloPanel";
import RichiestaDocumentiPreIngressoDialog from "../components/fascicoli/RichiestaDocumentiPreIngressoDialog";
import StampaDocumentiFascicoloDialog from "../components/fascicoli/StampaDocumentiFascicoloDialog";
import EstrazionePatologieDialog from "../components/fascicoli/EstrazionePatologieDialog";
import CompilaAnagraficaDaIdentitaDialog from "../components/fascicoli/CompilaAnagraficaDaIdentitaDialog";
import CambioMedicoSection from "../components/fascicoli/CambioMedicoSection";
import PulisciScansioneDialog, { isScanCleanable } from "../components/fascicoli/PulisciScansioneDialog";
import {
  CODICE_STATO_ITALIA,
  etichettaStatoAlloggiati,
  isNatoAllEstero,
  normalizzaCodiceStatoAlloggiati,
} from "../utils/alloggiatiCodici";
import {

  ChevronLeft,
  ChevronRight,
  User,
  FileText,
  Heart,
  Users,
  Briefcase,
  ClipboardList,
  ClipboardCheck,
  History,
  AlertTriangle,
  Calendar,
  Phone,
  Mail,
  MapPin,
  Edit,
  Save,
  X,
  Plus,
  Printer,
  Download,
  Check,
  Clock,
  Pill,
  Activity,
  Target,
  CreditCard,
  Globe,
  Trash2,
  Send,
  Upload,
  Paperclip,
  File,
  Image,
  Loader2,
  Eye,
  Archive,
  RotateCcw,
  PenLine,
  ScrollText,
  FileCheck,
  BookOpen,
  UtensilsCrossed,
  AlertCircle,
  FileSignature,
  Calculator,
  Home,
  Camera,
  Sun,
  Repeat,
  ArrowRightLeft,
  DoorOpen,
  Receipt,
  UserCheck,
  Sparkles,
  FolderOpen,
} from "lucide-react";
import CostiRicorrentiSection from "../components/fascicoli/CostiRicorrentiSection";
import CdPacchettoFascicoloSection from "../components/fascicoli/CdPacchettoFascicoloSection";
import DoctorSelect from "../components/doctors/DoctorSelect";
import { applyDoctorToSanitaria } from "../utils/doctorHelpers";
import CodiceFiscale from "codice-fiscale-js";
import PageHeader from "../components/PageHeader";

function formatApiDetail(detail, fallback = "Errore") {
  if (detail == null || detail === "") return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object") return item.msg || item.message || "";
        return "";
      })
      .filter(Boolean);
    return parts.join(". ") || fallback;
  }
  if (typeof detail === "object") {
    return detail.msg || detail.message || fallback;
  }
  return fallback;
}
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Input } from "../components/ui/input";
import FilePickerButton from "../components/ui/FilePickerButton";
import DateFieldInput from "../components/DateFieldInput";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Checkbox } from "../components/ui/checkbox";
import { Switch } from "../components/ui/switch";
import ComuneAutocomplete from "../components/ComuneAutocomplete";
import StatoAutocomplete from "../components/StatoAutocomplete";
import { formatCameraAssegnata } from "../utils/formatCamera";
import { normalizeCommaSeparatedForSave } from "../utils/normalizeCommaSeparatedForSave";
import { isDepositoCauzionaleAbilitato, importoDepositoCauzionale } from "../utils/depositoCauzionale";
import PaiViewBody from "../components/PaiViewBody";
import PaiFirmeStep from "../components/PaiFirmeStep";
import { createEmptyPaiFirmeState } from "../config/paiFirme";
import { isPaiUpload, isPaiCartaceo, isPaiEsterno, getPaiFileUrl } from "../utils/paiDisplay";
import { appendAuthToUrl, buildAuthFetchHeaders } from "../utils/authUrl";
import TerapieExtraSection from "../components/fascicoli/TerapieExtraSection";
import TerapieInCorsoSection from "../components/fascicoli/TerapieInCorsoSection";
import UsciteTemporaneeSection from "../components/fascicoli/UsciteTemporaneeSection";
import TagListEditor from "../components/TagListEditor";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PAI_WIZARD_STEPS = [
  "Generale",
  "Nutrizione",
  "Riposo",
  "Igiene",
  "Motoria",
  "Educativa",
  "Osservazione",
  "Obiettivi",
  "Firme",
];

function addDaysToIsoDate(isoDate, days) {
  if (!isoDate) return "";
  const parts = isoDate.split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return "";
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  d.setDate(d.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function addMonthsToIsoDate(isoDate, months) {
  if (!isoDate) return "";
  const parts = isoDate.split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return "";
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  d.setMonth(d.getMonth() + months);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function renderScadenzaBadge(scadenzaIso) {
  if (!scadenzaIso) return null;
  const scad = new Date(scadenzaIso);
  if (Number.isNaN(scad.getTime())) return null;
  const oggi = new Date();
  oggi.setHours(0, 0, 0, 0);
  scad.setHours(0, 0, 0, 0);
  const giorni = Math.ceil((scad - oggi) / (1000 * 60 * 60 * 24));
  if (giorni > 30) return null;
  if (giorni < 0) {
    const gg = Math.abs(giorni);
    return (
      <Badge className="mt-1 bg-red-600 text-white">
        Scaduto da {gg} {gg === 1 ? "giorno" : "giorni"}
      </Badge>
    );
  }
  return (
    <Badge className={`mt-1 ${giorni <= 7 ? "bg-red-500" : "bg-amber-500"} text-white`}>
      {giorni === 0 ? "Scade oggi" : `Scade tra ${giorni} ${giorni === 1 ? "giorno" : "giorni"}`}
    </Badge>
  );
}

function resizeImageFileToJpegDataUrl(file, maxEdge = 720, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let w = img.naturalWidth;
      let h = img.naturalHeight;
      if (w > maxEdge || h > maxEdge) {
        if (w >= h) {
          h = Math.round((h * maxEdge) / w);
          w = maxEdge;
        } else {
          w = Math.round((w * maxEdge) / h);
          h = maxEdge;
        }
      }
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("canvas"));
        return;
      }
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("load"));
    };
    img.src = url;
  });
}

/** Etichette per raggruppamento documenti per sezione (tab Documenti / export) */
const LABEL_DOCUMENTO_SEZIONE = {
  anagrafica: "Anagrafica",
  amministrativa: "Amministrativa",
  sociale: "Sociale",
  sanitaria: "Sanitaria",
  generale: "Generale",
  piani_terapeutici: "Piani terapeutici",
  terapie_ausili: "Terapie e Ausili",
  richiesta_rsa: "Richiesta RSA",
  contratto_firmato: "Contratto firmato",
  legali: "Documenti legali",
  delega_medico_firmata: "Delega medico",
  cambio_medico: "Cambio e rinnovo medico",
};

const SEZIONI_ALTRI_DOCUMENTI = [
  "anagrafica",
  "amministrativa",
  "sociale",
  "sanitaria",
  "legali",
  "delega_medico_firmata",
  "terapie_ausili",
  "piani_terapeutici",
  "richiesta_rsa",
  "generale",
];

function sezioniAltriDocumenti(documenti = []) {
  const presenti = new Set();
  documenti.forEach((doc) => {
    const sezione = doc.sezione || "generale";
    if (sezione !== "contratto_firmato") presenti.add(sezione);
  });
  const extra = [...presenti].filter((sezione) => !SEZIONI_ALTRI_DOCUMENTI.includes(sezione)).sort();
  return [...SEZIONI_ALTRI_DOCUMENTI.filter((sezione) => presenti.has(sezione)), ...extra];
}

const AMMINISTRATIVA_SECTIONS = new Set([
  "dati",
  "uscite",
  "centro-diurno",
  "destinatario",
  "fatturazione",
  "storico-fatture",
]);

// Rileva se siamo su dispositivo mobile/tablet
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
};

// Tipi documento per Alloggiati Web
const TIPI_DOCUMENTO = [
  { codice: "PASOR", descrizione: "PASSAPORTO ORDINARIO" },
  { codice: "PASSE", descrizione: "PASSAPORTO SERVIZIO" },
  { codice: "PASDI", descrizione: "PASSAPORTO DIPLOMATICO" },
  { codice: "IDELE", descrizione: "CARTA IDENTITA' ELETTRONICA" },
  { codice: "IDENT", descrizione: "CARTA DI IDENTITA'" },
  { codice: "PATEN", descrizione: "PATENTE DI GUIDA" },
  { codice: "PATNA", descrizione: "PATENTE NAUTICA" },
  { codice: "LIBNA", descrizione: "LIBRETTO DI NAVIGAZIONE" },
  { codice: "PERMO", descrizione: "PERMESSO DI SOGGIORNO ORDINARIO" },
  { codice: "PERME", descrizione: "PERMESSO DI SOGGIORNO ELETTRONICO" },
  { codice: "DOCVI", descrizione: "DOCUMENTO DI VIAGGIO" },
];


/** Campi comune/provincia nascita per tracciato Alloggiati (estero → EE / 000000000). */
function campiNascitaPerStato(statoCodice, statoLabel) {
  const label = String(statoLabel || "").trim();
  if (isNatoAllEstero(statoCodice, label)) {
    return {
      comune_nascita: "000000000",
      comune_nascita_label: label || "ESTERO",
      comune_nascita_provincia: "EE",
      luogo_nascita: label || "ESTERO",
    };
  }
  return null;
}

/** Estrae indirizzo strutturato da stringa libera tipo "Via Roma 1, 24100 Bergamo BG". */
function parseAddrResidenza(raw) {
  const s = String(raw || "").trim();
  if (!s) return { indirizzo: "", cap: "", citta: "", provincia: "" };
  const re = /(?<![0-9])(?<cap>\d{5})\s+(?<city>[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ'.\s-]+?)(?:\s+\((?<prov1>[A-Za-z]{2})\)|\s+(?<prov2>[A-Za-z]{2}))?\s*$/iu;
  const m = s.match(re);
  if (m) {
    return {
      indirizzo: s.slice(0, m.index).replace(/,\s*(SNC|SN)\b/gi, " $1").replace(/\s+/g, " ").trim().replace(/,\s*$/, ""),
      cap: m.groups.cap || "",
      citta: (m.groups.city || "").replace(/^(?:SNC|SN|N\.?\s*)\s+/i, "").trim(),
      provincia: ((m.groups.prov1 || m.groups.prov2) || "").toUpperCase(),
    };
  }
  const parts = s.split(",").map((p) => p.trim()).filter(Boolean);
  if (parts.length >= 2) {
    const tail = parts.slice(1).join(", ");
    const m2 = tail.match(re);
    if (m2) {
      return {
        indirizzo: parts[0],
        cap: m2.groups.cap || "",
        citta: (m2.groups.city || "").trim(),
        provincia: ((m2.groups.prov1 || m2.groups.prov2) || "").toUpperCase(),
      };
    }
  }
  return { indirizzo: s, cap: "", citta: "", provincia: "" };
}

/** Compone indirizzo_residenza (stringa SDI) dai 4 campi strutturati. */
function formatAddrResidenza(indirizzo, cap, citta, provincia) {
  const via = (indirizzo || "").trim();
  const locParts = [cap, citta, provincia ? `(${provincia})` : ""].filter(Boolean).join(" ");
  return [via, locParts].filter(Boolean).join(", ");
}

export default function FascicoloAssistenzialeDettaglio() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { token, user, hasPermission, strutture, activeStruttura, switchStruttura } = useAuth();
  const canFamily = canAccessFamily(user);
  const [cartella, setCartella] = useState(null);
  const [navOspiti, setNavOspiti] = useState([]);
  const [uploadingFotoOspite, setUploadingFotoOspite] = useState(false);
  const [loading, setLoading] = useState(true);
  const [terapieExtraAlertCount, setTerapieExtraAlertCount] = useState(0);
  const [preIngressoCard, setPreIngressoCard] = useState(null);
  const [attivandoOspite, setAttivandoOspite] = useState(false);
  const [showAttivaOspiteDialog, setShowAttivaOspiteDialog] = useState(false);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab") || "anagrafica";
  });
  const [amministrativaSection, setAmministrativaSection] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const section = params.get("section");
    return section && AMMINISTRATIVA_SECTIONS.has(section) ? section : "dati";
  });
  const [isEditing, setIsEditing] = useState(false);
  /** Bozza modifiche fascicolo: aggiornata onChange/onValueChange senza setState (niente re-render a ogni tasto). */
  const editDraftRef = useRef(null);
  /** Incrementata all'apertura modifica e su aggiunta/rimozione contatti (per rimontare le righe). */
  const [editSessionKey, setEditSessionKey] = useState(0);
  const [contattiListRevision, setContattiListRevision] = useState(0);
  const [editAusiliList, setEditAusiliList] = useState([]);
  const [editSedeProvincia, setEditSedeProvincia] = useState("");
  const [editDepositoAbilitato, setEditDepositoAbilitato] = useState(false);
  const diagnosiPrincipaleRef = useRef(null);
  const diagnosiSecondarieRef = useRef(null);
  const patologieCronicheRef = useRef(null);
  const allergieSanitariaRef = useRef(null);
  const pianiTerapeuticiTestoRef = useRef(null);
  const noteSanitarieRef = useRef(null);
  const codiceFiscaleInputRef = useRef(null);
  /** Evita doppia applicazione di ?edit=1 (es. Strict Mode). */
  const autoEditFromQueryAppliedRef = useRef(false);
  const [showValutazioneModal, setShowValutazioneModal] = useState(false);
  const [nuovaValutazione, setNuovaValutazione] = useState({
    data_valutazione: new Date().toISOString().split('T')[0],
    area_nutrizione: { stato: "", osservazioni: "" },
    area_riposo: { stato: "", osservazioni: "" },
    area_igiene: { stato: "", osservazioni: "" },
    area_motoria: { stato: "", osservazioni: "" },
    area_educativa: { stato: "", osservazioni: "" },
    area_psicosociale: { stato: "", osservazioni: "" },
    note_generali: "",
    operatori: { educatore: "", assistente_sociale: "", oss: "" }
  });
  
  // State per visualizzare valutazione PAI
  const [showValutazioneViewModal, setShowValutazioneViewModal] = useState(false);
  const [viewingValutazione, setViewingValutazione] = useState(null);
  
  // State per dialog conferma eliminazione
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [valutazioneToDelete, setValutazioneToDelete] = useState(null);

  const [showTrasferisciDialog, setShowTrasferisciDialog] = useState(false);
  const [trasferisciDestId, setTrasferisciDestId] = useState("");
  const [trasferisciNote, setTrasferisciNote] = useState("");
  const [trasferendo, setTrasferendo] = useState(false);
  
  // State per upload documenti
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showRichiestaDocumentiDialog, setShowRichiestaDocumentiDialog] = useState(false);
  const [showStampaDocumentiDialog, setShowStampaDocumentiDialog] = useState(false);
  const [showEstrazionePatologie, setShowEstrazionePatologie] = useState(false);
  const [showCompilaDaIdentita, setShowCompilaDaIdentita] = useState(false);
  const [showPulisciScansione, setShowPulisciScansione] = useState(false);
  const [pulisciScansioneDoc, setPulisciScansioneDoc] = useState(null);
  const [uploadSezione, setUploadSezione] = useState("generale");
  const [uploadDescrizione, setUploadDescrizione] = useState("");
  const [uploading, setUploading] = useState(false);
  const [uploadingPianiTerapeutici, setUploadingPianiTerapeutici] = useState(false);
  const [uploadingTerapieAusili, setUploadingTerapieAusili] = useState(false);
  const [proposteRefreshSignal, setProposteRefreshSignal] = useState(0);
  const [uploadingRichiestaRsa, setUploadingRichiestaRsa] = useState(false);
  const [scadenzaPianoTerapeutico, setScadenzaPianoTerapeutico] = useState("");
  const [documenti, setDocumenti] = useState([]);
  const [contrattoCartaceoAttestato, setContrattoCartaceoAttestato] = useState(false);
  const [contrattoCartaceoDataFirma, setContrattoCartaceoDataFirma] = useState("");
  const [savingContrattoCartaceo, setSavingContrattoCartaceo] = useState(false);
  const [paiCartaceoAttestato, setPaiCartaceoAttestato] = useState(false);
  const [paiCartaceoDataRedazione, setPaiCartaceoDataRedazione] = useState("");
  const [savingPaiCartaceo, setSavingPaiCartaceo] = useState(false);
  const fileInputRef = useRef(null);
  const pianiTerapeuticiFileInputRef = useRef(null);
  const terapieAusiliFileInputRef = useRef(null);
  const richiestaRsaFileInputRef = useRef(null);
  const fotoOspiteInputRef = useRef(null);
  
  // State per popup export cartella
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportHtml, setExportHtml] = useState("");
  
  // State per visualizzazione documento in popup
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedComunicazioneMedica, setSelectedComunicazioneMedica] = useState(null);
  const [showComunicazioneMedicaModal, setShowComunicazioneMedicaModal] = useState(false);
  const [selectedFamiliareEmail, setSelectedFamiliareEmail] = useState(null);
  const [selectedFamiliareEmailHistory, setSelectedFamiliareEmailHistory] = useState(null);
  const [familiareEmailSubject, setFamiliareEmailSubject] = useState("");
  const [familiareEmailText, setFamiliareEmailText] = useState("");
  const [sendingFamiliareEmail, setSendingFamiliareEmail] = useState(false);
  
  // State per camere disponibili (assegnazione camera)
  const [camereDisponibili, setCamereDisponibili] = useState([]);
  const [loadingCamere, setLoadingCamere] = useState(false);

  // Stato presenza ospite in Alloggiati Web
  const [alloggiatiStato, setAlloggiatiStato] = useState(null);
  const [loadingAlloggiatiStato, setLoadingAlloggiatiStato] = useState(false);
  
  // State per rilevamento mobile
  const [isMobile, setIsMobile] = useState(false);
  
  // State per PAI
  const [showPaiModal, setShowPaiModal] = useState(false);
  const [showPaiViewModal, setShowPaiViewModal] = useState(false);
  const [viewingPai, setViewingPai] = useState(null);
  const [savingPai, setSavingPai] = useState(false);
  const [paiStep, setPaiStep] = useState(0); // Step del wizard PAI
  // State per upload PAI da file
  const [showPaiUploadModal, setShowPaiUploadModal] = useState(false);
  const [paiUploadFile, setPaiUploadFile] = useState(null);
  const [paiUploadData, setPaiUploadData] = useState({
    data_redazione: new Date().toISOString().split('T')[0],
    data_scadenza: '',
    note_generali: '',
  });
  const [savingPaiUpload, setSavingPaiUpload] = useState(false);
  const [paiFirmeState, setPaiFirmeState] = useState(createEmptyPaiFirmeState);
  const paiFirmeStepRef = useRef(null);
  const [paiData, setPaiData] = useState({
    // Dati generali
    data_redazione: new Date().toISOString().split('T')[0],
    data_scadenza: '',
    redatto_da: '',
    
    // Stato civile e invalidità
    stato_civile: '',
    invalidita_civile: '',
    indennita_accompagnamento: '',
    certificazione_104: '',
    esenzioni: '',
    iniziativa_domanda: '',
    proveniente_da: '',
    partecipe_decisione: '',
    motivo_non_partecipe: '',
    
    // Medico e contatti
    medico_curante: '',
    medico_contatti: '',
    situazione_personale: '',
    
    // Persone di riferimento
    riferimento1_cognome: '',
    riferimento1_nome: '',
    riferimento1_nascita: '',
    riferimento1_residenza: '',
    riferimento1_parentela: '',
    riferimento1_telefono: '',
    riferimento2_cognome: '',
    riferimento2_nome: '',
    riferimento2_nascita: '',
    riferimento2_residenza: '',
    riferimento2_parentela: '',
    riferimento2_telefono: '',
    
    // Area Nutrizione
    appetito: '',
    percezione_sete: '',
    alimentazione: [],
    masticazione: '',
    deglutizione: '',
    preparazione_cibi: '',
    colazione_autonomia: '',
    colazione_terapia: false,
    pranzo_autonomia: '',
    pranzo_terapia: false,
    cena_autonomia: '',
    cena_terapia: false,
    note_nutrizione: '',
    obiettivi_nutrizione: '',
    
    // Area Riposo
    sonno: '',
    cambio_postura: '',
    cuscini: '',
    sponde_letto: '',
    difficolta_respiratoria: [],
    posizione_seduta: '',
    messa_a_letto: '',
    controllo_notturno: '',
    obiettivi_riposo: '',
    
    // Area Igiene
    alzata_mattino: '',
    vestizione: '',
    rimessa_a_letto: '',
    igiene_superiore: '',
    igiene_intima: '',
    bagno_settimanale: '',
    approccio_bagno: '',
    note_igiene: '',
    incontinenza_urinaria: '',
    incontinenza_rettale: '',
    usa_bagno: '',
    usa_catetere: '',
    usa_pannolone: '',
    allergie_pannolone: '',
    obiettivi_igiene: '',
    
    // Area Motoria
    spostamenti: '',
    ausili: {
      bastone: { usa: false, proprietario: '' },
      girello: { usa: false, proprietario: '' },
      carrozzina: { usa: false, proprietario: '' },
      cuscino_antidecubito: { usa: false, proprietario: '' },
      materasso_antidecubito: { usa: false, proprietario: '' }
    },
    presidi: [],
    programma_mattina: '',
    programma_pomeriggio: '',
    obiettivi_motoria: '',
    
    // Area Educativa
    comprensione: '',
    comunicazione: '',
    vita_relazione: '',
    contatti_esterni: [],
    contatti_con_chi: '',
    contatti_frequenza: '',
    interessi: {
      lettura: '',
      televisione: '',
      passatempi: '',
      lavori_manuali: '',
      uso_telefono: ''
    },
    esce_struttura: '',
    luoghi_frequentati: [],
    
    // Osservazione
    comunicazione_obs: '',
    relazione_maggioranza: '',
    relazione_ospite: '',
    relazione_operatore: '',
    relazione_privilegiata: '',
    sta_solo: '',
    partecipa_attivita: '',
    attivita_specifiche: '',
    tono_umore: '',
    ansia: [],
    agitazione: '',
    momenti_critici: '',
    aggressivo: '',
    collaborazione: '',
    orientamento: '',
    memoria: '',
    contatti_esterni_obs: [],
    
    // Obiettivi generali
    obiettivo_socializzazione: false,
    obiettivo_mantenimento: false,
    obiettivo_autonomie: false,
    obiettivo_specifico: '',
    
    // Note finali
    note_generali: ''
  });

  // Rileva mobile al mount
  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  useEffect(() => {
    const fetchCartella = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCartella(response.data);
        // Carica documenti
        setDocumenti(response.data.documenti || []);
      } catch (error) {
        console.error("Error fetching cartella:", error);
        toast.error("Errore nel caricamento della cartella");
      } finally {
        setLoading(false);
      }
    };

    fetchCartella();
  }, [id, token]);

  useEffect(() => {
    if (!token || !id) return;
    const fetchAlloggiatiStato = async () => {
      setLoadingAlloggiatiStato(true);
      try {
        const response = await axios.get(
          `${API_URL}/api/alloggiati-web/stato-fascicolo/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAlloggiatiStato(response.data);
      } catch (error) {
        console.error("Errore stato Alloggiati Web:", error);
        setAlloggiatiStato(null);
      } finally {
        setLoadingAlloggiatiStato(false);
      }
    };
    fetchAlloggiatiStato();
  }, [id, token, cartella?.ospite_id]);

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API_URL}/api/fascicoli-assistenziali`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        const list = (data || [])
          .filter((c) => !c.archiviata || c.id === id)
          .sort((a, b) => {
            const cmpCognome = (a.cognome || "").localeCompare(b.cognome || "", "it", {
              sensitivity: "base",
            });
            if (cmpCognome !== 0) return cmpCognome;
            return (a.nome || "").localeCompare(b.nome || "", "it", { sensitivity: "base" });
          })
          .map((c) => ({
            id: c.id,
            nome: (c.nome || "").trim(),
            cognome: (c.cognome || "").trim(),
            label: [c.cognome, c.nome].filter(Boolean).join(" ").trim() || c.nome_completo || "Ospite",
          }));
        setNavOspiti(list);
      })
      .catch(() => setNavOspiti([]));
  }, [token, activeStruttura?.id, id]);

  const navOspiteIndex = useMemo(
    () => navOspiti.findIndex((o) => o.id === id),
    [navOspiti, id]
  );
  const prevOspite =
    navOspiti.length > 1
      ? navOspiti[(navOspiteIndex + navOspiti.length - 1) % navOspiti.length]
      : null;
  const nextOspite =
    navOspiti.length > 1
      ? navOspiti[(navOspiteIndex + 1) % navOspiti.length]
      : null;

  const goToOspite = (ospiteId) => {
    if (!ospiteId || ospiteId === id) return;
    const qs = location.search;
    navigate(`/fascicoli-assistenziali/${ospiteId}${qs ? qs : ""}`);
  };

  useEffect(() => {
    if (!id || !token || cartella?.stato_ospite !== "PRE_INGRESSO") {
      setPreIngressoCard(null);
      return;
    }
    axios
      .get(`${API_URL}/api/fascicoli-assistenziali/${id}/pre-ingresso`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => setPreIngressoCard(data))
      .catch(() => setPreIngressoCard(null));
  }, [id, token, cartella?.stato_ospite, cartella?.pre_admission_status]);

  const handleAttivaOspite = async () => {
    setAttivandoOspite(true);
    try {
      const rawRoom = cartella?.room_id;
      const roomId =
        typeof rawRoom === "string" && /^[a-f\d]{24}$/i.test(rawRoom.trim())
          ? rawRoom.trim()
          : null;
      await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/attiva`,
        { room_id: roomId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Ospite attivato con successo");
      setShowAttivaOspiteDialog(false);
      await reloadCartella();
    } catch (err) {
      toast.error(formatApiDetail(err.response?.data?.detail, "Errore attivazione"));
    } finally {
      setAttivandoOspite(false);
    }
  };

  const reloadCartella = async () => {
    if (!id || !token) return;
    try {
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCartella(response.data);
      setDocumenti(response.data.documenti || []);
    } catch (error) {
      console.error("Error reloading cartella:", error);
    }
  };

  const refreshPreIngressoCard = async () => {
    if (!id || !token) return;
    try {
      const { data } = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}/pre-ingresso`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPreIngressoCard(data);
    } catch {
      setPreIngressoCard(null);
    }
  };

  const handleRichiestaDocumentiSent = async () => {
    await reloadCartella();
    await refreshPreIngressoCard();
  };

  useEffect(() => {
    if (!id || !token) return;
    const loadTerapieAlerts = () => {
      axios
        .get(`${API_URL}/api/fascicoli-assistenziali/${id}/terapie-extra/alerts`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(({ data }) => setTerapieExtraAlertCount(data.count || 0))
        .catch(() => setTerapieExtraAlertCount(0));
    };
    loadTerapieAlerts();
    const interval = setInterval(loadTerapieAlerts, 60000);
    return () => clearInterval(interval);
  }, [id, token]);

  useEffect(() => {
    autoEditFromQueryAppliedRef.current = false;
  }, [id]);

  useEffect(() => {
    if (isEditing) {
      const fetchCamere = async () => {
        setLoadingCamere(true);
        try {
          const currentRoomId = cartella?.room_id || "";
          const url = currentRoomId
            ? `${API_URL}/api/posti-liberi/camere-disponibili?current_room_id=${currentRoomId}`
            : `${API_URL}/api/posti-liberi/camere-disponibili`;
          const response = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setCamereDisponibili(response.data.camere || []);
        } catch (error) {
          console.error("Error fetching camere:", error);
        } finally {
          setLoadingCamere(false);
        }
      };
      fetchCamere();
    }
  }, [isEditing, token, cartella?.room_id]);

  useEffect(() => {
    const cc = cartella?.contratto_cartaceo;
    setContrattoCartaceoAttestato(!!cc?.attestato);
    setContrattoCartaceoDataFirma(cc?.data_firma || "");
  }, [cartella?.contratto_cartaceo]);

  useEffect(() => {
    const pai = cartella?.pai_attivo;
    const isCartaceo = isPaiCartaceo(pai);
    setPaiCartaceoAttestato(isCartaceo);
    setPaiCartaceoDataRedazione(isCartaceo ? (pai?.data_redazione || "") : "");
  }, [cartella?.pai_attivo]);

  const handleSaveContrattoCartaceo = async () => {
    if (contrattoCartaceoAttestato && !contrattoCartaceoDataFirma) {
      toast.error("Inserire la data di firma del contratto cartaceo");
      return;
    }
    setSavingContrattoCartaceo(true);
    try {
      const response = await axios.put(
        `${API_URL}/api/fascicoli-assistenziali/${id}/contratto-cartaceo`,
        {
          attestato: contrattoCartaceoAttestato,
          data_firma: contrattoCartaceoAttestato ? contrattoCartaceoDataFirma : null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setCartella((prev) =>
          prev ? { ...prev, contratto_cartaceo: response.data.contratto_cartaceo } : prev
        );
        toast.success(response.data.message || "Attestazione salvata");
      }
    } catch (error) {
      console.error("Errore attestazione contratto cartaceo:", error);
      toast.error(error.response?.data?.detail || "Errore nel salvataggio");
    } finally {
      setSavingContrattoCartaceo(false);
    }
  };

  const handleSavePaiCartaceo = async () => {
    if (paiCartaceoAttestato && !paiCartaceoDataRedazione) {
      toast.error("Inserire la data di redazione del PAI cartaceo");
      return;
    }
    setSavingPaiCartaceo(true);
    try {
      const response = await axios.put(
        `${API_URL}/api/fascicoli-assistenziali/${id}/pai-cartaceo`,
        {
          attestato: paiCartaceoAttestato,
          data_redazione: paiCartaceoAttestato ? paiCartaceoDataRedazione : null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setCartella((prev) =>
          prev
            ? {
                ...prev,
                pai_attivo: response.data.pai_attivo || null,
                pai_upload_usato: !!response.data.pai_attivo,
                pai_scadenza: response.data.pai_attivo?.data_scadenza || null,
              }
            : prev
        );
        toast.success(response.data.message || "Attestazione PAI salvata");
      }
    } catch (error) {
      console.error("Errore attestazione PAI cartaceo:", error);
      toast.error(error.response?.data?.detail || "Errore nel salvataggio");
    } finally {
      setSavingPaiCartaceo(false);
    }
  };

  // Funzione per caricare documenti
  const handleUploadDocument = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    
    // Validazione lato client
    const maxSize = 50 * 1024 * 1024; // 50 MB
    if (file.size > maxSize) {
      toast.error("File troppo grande. Massimo 50 MB");
      return;
    }
    
    const allowedTypes = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.doc', '.docx', '.xls', '.xlsx'];
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedTypes.includes(ext)) {
      toast.error(`Tipo file non supportato. Formati ammessi: ${allowedTypes.join(', ')}`);
      return;
    }
    
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('descrizione', uploadDescrizione);
    
    try {
      const response = await axios.post(
        `${API_URL}/api/upload/cartella/${id}/${uploadSezione}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      if (response.data.success) {
        toast.success(uploadSezione === 'contratto_firmato' ? "Contratto firmato caricato con successo" : "Documento caricato con successo");
        setDocumenti(prev => [...prev, response.data.document]);
        setShowUploadModal(false);
        setUploadDescrizione("");
        setUploadSezione("generale");
      }
    } catch (error) {
      console.error("Errore upload:", error);
      toast.error(error.response?.data?.detail || "Errore nel caricamento");
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  // Upload file/foto per Terapie e Ausili (come piani terapeutici, senza data di scadenza)
  const handleUploadTerapieAusili = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const maxSize = 50 * 1024 * 1024; // 50 MB
    if (file.size > maxSize) {
      toast.error("File troppo grande. Massimo 50 MB");
      event.target.value = "";
      return;
    }
    const allowedTypes = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
    ];
    const ext = "." + file.name.split(".").pop().toLowerCase();
    if (!allowedTypes.includes(ext)) {
      toast.error(`Tipo file non supportato. Formati ammessi: ${allowedTypes.join(", ")}`);
      event.target.value = "";
      return;
    }
    setUploadingTerapieAusili(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("descrizione", file.name || "Terapie e Ausili");
    try {
      const response = await axios.post(
        `${API_URL}/api/upload/cartella/${id}/terapie_ausili`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        toast.success("File caricato");
        setDocumenti((prev) => [...prev, response.data.document]);
        setProposteRefreshSignal((n) => n + 1);
      }
    } catch (error) {
      console.error("Errore upload Terapie e Ausili:", error);
      toast.error(error.response?.data?.detail || "Errore nel caricamento");
    } finally {
      setUploadingTerapieAusili(false);
      event.target.value = "";
    }
  };

  const handleUploadRichiestaRsa = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const maxSize = 50 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("File troppo grande. Massimo 50 MB");
      event.target.value = "";
      return;
    }
    const allowedTypes = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
    ];
    const ext = "." + file.name.split(".").pop().toLowerCase();
    if (!allowedTypes.includes(ext)) {
      toast.error(`Tipo file non supportato. Formati ammessi: ${allowedTypes.join(", ")}`);
      event.target.value = "";
      return;
    }
    setUploadingRichiestaRsa(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("descrizione", file.name || "Richiesta RSA");
    try {
      const response = await axios.post(
        `${API_URL}/api/upload/cartella/${id}/richiesta_rsa`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        toast.success("Documento caricato");
        setDocumenti((prev) => [...prev, response.data.document]);
      }
    } catch (error) {
      console.error("Errore upload Richiesta RSA:", error);
      toast.error(error.response?.data?.detail || "Errore nel caricamento");
    } finally {
      setUploadingRichiestaRsa(false);
      event.target.value = "";
    }
  };

  // Upload file/foto per Piani terapeutici (inline, senza modal e senza selezione sezione)
  const handleUploadPianoTerapeutico = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!scadenzaPianoTerapeutico) {
      toast.error("Inserisci la data di scadenza del piano terapeutico");
      event.target.value = '';
      return;
    }
    const maxSize = 50 * 1024 * 1024; // 50 MB
    if (file.size > maxSize) {
      toast.error("File troppo grande. Massimo 50 MB");
      event.target.value = '';
      return;
    }
    const allowedTypes = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.doc', '.docx', '.xls', '.xlsx'];
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!allowedTypes.includes(ext)) {
      toast.error(`Tipo file non supportato. Formati ammessi: ${allowedTypes.join(', ')}`);
      event.target.value = '';
      return;
    }
    setUploadingPianiTerapeutici(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('descrizione', file.name || 'Piano terapeutico');
    formData.append('scadenza', scadenzaPianoTerapeutico);
    try {
      const response = await axios.post(
        `${API_URL}/api/upload/cartella/${id}/piani_terapeutici`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.data.success) {
        toast.success("File caricato");
        setDocumenti(prev => [...prev, response.data.document]);
        setProposteRefreshSignal((n) => n + 1);
      }
    } catch (error) {
      console.error("Errore upload piano terapeutico:", error);
      toast.error(error.response?.data?.detail || "Errore nel caricamento");
    } finally {
      setUploadingPianiTerapeutici(false);
      event.target.value = '';
    }
  };

  // Helper: giorni mancanti alla scadenza (null se non presente)
  const giorniAllaScadenza = (scadenzaStr) => {
    if (!scadenzaStr) return null;
    try {
      const scadenza = new Date(scadenzaStr);
      const oggi = new Date();
      oggi.setHours(0, 0, 0, 0);
      scadenza.setHours(0, 0, 0, 0);
      return Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));
    } catch (_) { return null; }
  };
  
  // Funzione per eliminare documento
  const handleDeleteDocument = async (fileId) => {
    if (!confirm("Sei sicuro di voler eliminare questo documento?")) return;
    
    try {
      await axios.delete(
        `${API_URL}/api/upload/cartella/${id}/${fileId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setDocumenti(prev => prev.filter(d => d.file_id !== fileId));
      toast.success("Documento eliminato");
    } catch (error) {
      console.error("Errore eliminazione:", error);
      toast.error("Errore nell'eliminazione del documento");
    }
  };
  
  // Funzione per visualizzare documento in popup
  const handleViewDocument = (doc) => {
    setSelectedDocument(doc);
    setShowDocumentModal(true);
  };
  
  // Funzione per scaricare documento
  const handleDownloadDocument = async (doc) => {
    try {
      const response = await axios.get(
        `${API_URL}/api/upload/cartella/${id}/${doc.sezione}/${doc.file_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );
      
      // Crea un URL blob e scarica
      const blob = new Blob([response.data], { type: doc.file_type || 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      
      // Scarica il file
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.file_name || `documento${doc.file_ext}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Pulisci l'URL blob dopo un po'
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Errore download:", error);
      toast.error("Errore nel download del documento");
    }
  };

  const handleDownloadComunicazioneAllegato = async (allegato) => {
    if (!allegato?.file_id || !allegato?.sezione) {
      toast.error("Allegato non disponibile");
      return;
    }
    try {
      const response = await axios.get(
        `${API_URL}/api/upload/cartella/${id}/${allegato.sezione}/${allegato.file_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = allegato.nome || "allegato";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Errore download allegato comunicazione:", error);
      toast.error("Errore nel download dell'allegato");
    }
  };
  
  // Funzione per stampare documento dal popup
  const handlePrintDocument = () => {
    if (!selectedDocument) return;
    
    const docUrl = appendAuthToUrl(
      `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
      token
    );
    const printWindow = window.open(docUrl, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        setTimeout(() => printWindow.print(), 500);
      };
    }
  };
  
  // Funzioni per PAI
  const handlePaiFieldChange = (campo, valore) => {
    setPaiData(prev => ({
      ...prev,
      [campo]: valore
    }));
  };
  
  const handlePaiCheckboxChange = (campo, valore, checked) => {
    setPaiData(prev => {
      const currentArray = prev[campo] || [];
      if (checked) {
        return { ...prev, [campo]: [...currentArray, valore] };
      } else {
        return { ...prev, [campo]: currentArray.filter(v => v !== valore) };
      }
    });
  };
  
  const handleSavePai = async () => {
    setSavingPai(true);
    try {
      // Calcola data scadenza se non specificata (6 mesi da redazione)
      let dataScadenza = paiData.data_scadenza;
      if (!dataScadenza && paiData.data_redazione) {
        const redazione = new Date(paiData.data_redazione);
        redazione.setMonth(redazione.getMonth() + 6);
        dataScadenza = redazione.toISOString().split('T')[0];
      }

      const firmePayload = paiFirmeStepRef.current?.collectFirme() || {};

      const paiPayload = {
        ...paiData,
        ...firmePayload,
        data_scadenza: dataScadenza,
        stato: "Attivo",
        ospite_id: id,
        ospite_nome: `${cartella?.anagrafica?.nome || ''} ${cartella?.anagrafica?.cognome || ''}`
      };
      
      await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/pai`,
        paiPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      toast.success("PAI salvato con successo!");
      setShowPaiModal(false);
      setPaiStep(0);
      setPaiFirmeState(createEmptyPaiFirmeState());
      
      // Ricarica cartella per aggiornare il PAI
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
      
    } catch (error) {
      console.error("Errore salvataggio PAI:", error);
      toast.error(error.response?.data?.detail || "Errore nel salvataggio del PAI");
    } finally {
      setSavingPai(false);
    }
  };
  
  // Funzione per visualizzare PAI salvato
  const handleViewPai = (pai) => {
    setViewingPai(pai);
    setShowPaiViewModal(true);
  };
  
  const openPaiWizard = () => {
    setPaiStep(0);
    setPaiFirmeState(createEmptyPaiFirmeState());
    setShowPaiModal(true);
  };

  // Funzione per stampare PAI salvato (con tutti i dati dal database) - usa PDF su Android, HTML su desktop
  const handlePrintSavedPai = async (pai) => {
    const htmlUrl = `${API_URL}/api/pai/${id}/print`;
    const pdfUrl = `${API_URL}/api/pai/${id}/print.pdf`;

    if (!token) {
      toast.error("Utente non loggato. Effettua il login per stampare il PAI.");
      return;
    }

    try {
      // Su Android/tablet apri direttamente il PDF (l'app intercetta gli URL .pdf)
      if (isMobileDevice() && navigator.userAgent.includes('Android')) {
        const authenticatedPdfUrl = appendAuthToUrl(pdfUrl, token);
        const link = document.createElement('a');
        link.href = authenticatedPdfUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("PAI aperto in PDF!", { duration: 5000 });
      } else {
        const response = await fetch(htmlUrl, {
          headers: buildAuthFetchHeaders(token),
        });
        if (!response.ok) {
          let detail = 'Errore nel caricamento del PAI';
          try {
            const body = await response.json();
            if (body?.detail) detail = body.detail;
          } catch (_) { /* risposta non JSON */ }
          throw new Error(detail);
        }
        const htmlContent = await response.text();
        const printWindow = window.open('', '_blank');
        if (printWindow) {
          printWindow.document.write(htmlContent);
          printWindow.document.close();
          printWindow.addEventListener('load', () => {
            printWindow.print();
          });
        }
      }
    } catch (error) {
      console.error('Errore stampa PAI:', error);
      toast.error(error.message || "Errore durante la stampa del PAI");
    }
  };
  
  const handleOpenPaiFile = () => {
    const url = getPaiFileUrl(id, token);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleSavePaiUpload = async () => {
    if (!paiUploadFile) {
      toast.error("Seleziona un file da caricare");
      return;
    }
    if (!paiUploadData.data_redazione) {
      toast.error("La data di redazione è obbligatoria");
      return;
    }
    setSavingPaiUpload(true);
    try {
      const formData = new FormData();
      formData.append("file", paiUploadFile);
      formData.append("data_redazione", paiUploadData.data_redazione);
      if (paiUploadData.data_scadenza) {
        formData.append("data_scadenza", paiUploadData.data_scadenza);
      }
      if (paiUploadData.note_generali) {
        formData.append("note_generali", paiUploadData.note_generali);
      }
      await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/pai/upload`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      toast.success("PAI caricato con successo!");
      setShowPaiUploadModal(false);
      setPaiUploadFile(null);
      setPaiUploadData({ data_redazione: new Date().toISOString().split('T')[0], data_scadenza: '', note_generali: '' });
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
    } catch (error) {
      console.error("Errore upload PAI:", error);
      toast.error(error.response?.data?.detail || "Errore nel caricamento del PAI");
    } finally {
      setSavingPaiUpload(false);
    }
  };

  const handlePrintPai = async () => {
    const url = `${API_URL}/api/pai/${id}/print`;

    if (!token) {
      toast.error("Utente non loggato. Effettua il login per stampare il PAI.");
      return;
    }

    try {
      if (isMobileDevice() && navigator.userAgent.includes('Android')) {
        const authenticatedUrl = appendAuthToUrl(url, token);
        const link = document.createElement('a');
        link.href = authenticatedUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("PAI aperto per stampa! Usa la funzione di stampa del browser", { duration: 5000 });
      } else {
        const response = await fetch(url, {
          headers: buildAuthFetchHeaders(token),
        });

        if (!response.ok) {
          let detail = 'Errore nel caricamento del PAI';
          try {
            const body = await response.json();
            if (body?.detail) detail = body.detail;
          } catch (_) { /* risposta non JSON */ }
          throw new Error(detail);
        }

        const htmlContent = await response.text();
        const printWindow = window.open('', '_blank');
        if (printWindow) {
          printWindow.document.write(htmlContent);
          printWindow.document.close();
          printWindow.addEventListener('load', () => {
            printWindow.print();
          });
        }
      }
    } catch (error) {
      console.error('Errore stampa PAI:', error);
      toast.error(error.message || "Errore durante la stampa del PAI");
    }
  };
  const handleFieldChange = (sezione, campo, valore) => {
    const d = editDraftRef.current;
    if (!d) return;
    if (!d[sezione]) d[sezione] = {};
    d[sezione][campo] = valore;
  };

  const handleApplicaAnagraficaDaIdentita = ({ fields, documents }) => {
    if (!fields) return;
    if (!editDraftRef.current) beginEditing();
    Object.entries(fields).forEach(([campo, valore]) => {
      if (valore != null && String(valore).trim() !== "") {
        handleFieldChange("anagrafica", campo, valore);
      }
    });
    if (fields.provincia) {
      setEditSedeProvincia(String(fields.provincia).toUpperCase().slice(0, 2));
    }
    // Nati all'estero: allinea comune/provincia al tracciato Alloggiati (EE / 000000000)
    const a = editDraftRef.current?.anagrafica || {};
    const nascitaEstero = campiNascitaPerStato(
      fields.stato_nascita ?? a.stato_nascita,
      fields.stato_nascita_label ?? a.stato_nascita_label
    );
    if (nascitaEstero) {
      Object.entries(nascitaEstero).forEach(([campo, valore]) => {
        handleFieldChange("anagrafica", campo, valore);
      });
    }
    if (documents?.length) {
      setDocumenti((prev) => {
        const ids = new Set(prev.map((d) => d.file_id));
        const nuovi = documents.filter((d) => d.file_id && !ids.has(d.file_id));
        return nuovi.length ? [...prev, ...nuovi] : prev;
      });
    }
    // Allinea cartella.anagrafica al draft per remount autocomplete / campi controllati
    setCartella((prev) => ({
      ...prev,
      anagrafica: {
        ...(prev?.anagrafica || {}),
        ...(editDraftRef.current?.anagrafica || {}),
      },
    }));
    setEditSessionKey((k) => k + 1);
    toast.success("Dati applicati in modifica — verifica e salva le modifiche");
  };

  const handleApplicaPatologie = ({ fields }) => {
    if (!fields) return;
    if (!isEditing) beginEditing();

    if (editDraftRef.current) {
      if (!editDraftRef.current.sanitaria) editDraftRef.current.sanitaria = {};
      const san = editDraftRef.current.sanitaria;
      if (fields.diagnosi_principale) san.diagnosi_principale = fields.diagnosi_principale;
      if (fields.diagnosi_secondarie?.length) san.diagnosi_secondarie = fields.diagnosi_secondarie;
      if (fields.patologie_croniche?.length) san.patologie_croniche = fields.patologie_croniche;
      if (fields.allergie?.length) san.allergie = fields.allergie;
      if (fields.note_sanitarie) san.note_sanitarie = fields.note_sanitarie;
    }

    // Aggiorna cartella.sanitaria affinché i defaultValue degli input riflettano i valori AI al remount
    setCartella((prev) => ({
      ...prev,
      sanitaria: {
        ...(prev?.sanitaria || {}),
        ...(fields.diagnosi_principale ? { diagnosi_principale: fields.diagnosi_principale } : {}),
        ...(fields.diagnosi_secondarie?.length ? { diagnosi_secondarie: fields.diagnosi_secondarie } : {}),
        ...(fields.patologie_croniche?.length ? { patologie_croniche: fields.patologie_croniche } : {}),
        ...(fields.allergie?.length ? { allergie: fields.allergie } : {}),
        ...(fields.note_sanitarie ? { note_sanitarie: fields.note_sanitarie } : {}),
      },
    }));

    setEditSessionKey((k) => k + 1);
    toast.success("Dati sanitari applicati — verifica i campi e salva le modifiche");
  };

  const handleDoctorSelect = (doctor) => {
    const mapped = applyDoctorToSanitaria(doctor);
    Object.entries(mapped).forEach(([field, value]) => {
      handleFieldChange("sanitaria", field, value);
    });
    setEditSessionKey((k) => k + 1);
  };

  const handleDoctorClear = () => {
    handleFieldChange("sanitaria", "doctor_id", null);
    handleFieldChange("sanitaria", "medico_curante", "");
    setEditSessionKey((k) => k + 1);
  };

  const handleRoomIdDraftChange = (v) => {
    if (editDraftRef.current) editDraftRef.current._room_id = v;
  };

  const beginEditing = () => {
    if (!cartella) return;
    editDraftRef.current = {
      anagrafica: JSON.parse(JSON.stringify(cartella.anagrafica || {})),
      amministrativa: JSON.parse(JSON.stringify(cartella.amministrativa || {})),
      sociale: JSON.parse(JSON.stringify(cartella.sociale || {})),
      sanitaria: JSON.parse(JSON.stringify(cartella.sanitaria || {})),
      diurno: JSON.parse(JSON.stringify(cartella.diurno || {})),
      _room_id: cartella.room_id ? String(cartella.room_id) : "none",
    };
    // Popola i campi strutturati sede dal testo libero se mancano
    const anag = editDraftRef.current.anagrafica;
    if (!anag.indirizzo && !anag.cap && !anag.citta && !anag.provincia && anag.indirizzo_residenza) {
      const p = parseAddrResidenza(anag.indirizzo_residenza);
      anag.indirizzo = p.indirizzo;
      anag.cap = p.cap;
      anag.citta = p.citta;
      anag.provincia = p.provincia;
    }
    setEditSedeProvincia(anag.provincia || "");
    setEditDepositoAbilitato(isDepositoCauzionaleAbilitato(editDraftRef.current.amministrativa));
    setEditSessionKey((k) => k + 1);
    setContattiListRevision((n) => n + 1);
    setEditAusiliList(
      (cartella.sanitaria?.ausili_utilizzati || []).filter((a) => String(a ?? "").trim())
    );
    setIsEditing(true);
  };

  const beginEditingRef = useRef(beginEditing);
  beginEditingRef.current = beginEditing;

  useEffect(() => {
    if (loading || !cartella) return;
    const sp = new URLSearchParams(location.search);
    if (sp.get("edit") !== "1") return;
    if (autoEditFromQueryAppliedRef.current) return;
    autoEditFromQueryAppliedRef.current = true;

    const nextSearch = new URLSearchParams(location.search);
    nextSearch.delete("edit");
    const qs = nextSearch.toString();
    const stripEditFromUrl = () =>
      navigate({ pathname: `/fascicoli-assistenziali/${id}`, search: qs ? `?${qs}` : "" }, { replace: true });

    if (!hasPermission("fascicolo:update")) {
      toast.error("Non hai permesso di modificare il fascicolo");
      stripEditFromUrl();
      return;
    }

    beginEditingRef.current();
    stripEditFromUrl();
  }, [loading, cartella, location.search, id, navigate, hasPermission]);

  const canDatiContabili = hasPermission("contabile:read");
  const canFatturazione = canAccessFatturazioneElettronica(user) && canDatiContabili;
  const canCentroDiurno = canAccessCentroDiurno(user);

  useEffect(() => {
    if (activeTab === "family" && !canFamily) setActiveTab("anagrafica");
  }, [activeTab, canFamily]);

  useEffect(() => {
    if (activeTab !== "amministrativa") return;
    const sp = new URLSearchParams(location.search);
    const section = sp.get("section");
    if (
      section &&
      !canFatturazione &&
      ["destinatario", "fatturazione", "storico-fatture"].includes(section)
    ) {
      setAmministrativaSection(prev => (prev === "dati" ? prev : "dati"));
      const next = new URLSearchParams(location.search);
      next.set("tab", "amministrativa");
      next.delete("section");
      const qs = next.toString();
      navigate({ pathname: location.pathname, search: qs ? `?${qs}` : "" }, { replace: true });
      return;
    }
    if (section && AMMINISTRATIVA_SECTIONS.has(section)) {
      setAmministrativaSection(prev => (prev === section ? prev : section));
    }
  }, [location.search, activeTab, canFatturazione, location.pathname, navigate]);

  const handleAmministrativaSectionChange = (value) => {
    if (value === amministrativaSection) return;
    setAmministrativaSection(value);
  };

  const amminSubTabClass =
    "gap-2 rounded-none border-b-2 border-transparent px-3 py-2.5 text-sm whitespace-nowrap data-[state=active]:border-amber-600 data-[state=active]:text-amber-900 data-[state=active]:shadow-none";

  const mainTabTriggerClass =
    "flex w-full min-w-0 items-center justify-center gap-1.5 rounded-2xl px-1.5 py-2.5 text-xs font-medium text-slate-500 transition-colors hover:bg-white/80 hover:text-slate-700 sm:px-2 sm:text-sm lg:px-3 data-[state=active]:bg-white data-[state=active]:text-emerald-600 data-[state=active]:shadow-sm";

  const hideEditForAmminSection =
    activeTab === "amministrativa" &&
    !["dati", "destinatario"].includes(amministrativaSection);

  /** Calcolo codice fiscale da anagrafica (Italia: comune+provincia; estero: stato + EE). */
  const handleCalcolaCodiceFiscale = () => {
    const a = editDraftRef.current?.anagrafica || {};
    const nome = (a.nome || "").trim();
    const cognome = (a.cognome || "").trim();
    const sesso = a.sesso;
    const dataNascita = a.data_nascita;
    if (!nome || !cognome || !sesso || !dataNascita) {
      toast.error("Compila nome, cognome, sesso e data di nascita.");
      return;
    }
    const parts = String(dataNascita).split("-");
    if (parts.length !== 3) {
      toast.error("Data di nascita non valida.");
      return;
    }
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);
    if (!year || !month || !day) {
      toast.error("Data di nascita non valida.");
      return;
    }
    const statoLabel = (a.stato_nascita_label || "ITALIA").trim().toUpperCase();
    const isItaly = statoLabel === "ITALIA" || statoLabel === "";
    let computeParams;
    if (isItaly) {
      const comuneLabel = (a.comune_nascita_label || a.luogo_nascita || "").trim();
      const prov = (a.comune_nascita_provincia || "").trim();
      if (!comuneLabel || !prov) {
        toast.error(
          "Per il calcolo in Italia seleziona il comune di nascita dall'elenco (sezione Dati per Alloggiati Web), così da registrare anche la provincia."
        );
        return;
      }
      computeParams = {
        name: nome,
        surname: cognome,
        gender: sesso === "F" ? "F" : "M",
        day,
        month,
        year,
        birthplace: comuneLabel,
        birthplaceProvincia: prov,
      };
    } else {
      const stato = (a.stato_nascita_label || "").trim();
      if (!stato) {
        toast.error("Indica lo stato di nascita per il calcolo per nati all'estero.");
        return;
      }
      computeParams = {
        name: nome,
        surname: cognome,
        gender: sesso === "F" ? "F" : "M",
        day,
        month,
        year,
        birthplace: stato,
        birthplaceProvincia: "EE",
      };
    }
    try {
      const cf = CodiceFiscale.compute(computeParams);
      handleFieldChange("anagrafica", "codice_fiscale", cf);
      if (codiceFiscaleInputRef.current) codiceFiscaleInputRef.current.value = cf;
      toast.success("Codice fiscale calcolato");
    } catch (e) {
      toast.error(
        e?.message || "Impossibile calcolare il codice fiscale. Verifica comune, provincia o stato di nascita."
      );
    }
  };

  const handleFotoOspiteChange = async (e) => {
    const file = e.target.files?.[0];
    if (e.target) e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Seleziona un file immagine (JPEG, PNG, …)");
      return;
    }
    if (!hasPermission("fascicolo:update")) {
      toast.error("Non hai permesso di modificare il fascicolo");
      return;
    }
    setUploadingFotoOspite(true);
    try {
      const dataUrl = await resizeImageFileToJpegDataUrl(file, 720, 0.85);
      if (dataUrl.length > 2_500_000) {
        toast.error("Immagine troppo grande; prova con un file più piccolo.");
        return;
      }
      await axios.put(
        `${API_URL}/api/fascicoli-assistenziali/${id}`,
        { sezione: "anagrafica", dati: { foto_url: dataUrl } },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCartella((prev) =>
        prev ? { ...prev, anagrafica: { ...prev.anagrafica, foto_url: dataUrl } } : prev
      );
      if (editDraftRef.current?.anagrafica) {
        editDraftRef.current.anagrafica.foto_url = dataUrl;
      }
      toast.success("Foto ospite aggiornata");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.detail || "Errore nel caricamento della foto");
    } finally {
      setUploadingFotoOspite(false);
    }
  };

  const struttureDestinazione = (strutture || []).filter(
    (s) => s.id !== activeStruttura?.id
  );
  const canTrasferireOspite =
    hasPermission("fascicolo:transfer") &&
    struttureDestinazione.length > 0 &&
    !cartella?.archiviata;

  const openTrasferisciDialog = () => {
    setTrasferisciDestId(struttureDestinazione[0]?.id || "");
    setTrasferisciNote("");
    setShowTrasferisciDialog(true);
  };

  const handleTrasferisciOspite = async () => {
    if (!trasferisciDestId) {
      toast.error("Seleziona la struttura di destinazione");
      return;
    }
    setTrasferendo(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/trasferisci`,
        {
          struttura_destinazione_id: trasferisciDestId,
          note: trasferisciNote.trim() || undefined,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const destNome =
        response.data?.destinazione_nome ||
        struttureDestinazione.find((s) => s.id === trasferisciDestId)?.name ||
        "la nuova struttura";
      const destId = response.data?.destinazione_id || trasferisciDestId;
      setShowTrasferisciDialog(false);
      toast.success(response.data?.message || `Ospite trasferito a ${destNome}`);
      toast.info(
        `Ricorda di registrare e inviare l'ospite ad Alloggiati Web nella struttura "${destNome}".`,
        { duration: 8000 }
      );
      if (destId && destId !== activeStruttura?.id) {
        try {
          await switchStruttura(destId);
        } catch (switchErr) {
          console.error(switchErr);
          toast.warning(
            `Ospite trasferito. Seleziona "${destNome}" dallo switcher in alto per vederlo.`
          );
        }
      }
      navigate("/fascicoli-assistenziali");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.detail || "Errore durante il trasferimento dell'ospite");
    } finally {
      setTrasferendo(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const draft = editDraftRef.current;
      if (!draft) {
        toast.error("Sessione di modifica non attiva");
        setSaving(false);
        return;
      }

      if (canDatiContabili) {
        if (isDepositoCauzionaleAbilitato(draft.amministrativa || {})) {
          const dep = importoDepositoCauzionale(draft.amministrativa);
          if (dep == null) {
            toast.error("Inserisci l'importo del deposito cauzionale");
            setSaving(false);
            return;
          }
          draft.amministrativa.deposito_cauzionale_abilitato = true;
          draft.amministrativa.deposito_cauzionale = dep;
        } else if (draft.amministrativa) {
          draft.amministrativa.deposito_cauzionale_abilitato = false;
          draft.amministrativa.deposito_cauzionale = null;
        }
      } else if (draft.amministrativa) {
        // Senza contabile:read non inviare/alterare campi economici
        const CONTABILE_KEYS = [
          "retta_mensile",
          "tariffa_giornaliera",
          "tariffa_settimanale",
          "deposito_cauzionale",
          "deposito_cauzionale_abilitato",
          "ente_pagante",
          "fatturazione_retta",
          "destinatario_fatturazione",
        ];
        for (const k of CONTABILE_KEYS) {
          delete draft.amministrativa[k];
        }
      }

      // Salva tutte le sezioni modificate
      const sezioni = ['anagrafica', 'amministrativa', 'diurno', 'sociale', 'sanitaria'];
      
      // Determina se la camera è cambiata
      const newRoomId = draft._room_id;
      const roomChanged =
        newRoomId !== undefined &&
        (newRoomId === "none" ? "" : newRoomId) !== String(cartella?.room_id || "");
      
      for (const sezione of sezioni) {
        const dati =
          sezione === "anagrafica"
            ? (() => {
                const d = JSON.parse(JSON.stringify(draft.anagrafica));
                d.indirizzo_residenza = formatAddrResidenza(d.indirizzo, d.cap, d.citta, d.provincia);
                return d;
              })()
            : sezione === "sanitaria"
            ? (() => {
                const { terapie_in_corso: _terapieOmit, ...sanitariaRest } = draft.sanitaria || {};
                return {
                  ...sanitariaRest,
                  diagnosi_principale: String(
                    diagnosiPrincipaleRef.current?.value ??
                      cartella?.sanitaria?.diagnosi_principale ??
                      ""
                  ).trim(),
                  diagnosi_secondarie: normalizeCommaSeparatedForSave(
                    diagnosiSecondarieRef.current?.value ??
                      (cartella?.sanitaria?.diagnosi_secondarie || []).join(", ")
                  ),
                  patologie_croniche: normalizeCommaSeparatedForSave(
                    patologieCronicheRef.current?.value ??
                      (cartella?.sanitaria?.patologie_croniche || []).join(", ")
                  ),
                  allergie: normalizeCommaSeparatedForSave(
                    allergieSanitariaRef.current?.value
                  ),
                  ausili_utilizzati: editAusiliList
                    .map((a) => String(a ?? "").trim())
                    .filter(Boolean),
                  piani_terapeutici_testo:
                    pianiTerapeuticiTestoRef.current?.value ??
                    draft.sanitaria?.piani_terapeutici_testo ??
                    "",
                  note_sanitarie:
                    noteSanitarieRef.current?.value ??
                    draft.sanitaria?.note_sanitarie ??
                    "",
                  medico_curante: String(draft.sanitaria?.medico_curante ?? "").trim(),
                  doctor_id: draft.sanitaria?.doctor_id || null,
                  medico_curante_telefono: String(
                    draft.sanitaria?.medico_curante_telefono ?? ""
                  ).trim(),
                  medico_curante_email_personale: String(
                    draft.sanitaria?.medico_curante_email_personale ?? ""
                  ).trim(),
                  medico_curante_email_blisteraggio: String(
                    draft.sanitaria?.medico_curante_email_blisteraggio ?? ""
                  ).trim(),
                  medico_curante_indirizzo_studio: String(
                    draft.sanitaria?.medico_curante_indirizzo_studio ?? ""
                  ).trim(),
                  asl_riferimento: String(draft.sanitaria?.asl_riferimento ?? "").trim(),
                  richiesta_rsa: !!draft.sanitaria?.richiesta_rsa,
                };
              })()
            : JSON.parse(JSON.stringify(draft[sezione]));
        const payload = {
          sezione,
          dati,
        };
        // Invia room_id nella prima chiamata se la camera è cambiata
        if (roomChanged && sezione === sezioni[0]) {
          payload.room_id = newRoomId === "none" ? "" : newRoomId;
        }
        await axios.put(`${API_URL}/api/fascicoli-assistenziali/${id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      
      // Ricarica i dati
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
      editDraftRef.current = null;

      toast.success("Modifiche salvate con successo!");
      setIsEditing(false);
    } catch (error) {
      console.error("Errore salvataggio:", error);
      const detail = error.response?.data?.detail;
      toast.error(detail || "Errore nel salvataggio delle modifiche");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    editDraftRef.current = null;
    setIsEditing(false);
  };

  // Funzione per creare scheda Alloggiati Web
  const handleCreaAlloggiatiWeb = () => {
    const ana = cartella?.anagrafica || {};
    const statoLabel = etichettaStatoAlloggiati(ana.stato_nascita, ana.stato_nascita_label);
    const statoCodNorm = normalizzaCodiceStatoAlloggiati(ana.stato_nascita, ana.stato_nascita_label);
    const natoEstero = isNatoAllEstero(statoCodNorm || ana.stato_nascita, statoLabel);
    const statoCod = statoCodNorm || (natoEstero ? "" : CODICE_STATO_ITALIA);

    // Prepara i dati da passare ad Alloggiati Web
    const alloggiatiData = {
      fascicolo_id: id,
      cognome: ana.cognome?.toUpperCase() || "",
      nome: ana.nome?.toUpperCase() || "",
      sesso: ana.sesso === "M" ? "1" : "2",
      dataNascita: ana.data_nascita || "",
      comuneNascita: natoEstero ? "000000000" : (ana.comune_nascita || ""),
      comuneNascitaLabel: natoEstero
        ? (statoLabel || ana.comune_nascita_label || ana.luogo_nascita || "")
        : (ana.comune_nascita_label || ana.luogo_nascita || ""),
      provinciaNascita: natoEstero ? "EE" : (ana.comune_nascita_provincia || ""),
      statoNascita: statoCod,
      statoNascitaLabel: statoLabel || (natoEstero ? "" : "ITALIA"),
      cittadinanza: normalizzaCodiceStatoAlloggiati(ana.cittadinanza, ana.cittadinanza_label),
      cittadinanzaLabel: etichettaStatoAlloggiati(ana.cittadinanza, ana.cittadinanza_label),
      tipoDocumento: ana.tipo_documento || "IDENT",
      tipoDocumentoLabel: ana.tipo_documento_label || "CARTA DI IDENTITA'",
      numeroDocumento: ana.numero_documento || "",
      luogoRilascioDocumento: ana.luogo_rilascio_documento || "",
    };
    
    // Salva i dati nel localStorage per passarli ad Alloggiati Web
    localStorage.setItem('affidya_alloggiati_prefill', JSON.stringify(alloggiatiData));
    
    toast.success("Dati pronti! Verrai reindirizzato ad Alloggiati Web");
    
    // Naviga ad Alloggiati Web
    setTimeout(() => {
      navigate('/alloggiati-web?prefill=true');
    }, 500);
  };

  // Funzioni per gestire i contatti familiari
  const handleAddContatto = () => {
    const d = editDraftRef.current;
    if (!d?.anagrafica) return;
    if (!Array.isArray(d.anagrafica.contatti_familiari)) {
      d.anagrafica.contatti_familiari = [];
    }
    d.anagrafica.contatti_familiari.push({
      nome: "",
      relazione: "",
      telefono: "",
      email: "",
    });
    setContattiListRevision((n) => n + 1);
  };

  const handleUpdateContatto = (index, campo, valore) => {
    const d = editDraftRef.current;
    const contatti = d?.anagrafica?.contatti_familiari;
    if (!contatti || !contatti[index]) return;
    contatti[index][campo] = valore;
  };

  const handleRemoveContatto = (index) => {
    const d = editDraftRef.current;
    const contatti = d?.anagrafica?.contatti_familiari;
    if (!contatti) return;
    contatti.splice(index, 1);
    setContattiListRevision((n) => n + 1);
  };

  const openFamiliareEmailDialog = (contatto) => {
    const nomeOspite = `${cartella?.anagrafica?.nome || ""} ${cartella?.anagrafica?.cognome || ""}`.trim() || "Ospite";
    const nomeStruttura = user?.facility_name || "Struttura";
    setSelectedFamiliareEmail(contatto);
    setFamiliareEmailSubject(`Comunicazione ${nomeStruttura} - ${nomeOspite}`);
    setFamiliareEmailText("");
  };

  const closeFamiliareEmailDialog = () => {
    if (sendingFamiliareEmail) return;
    setSelectedFamiliareEmail(null);
    setFamiliareEmailSubject("");
    setFamiliareEmailText("");
  };

  const openFamiliareEmailHistoryDialog = (contatto) => {
    setSelectedFamiliareEmailHistory(contatto);
  };

  const handleSendFamiliareEmail = async () => {
    const email = selectedFamiliareEmail?.email?.trim();
    const subject = familiareEmailSubject.trim();
    const message = familiareEmailText.trim();
    if (!email) {
      toast.error("Contatto senza email");
      return;
    }
    if (!subject) {
      toast.error("Inserisci l'oggetto della mail");
      return;
    }
    if (!message) {
      toast.error("Inserisci il testo della mail");
      return;
    }

    setSendingFamiliareEmail(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/contatti-familiari/email`,
        { recipient_email: email, subject, message },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Email inviata al familiare");
      if (response.data?.log) {
        setCartella((prev) =>
          prev
            ? {
                ...prev,
                email_familiari_log: [
                  ...(prev.email_familiari_log || []),
                  response.data.log,
                ],
              }
            : prev
        );
      }
      setSelectedFamiliareEmail(null);
      setFamiliareEmailSubject("");
      setFamiliareEmailText("");
    } catch (error) {
      console.error("Errore invio email familiare:", error);
      toast.error(error.response?.data?.detail || "Errore nell'invio della mail");
    } finally {
      setSendingFamiliareEmail(false);
    }
  };

  const handleAddValutazione = async () => {
    await handleSaveValutazione();
  };

  // Funzione per visualizzare valutazione PAI
  const handleViewValutazione = (val) => {
    setViewingValutazione(val);
    setShowValutazioneViewModal(true);
  };
  
  // Funzione per aprire il modal di modifica valutazione
  const handleEditValutazione = (val) => {
    // Precompila il form con i dati della valutazione esistente
    setNuovaValutazione({
      id: val.id,
      data_valutazione: val.data_valutazione || new Date().toISOString().split('T')[0],
      area_nutrizione: val.area_nutrizione || { stato: "", osservazioni: "" },
      area_riposo: val.area_riposo || { stato: "", osservazioni: "" },
      area_igiene: val.area_igiene || { stato: "", osservazioni: "" },
      area_motoria: val.area_motoria || { stato: "", osservazioni: "" },
      area_educativa: val.area_educativa || { stato: "", osservazioni: "" },
      area_psicosociale: val.area_psicosociale || { stato: "", osservazioni: "" },
      note_generali: val.note_generali || val.note || "",
      operatori: val.operatori || { educatore: "", assistente_sociale: "", oss: "" }
    });
    setShowValutazioneModal(true);
  };
  
  // Funzione per salvare (crea o modifica) valutazione
  const handleSaveValutazione = async () => {
    try {
      // Calcola esito complessivo basato sulle aree
      const aree = [
        nuovaValutazione.area_nutrizione,
        nuovaValutazione.area_riposo,
        nuovaValutazione.area_igiene,
        nuovaValutazione.area_motoria,
        nuovaValutazione.area_educativa,
        nuovaValutazione.area_psicosociale
      ];
      
      const statiValutati = aree.filter(a => a?.stato).map(a => a.stato);
      let esitoComplessivo = "Positivo";
      if (statiValutati.includes("non_adeguato")) {
        esitoComplessivo = "Negativo";
      } else if (statiValutati.includes("parz_adeguato")) {
        esitoComplessivo = "Parziale";
      }
      
      const valutazioneCompleta = {
        ...nuovaValutazione,
        esito: esitoComplessivo,
        note: nuovaValutazione.note_generali
      };
      
      let saveResponse;
      if (nuovaValutazione.id) {
        // Modifica valutazione esistente
        saveResponse = await axios.put(`${API_URL}/api/fascicoli-assistenziali/${id}/valutazioni/${nuovaValutazione.id}`, valutazioneCompleta, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(
          saveResponse.data?.pai_scadenza_aggiornata
            ? `Valutazione PAI aggiornata! Scadenza PAI prorogata al ${new Date(saveResponse.data.pai_scadenza_aggiornata).toLocaleDateString('it-IT')}.`
            : "Valutazione PAI aggiornata!"
        );
      } else {
        // Crea nuova valutazione
        saveResponse = await axios.post(`${API_URL}/api/fascicoli-assistenziali/${id}/valutazioni`, valutazioneCompleta, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(
          saveResponse.data?.pai_scadenza_aggiornata
            ? `Valutazione PAI aggiunta! Scadenza PAI prorogata al ${new Date(saveResponse.data.pai_scadenza_aggiornata).toLocaleDateString('it-IT')}.`
            : "Valutazione PAI aggiunta!"
        );
      }
      
      setShowValutazioneModal(false);
      resetValutazioneForm();
      
      // Refresh data
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
    } catch (error) {
      toast.error("Errore nel salvataggio della valutazione");
    }
  };
  
  // Funzione per aprire dialog conferma eliminazione
  const handleDeleteValutazione = (valutazioneId) => {
    setValutazioneToDelete(valutazioneId);
    setShowDeleteConfirm(true);
  };
  
  // Funzione per confermare eliminazione
  const confirmDeleteValutazione = async () => {
    if (!valutazioneToDelete) return;
    
    try {
      await axios.delete(`${API_URL}/api/fascicoli-assistenziali/${id}/valutazioni/${valutazioneToDelete}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Valutazione eliminata!");
      
      // Refresh data
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
    } catch (error) {
      console.error("Errore eliminazione:", error);
      toast.error("Errore nell'eliminazione della valutazione");
    } finally {
      setShowDeleteConfirm(false);
      setValutazioneToDelete(null);
    }
  };
  
  // Funzione per ripristinare valutazione archiviata
  const handleRipristinaValutazione = async (valutazioneId) => {
    try {
      await axios.put(`${API_URL}/api/fascicoli-assistenziali/${id}/valutazioni/${valutazioneId}/ripristina`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Valutazione ripristinata!");
      
      // Refresh data
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
    } catch (error) {
      toast.error("Errore nel ripristino della valutazione");
    }
  };
  
  // Funzione per archiviare valutazione
  const handleArchiviaValutazione = async (valutazioneId) => {
    try {
      await axios.put(`${API_URL}/api/fascicoli-assistenziali/${id}/valutazioni/${valutazioneId}/archivia`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Valutazione archiviata!");
      
      // Refresh data
      const response = await axios.get(`${API_URL}/api/fascicoli-assistenziali/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCartella(response.data);
    } catch (error) {
      toast.error("Errore nell'archiviazione della valutazione");
    }
  };
  
  // Reset form valutazione
  const resetValutazioneForm = () => {
    setNuovaValutazione({
      data_valutazione: new Date().toISOString().split('T')[0],
      area_nutrizione: { stato: "", osservazioni: "" },
      area_riposo: { stato: "", osservazioni: "" },
      area_igiene: { stato: "", osservazioni: "" },
      area_motoria: { stato: "", osservazioni: "" },
      area_educativa: { stato: "", osservazioni: "" },
      area_psicosociale: { stato: "", osservazioni: "" },
      note_generali: "",
      operatori: { educatore: "", assistente_sociale: "", oss: "" }
    });
  };
  
  // Funzione per stampare valutazione PAI
  const handlePrintValutazione = (val) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      toast.error("Popup bloccato. Abilita i popup per stampare.");
      return;
    }
    
    const anagrafica = cartella?.anagrafica || {};
    const getStatoLabel = (stato) => {
      if (stato === 'adeguato') return 'Adeguato';
      if (stato === 'parz_adeguato') return 'Parz. Adeguato';
      if (stato === 'non_adeguato') return 'Non Adeguato';
      return stato || '-';
    };
    const getStatoColor = (stato) => {
      if (stato === 'adeguato') return '#10b981';
      if (stato === 'parz_adeguato') return '#f59e0b';
      if (stato === 'non_adeguato') return '#ef4444';
      return '#64748b';
    };
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Verifica PAI - ${anagrafica.nome} ${anagrafica.cognome}</title>
        <style>
          @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          body { font-family: Arial, sans-serif; padding: 30px; font-size: 11px; line-height: 1.5; }
          h1 { font-size: 18px; text-align: center; margin-bottom: 5px; color: #6b46c1; }
          .header { text-align: center; margin-bottom: 25px; border-bottom: 2px solid #6b46c1; padding-bottom: 15px; }
          .subtitle { font-size: 10px; color: #666; margin-top: 5px; }
          .info-row { display: flex; justify-content: space-between; margin-bottom: 15px; padding: 10px; background: #f5f5f5; border-radius: 8px; }
          .info-item { text-align: center; }
          .info-label { font-size: 9px; color: #666; text-transform: uppercase; }
          .info-value { font-weight: bold; font-size: 12px; }
          .area { margin-bottom: 15px; padding: 12px; border: 1px solid #e5e7eb; border-radius: 8px; }
          .area-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
          .area-title { font-weight: bold; font-size: 12px; }
          .area-stato { padding: 4px 12px; border-radius: 20px; font-size: 10px; font-weight: bold; color: white; }
          .area-osservazioni { font-size: 10px; color: #555; margin-top: 5px; padding: 8px; background: #fafafa; border-radius: 4px; }
          .notes { margin-top: 20px; padding: 15px; background: #f8fafc; border-radius: 8px; border-left: 4px solid #6b46c1; }
          .notes-title { font-weight: bold; margin-bottom: 8px; }
          .operatori { margin-top: 20px; display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 15px; }
          .operatore { text-align: center; }
          .operatore-label { font-size: 9px; color: #666; text-transform: uppercase; }
          .operatore-value { font-weight: bold; margin-top: 5px; }
          .firma-line { border-top: 1px solid #333; margin-top: 40px; width: 150px; margin-left: auto; margin-right: auto; }
          .esito { text-align: center; margin: 20px 0; padding: 15px; border-radius: 8px; }
          .esito.positivo { background: #d1fae5; color: #059669; }
          .esito.parziale { background: #fef3c7; color: #d97706; }
          .esito.negativo { background: #fee2e2; color: #dc2626; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>VERIFICA PPA</h1>
          <div class="subtitle">Valutazione Periodica del Piano Personalizzato Assistenziale</div>
        </div>
        
        <div class="info-row">
          <div class="info-item">
            <div class="info-label">Ospite</div>
            <div class="info-value">${anagrafica.nome || ''} ${anagrafica.cognome || ''}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Data Valutazione</div>
            <div class="info-value">${val.data_valutazione ? new Date(val.data_valutazione).toLocaleDateString('it-IT') : '-'}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Esito Complessivo</div>
            <div class="info-value">${val.esito || '-'}</div>
          </div>
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">🍽️ AREA NUTRIZIONE</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_nutrizione?.stato)}">${getStatoLabel(val.area_nutrizione?.stato)}</span>
          </div>
          ${val.area_nutrizione?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_nutrizione.osservazioni}</div>` : ''}
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">🛏️ AREA RIPOSO</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_riposo?.stato)}">${getStatoLabel(val.area_riposo?.stato)}</span>
          </div>
          ${val.area_riposo?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_riposo.osservazioni}</div>` : ''}
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">🚿 AREA IGIENE</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_igiene?.stato)}">${getStatoLabel(val.area_igiene?.stato)}</span>
          </div>
          ${val.area_igiene?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_igiene.osservazioni}</div>` : ''}
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">🚶 AREA MOTORIA</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_motoria?.stato)}">${getStatoLabel(val.area_motoria?.stato)}</span>
          </div>
          ${val.area_motoria?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_motoria.osservazioni}</div>` : ''}
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">📚 AREA EDUCATIVA-RIABILITATIVA</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_educativa?.stato)}">${getStatoLabel(val.area_educativa?.stato)}</span>
          </div>
          ${val.area_educativa?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_educativa.osservazioni}</div>` : ''}
        </div>
        
        <div class="area">
          <div class="area-header">
            <span class="area-title">💬 AREA PSICO-SOCIALE</span>
            <span class="area-stato" style="background: ${getStatoColor(val.area_psicosociale?.stato)}">${getStatoLabel(val.area_psicosociale?.stato)}</span>
          </div>
          ${val.area_psicosociale?.osservazioni ? `<div class="area-osservazioni">Osservazioni: ${val.area_psicosociale.osservazioni}</div>` : ''}
        </div>
        
        ${val.note_generali || val.note ? `
        <div class="notes">
          <div class="notes-title">Note Generali</div>
          <div>${val.note_generali || val.note || ''}</div>
        </div>
        ` : ''}
        
        <div class="esito ${val.esito === 'Positivo' ? 'positivo' : val.esito === 'Parziale' ? 'parziale' : 'negativo'}">
          <strong>ESITO COMPLESSIVO: ${val.esito || '-'}</strong>
        </div>
        
        <div class="operatori">
          <div class="operatore">
            <div class="operatore-label">L'Educatore</div>
            <div class="operatore-value">${val.operatori?.educatore || '_________________'}</div>
            <div class="firma-line"></div>
          </div>
          <div class="operatore">
            <div class="operatore-label">L'Assistente Sociale</div>
            <div class="operatore-value">${val.operatori?.assistente_sociale || '_________________'}</div>
            <div class="firma-line"></div>
          </div>
          <div class="operatore">
            <div class="operatore-label">L'OSS</div>
            <div class="operatore-value">${val.operatori?.oss || '_________________'}</div>
            <div class="firma-line"></div>
          </div>
        </div>
        
        <script>window.onload = function() { window.print(); }</script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  // Stampa modulo corrente (usa window.print per la pagina attuale)
  const handlePrint = () => {
    window.print();
  };
  
  // Genera il contenuto HTML per l'export
  const generateExportHtml = () => {
    // Escape di tutti i campi utente: l'HTML va in dangerouslySetInnerHTML
    const e = (v) => escapeHtml(v == null || v === "" ? "" : v);
    const anagRaw = cartella.anagrafica || {};
    const anag = {
      ...anagRaw,
      nome: e(anagRaw.nome),
      cognome: e(anagRaw.cognome),
      codice_fiscale: e(anagRaw.codice_fiscale),
      data_nascita: e(anagRaw.data_nascita),
      luogo_nascita: e(anagRaw.luogo_nascita),
      comune_nascita_label: e(anagRaw.comune_nascita_label),
      stato_nascita_label: e(anagRaw.stato_nascita_label),
      sesso: e(anagRaw.sesso),
      cittadinanza: e(anagRaw.cittadinanza),
      cittadinanza_label: e(anagRaw.cittadinanza_label),
      telefono: e(anagRaw.telefono),
      indirizzo_residenza: e(anagRaw.indirizzo_residenza),
      contatti_familiari: (anagRaw.contatti_familiari || []).map((c) => ({
        ...c,
        nome: e(c?.nome),
        parentela: e(c?.parentela),
        telefono: e(c?.telefono),
      })),
    };
    const ammRaw = cartella.amministrativa || {};
    const amm = Object.fromEntries(Object.entries(ammRaw).map(([k, v]) => [k, typeof v === "string" ? e(v) : v]));
    const socRaw = cartella.sociale || {};
    const soc = Object.fromEntries(Object.entries(socRaw).map(([k, v]) => [k, typeof v === "string" ? e(v) : v]));
    const sanRaw = cartella.sanitaria || {};
    const san = {
      ...sanRaw,
      diagnosi_principale: e(sanRaw.diagnosi_principale),
      diagnosi_secondarie: Array.isArray(sanRaw.diagnosi_secondarie)
        ? sanRaw.diagnosi_secondarie.map((x) => e(x))
        : e(sanRaw.diagnosi_secondarie),
      patologie_croniche: Array.isArray(sanRaw.patologie_croniche)
        ? sanRaw.patologie_croniche.map((x) => e(x))
        : e(sanRaw.patologie_croniche),
      allergie: Array.isArray(sanRaw.allergie) ? sanRaw.allergie.map((x) => e(x)) : e(sanRaw.allergie),
    };
    const val = (cartella.valutazioni || []).map((v) =>
      Object.fromEntries(Object.entries(v || {}).map(([k, val]) => [k, typeof val === "string" ? e(val) : val]))
    );
    const docs = (cartella.documenti || []).map((d) =>
      Object.fromEntries(Object.entries(d || {}).map(([k, val]) => [k, typeof val === "string" ? e(val) : val]))
    );

    const luogoNascitaExport =
      [anag.comune_nascita_label, anag.luogo_nascita, anag.stato_nascita_label]
        .map((s) => (s != null ? String(s).trim() : ""))
        .find(Boolean) || "N/D";

    const formatSanFieldList = (v) => {
      if (v == null || v === "") return "";
      if (Array.isArray(v)) return v.filter(Boolean).join(", ");
      return String(v);
    };

    const diagnosiPrincipaleExport = san.diagnosi_principale
      ? String(san.diagnosi_principale).trim()
      : "";
    const diagnosiSecondarieExport = formatSanFieldList(san.diagnosi_secondarie);
    const patologieCronicheExport = formatSanFieldList(san.patologie_croniche);
    const allergieExport = formatSanFieldList(san.allergie);

    return `
      <div style="font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; font-size: 11pt; line-height: 1.4; max-width: 900px; margin: 0 auto;">
        <div style="text-align: center; border-bottom: 3px solid #3B5998; padding-bottom: 15px; margin-bottom: 20px;">
          <h1 style="color: #3B5998; font-size: 24pt; margin-bottom: 5px;">FASCICOLO ASSISTENZIALE</h1>
          <div style="color: #666; font-size: 10pt;">Generato il ${new Date().toLocaleDateString('it-IT')} alle ${new Date().toLocaleTimeString('it-IT')}</div>
        </div>
        
        <div style="background: #f5f7fa; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
          <h2 style="font-size: 18pt; color: #333; margin-bottom: 5px;">${anag.cognome || 'N/D'} ${anag.nome || ''}</h2>
          <div style="color: #666; font-size: 10pt;">CF: ${anag.codice_fiscale || 'Non disponibile'} | ${e(formatCameraAssegnata(cartella.camera) || cartella.camera || 'N/D')}</div>
        </div>
        
        <!-- ANAGRAFICA -->
        <div style="margin-bottom: 20px; page-break-inside: avoid;">
          <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">DATI ANAGRAFICI</div>
          <div style="padding: 0 10px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Data di Nascita</div>
                <div style="color: #333;">${anag.data_nascita || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Luogo di Nascita</div>
                <div style="color: #333;">${luogoNascitaExport}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Sesso</div>
                <div style="color: #333;">${anag.sesso === 'M' ? 'Maschio' : anag.sesso === 'F' ? 'Femmina' : anag.sesso || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Cittadinanza</div>
                <div style="color: #333;">${anag.cittadinanza_label || anag.cittadinanza || 'Italiana'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Telefono</div>
                <div style="color: #333;">${anag.telefono || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Indirizzo Residenza</div>
                <div style="color: #333;">${anag.indirizzo_residenza || 'N/D'}</div>
              </div>
            </div>
            ${anag.contatti_familiari && anag.contatti_familiari.length > 0 ? `
              <div style="margin-top: 15px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Contatti Familiari</div>
                <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                  <thead><tr><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Nome</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Parentela</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Telefono</th></tr></thead>
                  <tbody>
                    ${anag.contatti_familiari.map(c => `
                      <tr><td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${c.nome || ''}</td><td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${c.parentela || ''}</td><td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${c.telefono || ''}</td></tr>
                    `).join('')}
                  </tbody>
                </table>
              </div>
            ` : ''}
          </div>
        </div>
        
        <!-- AMMINISTRATIVA (solo data ingresso e numero cartella in export) -->
        <div style="margin-bottom: 20px; page-break-inside: avoid;">
          <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">DATI AMMINISTRATIVI</div>
          <div style="padding: 0 10px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Data Ingresso</div>
                <div style="color: #333;">${amm.data_ingresso || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">N. Cartella</div>
                <div style="color: #333;">${amm.numero_cartella || 'N/D'}</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- SOCIALE -->
        <div style="margin-bottom: 20px; page-break-inside: avoid;">
          <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">SITUAZIONE SOCIALE</div>
          <div style="padding: 0 10px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Stato Civile</div>
                <div style="color: #333;">${soc.stato_civile || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Professione Precedente</div>
                <div style="color: #333;">${soc.professione_precedente || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Titolo di Studio</div>
                <div style="color: #333;">${soc.titolo_studio || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Rete Familiare</div>
                <div style="color: #333;">${soc.rete_familiare || 'N/D'}</div>
              </div>
            </div>
            ${soc.storia_personale ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Storia Personale</div>
                <div style="color: #333;">${soc.storia_personale}</div>
              </div>
            ` : ''}
            ${soc.interessi_hobby ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Interessi e Hobby</div>
                <div style="color: #333;">${soc.interessi_hobby}</div>
              </div>
            ` : ''}
          </div>
        </div>
        
        <!-- SANITARIA -->
        <div style="margin-bottom: 20px; page-break-inside: avoid;">
          <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">SITUAZIONE SANITARIA</div>
          <div style="padding: 0 10px;">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Medico Curante</div>
                <div style="color: #333;">${san.medico_curante || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">ASL di Riferimento</div>
                <div style="color: #333;">${san.asl_riferimento || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Indirizzo studio medico</div>
                <div style="color: #333;">${san.medico_curante_indirizzo_studio || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Telefono medico curante</div>
                <div style="color: #333;">${san.medico_curante_telefono || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Email personale medico</div>
                <div style="color: #333;">${san.medico_curante_email_personale || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Email blisteraggio medico</div>
                <div style="color: #333;">${san.medico_curante_email_blisteraggio || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Gruppo Sanguigno</div>
                <div style="color: #333;">${san.gruppo_sanguigno || 'N/D'}</div>
              </div>
              <div style="margin-bottom: 8px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Livello Autosufficienza</div>
                <div style="color: #333;">${san.livello_autosufficienza || 'N/D'}</div>
              </div>
            </div>
            ${diagnosiPrincipaleExport ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Diagnosi Principale</div>
                <div style="color: #333;">${diagnosiPrincipaleExport}</div>
              </div>
            ` : ''}
            ${diagnosiSecondarieExport ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Diagnosi Secondarie</div>
                <div style="color: #333;">${diagnosiSecondarieExport}</div>
              </div>
            ` : ''}
            ${patologieCronicheExport ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Patologie Croniche</div>
                <div style="color: #333;">${patologieCronicheExport}</div>
              </div>
            ` : ''}
            ${allergieExport ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Allergie</div>
                <div style="color: #dc2626;">${allergieExport}</div>
              </div>
            ` : ''}
            ${san.terapia_farmacologica ? `
              <div style="margin-top: 10px;">
                <div style="font-weight: bold; color: #555; font-size: 9pt; text-transform: uppercase;">Terapia Farmacologica</div>
                <div style="color: #333;">${san.terapia_farmacologica}</div>
              </div>
            ` : ''}
          </div>
        </div>
        
        <!-- VALUTAZIONI -->
        ${val.length > 0 ? `
          <div style="margin-bottom: 20px; page-break-inside: avoid;">
            <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">STORICO VALUTAZIONI</div>
            <div style="padding: 0 10px;">
              <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                <thead>
                  <tr><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Data</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Tipo</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Punteggio</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Note</th></tr>
                </thead>
                <tbody>
                  ${val.slice(0, 10).map(v => `
                    <tr>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${v.data || ''}</td>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${v.tipo || ''}</td>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${v.punteggio || ''}</td>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${v.note || ''}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          </div>
        ` : ''}
        
        <!-- DOCUMENTI -->
        ${docs.length > 0 ? `
          <div style="margin-bottom: 20px; page-break-inside: avoid;">
            <div style="background: #3B5998; color: white; padding: 8px 12px; font-size: 12pt; font-weight: bold; margin-bottom: 10px;">DOCUMENTI ALLEGATI</div>
            <div style="padding: 0 10px;">
              <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                <thead>
                  <tr><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Nome File</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Sezione</th><th style="background: #e5e7eb; padding: 8px; text-align: left; font-size: 9pt;">Data Caricamento</th></tr>
                </thead>
                <tbody>
                  ${docs.map(d => `
                    <tr>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${d.file_name || ''}</td>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${d.sezione || ''}</td>
                      <td style="border-bottom: 1px solid #e5e7eb; padding: 8px; font-size: 10pt;">${d.uploaded_at ? new Date(d.uploaded_at).toLocaleDateString('it-IT') : ''}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          </div>
        ` : ''}
        
        <div style="margin-top: 30px; text-align: center; color: #999; font-size: 9pt; border-top: 1px solid #ddd; padding-top: 15px;">
          <p>Documento generato da AFFIDYA - Sistema Gestionale per Strutture Socio-Assistenziali</p>
          <p>Cartella ID: ${cartella.id || id} | Generato: ${new Date().toLocaleString('it-IT')}</p>
        </div>
      </div>
    `;
  };
  
  // Export intera cartella (apre popup senza stampa automatica)
  const handleExportPDF = async () => {
    const html = generateExportHtml();
    setExportHtml(html);
    setShowExportModal(true);
    
    // Registra l'azione di export/stampa nello storico
    try {
      await axios.post(`${API_URL}/api/fascicoli-assistenziali/${id}/log-action`, {
        action: "export_pdf",
        description: "Esportazione/Stampa fascicolo"
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error("Errore log azione:", error);
    }
  };
  
  // Stampa dal popup export
  const handlePrintFromExport = async () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      toast.error("Popup bloccato - abilita i popup per stampare");
      return;
    }
    
    const anag = cartella.anagrafica || {};
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Fascicolo Assistenziale - ${anag.cognome || ''} ${anag.nome || ''}</title>
        <style>
          @media print {
            body { margin: 0; padding: 10px; }
          }
        </style>
      </head>
      <body>
        ${exportHtml}
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = function() {
      printWindow.print();
    };
    
    // Registra l'azione di stampa nello storico
    try {
      await axios.post(`${API_URL}/api/fascicoli-assistenziali/${id}/log-action`, {
        action: "print",
        description: "Stampa fascicolo"
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error("Errore log azione:", error);
    }
  };
  
  // Export completo fascicolo come ZIP (solo super_admin)
  const [exporting, setExporting] = useState(false);
  
  const handleExportZIP = async () => {
    setExporting(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/fascicoli-assistenziali/${id}/export`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        }
      );
      
      // Crea download del file
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Estrai nome file dall'header o genera uno default
      const contentDisposition = response.headers['content-disposition'];
      let filename = `Fascicolo_Export_${new Date().toISOString().split('T')[0]}.zip`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) {
          filename = match[1].replace(/['"]/g, '');
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('Export completato! File scaricato.');
    } catch (error) {
      console.error('Errore export:', error);
      if (error.response?.status === 403) {
        toast.error('Non hai i permessi per esportare il fascicolo. Richiesto ruolo Super Admin.');
      } else {
        toast.error('Errore durante l\'export del fascicolo');
      }
    } finally {
      setExporting(false);
    }
  };

  const pageHeader = (
    <PageHeader
      title="Fascicoli Assistenziali"
      subtitle="Gestione documentazione assistenziale ospiti"
      icon={FolderOpen}
      iconContainerClassName="bg-[#F3EFFF] !shadow-none"
      iconClassName="text-violet-500"
    />
  );

  if (loading) {
    return (
      <>
        {pageHeader}
        <div className="p-4 md:p-6 lg:p-8">
          <div className="animate-pulse space-y-4">
            <div className="h-12 bg-slate-200 rounded-xl w-1/3" />
            <div className="h-64 bg-slate-200 rounded-xl" />
          </div>
        </div>
      </>
    );
  }

  if (!cartella) {
    return (
      <>
        {pageHeader}
        <div className="p-4 md:p-6 lg:p-8 text-center">
          <p className="text-slate-500">Fascicolo assistenziale non trovato</p>
          <Link to="/fascicoli-assistenziali">
            <Button className="mt-4">Torna alla lista</Button>
          </Link>
        </div>
      </>
    );
  }

  // Estrai dati con valori di default per evitare errori su campi mancanti
  const anagrafica = {
    nome: '', cognome: '', data_nascita: '', sesso: '', codice_fiscale: '',
    luogo_nascita: '', foto_url: null, telefono: '', indirizzo_residenza: '',
    stato_nascita_label: 'ITALIA', cittadinanza_label: 'ITALIA', contatti_familiari: [],
    ...cartella.anagrafica
  };
  const amministrativa = {
    data_ingresso: '', data_uscita: '', numero_cartella: '', tipo_contratto: '', retta_mensile: 0,
    tariffa_giornaliera: null, tariffa_settimanale: null,
    deposito_cauzionale: null,
    deposito_cauzionale_abilitato: false,
    ente_pagante: '', documenti: [], note_amministrative: '',
    residente_in_struttura: false,
    ...cartella.amministrativa
  };
  const diurnoData = {
    giorni_settimana: [],
    orario_ingresso: "08:00",
    orario_uscita: "18:00",
    ...(cartella.diurno || {})
  };
  const isDiurno = cartella.tipo_ospite === "diurno";
  const ospiteInitials =
    `${(anagrafica.nome || "").trim().charAt(0)}${(anagrafica.cognome || "").trim().charAt(0)}`.toUpperCase() ||
    "O";
  const sociale = {
    stato_civile: 'Non specificato', professione_precedente: '', titolo_studio: '',
    rete_familiare: 'Non specificata', storia_personale: '', interessi_hobby: '',
    preferenze_alimentari: '', note_sociali: '',
    ...cartella.sociale
  };
  const sanitaria = {
    diagnosi_principale: '', diagnosi_secondarie: [], patologie_croniche: [],
    doctor_id: null,
    medico_curante: '',
    medico_curante_telefono: '',
    medico_curante_email_personale: '',
    medico_curante_email_blisteraggio: '',
    medico_curante_indirizzo_studio: '',
    asl_riferimento: '',
    gruppo_sanguigno: '', dieta: '', allergie: [], terapie_in_corso: [],
    ausili_utilizzati: [], note_sanitarie: '', note_cliniche: '',
    piani_terapeutici_testo: '',
    richiesta_rsa: false,
    ...cartella.sanitaria
  };
  const sanitariaEditing = isEditing && editDraftRef.current?.sanitaria
    ? { ...sanitaria, ...editDraftRef.current.sanitaria }
    : sanitaria;
  const pai_attivo = cartella.pai_attivo || null;
  const valutazioni = cartella.valutazioni || [];
  const storico_modifiche = cartella.storico_modifiche || [];
  const alert_scadenze = cartella.alert_scadenze || [];
  const contattiFamiliariDraft = isEditing
    ? editDraftRef.current?.anagrafica?.contatti_familiari || []
    : [];
  const emailFamiliariLog = cartella.email_familiari_log || [];
  const comunicazioniMediche = [...(cartella.comunicazioni_mediche || [])].sort(
    (a, b) => new Date(b.sent_at || 0) - new Date(a.sent_at || 0)
  );
  const selectedFamiliareEmailHistoryLogs = selectedFamiliareEmailHistory?.email
    ? emailFamiliariLog
        .filter((log) => (log.recipient_email || "").toLowerCase() === selectedFamiliareEmailHistory.email.toLowerCase())
        .sort((a, b) => new Date(b.sent_at || 0) - new Date(a.sent_at || 0))
    : [];
  const requestedPreIngressoDocs = preIngressoCard?.requested_documents || [];
  const requestedPreIngressoFileDocs = requestedPreIngressoDocs.filter((doc) => !doc.is_therapy);
  const requestedPreIngressoTherapy = requestedPreIngressoDocs.find((doc) => doc.is_therapy);

  return (
    <>
    {pageHeader}
    <div className="w-full px-0 py-4 md:py-5 lg:py-6">
      <input
        type="file"
        ref={fotoOspiteInputRef}
        className="hidden"
        accept="image/jpeg,image/png,image/webp,image/gif"
        onChange={handleFotoOspiteChange}
      />
      {/* Alert scadenze */}
      {alert_scadenze && alert_scadenze.length > 0 && (
        <Card className="card-base mb-6 border-l-4 border-l-amber-500">
          <CardContent className="p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-amber-500 mt-0.5" />
              <div>
                <p className="font-semibold text-slate-900">Scadenze in arrivo</p>
                <div className="flex flex-wrap gap-2 mt-2">
                  {alert_scadenze.map((alert, idx) => (
                    <Badge 
                      key={idx} 
                      className={`${alert.giorni_rimanenti <= 30 ? 'bg-red-500' : 'bg-amber-500'} text-white`}
                    >
                      {alert.descrizione}: {alert.data} ({alert.giorni_rimanenti} giorni)
                    </Badge>
                  ))}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {cartella?.stato_ospite === "PRE_INGRESSO" && preIngressoCard && (
        <Card className="mb-6 border-yellow-200 bg-gradient-to-br from-yellow-50 to-white">
          <CardContent className="p-5">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold bg-yellow-100 text-yellow-800 ring-1 ring-yellow-300">
                    <span className="w-2 h-2 rounded-full bg-yellow-500" aria-hidden />
                    PRE-INGRESSO
                  </span>
                  <Badge variant="outline" className="text-amber-700 border-amber-300">
                    In attesa documentazione
                  </Badge>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
                  <div>
                    <p className="text-slate-500 text-xs uppercase font-semibold mb-1">Contratto</p>
                    {preIngressoCard.contratto?.firmato ? (
                      <span className="text-emerald-700 font-medium">Firmato</span>
                    ) : preIngressoCard.contratto?.stato === "in_attesa" ? (
                      <span className="text-amber-700 font-medium">In attesa</span>
                    ) : (
                      <span className="text-red-600 font-medium">Mancante</span>
                    )}
                  </div>
                  <div>
                    <p className="text-slate-500 text-xs uppercase font-semibold mb-1">Documenti</p>
                    <span className="font-medium text-slate-800">
                      {preIngressoCard.documenti?.ricevuti ?? 0} di {preIngressoCard.documenti?.totali ?? 0} ricevuti
                    </span>
                  </div>
                  <div>
                    <p className="text-slate-500 text-xs uppercase font-semibold mb-1">Terapia</p>
                    <span className={preIngressoCard.terapia?.ricevuta ? "text-emerald-700 font-medium" : "text-slate-600"}>
                      {preIngressoCard.terapia?.ricevuta ? "Ricevuta" : "Non ricevuta"}
                    </span>
                  </div>
                </div>
              </div>
              {hasPermission("fascicolo:update") && preIngressoCard.attivabile && (
                <Button
                  className="bg-emerald-600 hover:bg-emerald-700 shrink-0"
                  onClick={() => setShowAttivaOspiteDialog(true)}
                  disabled={attivandoOspite}
                >
                  {attivandoOspite ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  ) : null}
                  ATTIVA OSPITE
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-0">
        <Card className="mb-0 overflow-hidden rounded-none border-0 bg-white shadow-none hover:shadow-none">
          {/* Navigazione fascicoli */}
          <div className="flex items-center justify-between bg-white px-3 py-2 md:px-5">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-8 gap-1 px-1.5 text-xs text-emerald-700 shadow-none hover:bg-emerald-50 hover:text-emerald-800 sm:text-sm"
              asChild
            >
              <Link to="/fascicoli-assistenziali">
                <ChevronLeft className="h-3.5 w-3.5 shrink-0" />
                Fascicoli
              </Link>
            </Button>

            <div className="flex items-center gap-1">
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="h-8 gap-1 rounded-xl bg-slate-50 px-2 text-xs text-slate-500 shadow-none hover:bg-slate-100 disabled:opacity-50"
                onClick={() => prevOspite && goToOspite(prevOspite.id)}
                disabled={!prevOspite}
                title={prevOspite ? `Ospite precedente: ${prevOspite.label}` : "Nessun ospite precedente"}
              >
                <ChevronLeft className="h-3.5 w-3.5" />
                Prec.
              </Button>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                className="h-8 gap-1 rounded-xl bg-slate-50 px-2 text-xs text-slate-500 shadow-none hover:bg-slate-100 disabled:opacity-50"
                onClick={() => nextOspite && goToOspite(nextOspite.id)}
                disabled={!nextOspite}
                title={nextOspite ? `Ospite successivo: ${nextOspite.label}` : "Nessun ospite successivo"}
              >
                Succ.
                <ChevronRight className="h-3.5 w-3.5" />
              </Button>
            </div>
          </div>

          {/* Header ospite */}
          <div className="mx-4 mb-3 flex flex-col justify-between gap-4 rounded-2xl border border-slate-200 bg-white p-4 md:mx-5 md:p-5 lg:mx-6 lg:flex-row lg:items-center lg:p-6">
        <div className="flex items-center gap-4">
          {/* Avatar e info principali */}
          <div className="flex items-center gap-4 min-w-0">
            <div className="flex h-16 w-16 shrink-0 overflow-hidden rounded-2xl bg-violet-50 ring-1 ring-violet-100/70">
              {anagrafica.foto_url ? (
                <img 
                  src={anagrafica.foto_url} 
                  alt={`${anagrafica.nome} ${anagrafica.cognome}`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center text-xl font-semibold tracking-tight text-violet-500">
                  {ospiteInitials}
                </div>
              )}
            </div>
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <h1 className="text-xl font-bold tracking-tight text-slate-900 md:text-2xl">
                  {anagrafica.nome || ""} {anagrafica.cognome || ""}
                </h1>
                {isDiurno && (
                  <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold bg-amber-100 text-amber-700 ring-1 ring-amber-200">
                    <Sun className="w-3.5 h-3.5" />
                    Ospite Diurno
                  </span>
                )}
                {cartella?.stato_ospite === "PRE_INGRESSO" && (
                  <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold bg-yellow-100 text-yellow-800 ring-1 ring-yellow-300">
                    <span className="w-2 h-2 rounded-full bg-yellow-500 shrink-0" aria-hidden />
                    PRE-INGRESSO
                  </span>
                )}
              </div>
              {cartella?.stato_ospite === "PRE_INGRESSO" && (
                <p className="text-sm text-amber-800 font-medium mt-1">
                  Ingresso previsto:{" "}
                  {(() => {
                    const raw =
                      amministrativa.data_ingresso_prevista || amministrativa.data_ingresso;
                    if (!raw) return "—";
                    const d = new Date(raw);
                    return Number.isNaN(d.getTime())
                      ? raw
                      : d.toLocaleDateString("it-IT");
                  })()}
                </p>
              )}
              <p className="text-sm text-slate-500">
                {isDiurno
                  ? `Diurno • Cartella ${amministrativa.numero_cartella || "N/D"}`
                  : `${formatCameraAssegnata(cartella.camera) || cartella.camera || "N/D"} • Cartella ${amministrativa.numero_cartella || "N/D"}`
                }
              </p>
              {hasPermission("fascicolo:update") && (
                <Button
                  type="button"
                  variant="link"
                  size="sm"
                  className="mt-1.5 h-auto gap-1.5 p-0 text-xs text-violet-500 hover:text-violet-700 justify-start"
                  onClick={() => fotoOspiteInputRef.current?.click()}
                  disabled={uploadingFotoOspite}
                  data-testid="btn-carica-foto-ospite"
                >
                  {uploadingFotoOspite ? (
                    <Loader2 className="w-4 h-4 animate-spin shrink-0" />
                  ) : (
                    <Camera className="w-4 h-4 shrink-0" />
                  )}
                  Carica foto ospite
                </Button>
              )}
            </div>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-2 lg:justify-end">
          {isEditing ? (
            <>
              <Button variant="outline" onClick={handleCancel} disabled={saving}>
                <X className="w-4 h-4 mr-2" />
                Annulla
              </Button>
              <Button onClick={handleSave} className="bg-purple-600 hover:bg-purple-700" disabled={saving}>
                {saving ? (
                  <>
                    <Clock className="w-4 h-4 mr-2 animate-spin" />
                    Salvataggio...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-2" />
                    Salva
                  </>
                )}
              </Button>
            </>
          ) : (
            <>
              <Button variant="outline" size="sm" className="h-9 rounded-xl border-slate-200 bg-slate-50 text-slate-600 shadow-none hover:bg-slate-100" onClick={handleExportPDF} title="Esporta e stampa il fascicolo completo">
                <Download className="w-4 h-4 mr-2" />
                Esporta/Stampa
              </Button>
              {/* Pulsante Export ZIP - visibile solo a super_admin con permesso fascicolo:export */}
              {hasPermission('fascicolo:export') && (
                <Button 
                  variant="outline" 
                  onClick={handleExportZIP} 
                  disabled={exporting}
                  title="Esporta fascicolo completo come ZIP"
                  className="h-9 rounded-xl border-emerald-200 bg-emerald-50 text-emerald-700 shadow-none hover:bg-emerald-100"
                  data-testid="btn-export-zip"
                >
                  {exporting ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Esportazione...
                    </>
                  ) : (
                    <>
                      <Archive className="w-4 h-4 mr-2" />
                      Export ZIP
                    </>
                  )}
                </Button>
              )}
              {/* Pulsante Firma Contratto */}
              <Button 
                variant="outline" 
                onClick={() => navigate(`/fascicoli-assistenziali/${id}/firma-contratto`)}
                title="Firma digitale del contratto"
                className="h-9 rounded-xl border-violet-200 bg-violet-50 text-violet-700 shadow-none hover:bg-violet-100"
                data-testid="btn-firma-contratto"
              >
                <FileSignature className="w-4 h-4 mr-2" />
                Firma Contratto
              </Button>
              <Button size="sm" onClick={beginEditing} className="h-9 rounded-xl bg-fuchsia-600 shadow-none hover:bg-fuchsia-700" style={{ display: ['pai', 'documenti', 'storico', 'costi-ricorrenti'].includes(activeTab) || hideEditForAmminSection ? 'none' : 'inline-flex' }}>
                <Edit className="w-4 h-4 mr-2" />
                Modifica
              </Button>
            </>
          )}
        </div>
          </div>

          {/* Tab principali + contenuto */}
          <div className="bg-white">
          <div className="px-3 pb-2 pt-3 md:px-5 lg:px-6">
        <TabsList className="grid h-auto w-full grid-cols-4 gap-1 rounded-[1.35rem] bg-[#eef2f2] p-1 lg:grid-cols-9">
          <TabsTrigger 
            value="anagrafica" 
            className={mainTabTriggerClass}
          >
            <User className="w-4 h-4 shrink-0" />
            Anagrafica
          </TabsTrigger>
          <TabsTrigger 
            value="amministrativa" 
            className={mainTabTriggerClass}
          >
            <Briefcase className="w-4 h-4 shrink-0" />
            Amministr.
          </TabsTrigger>
          <TabsTrigger 
            value="sociale" 
            className={mainTabTriggerClass}
          >
            <Users className="w-4 h-4 shrink-0" />
            Sociale
          </TabsTrigger>
          <TabsTrigger 
            value="sanitaria" 
            className={mainTabTriggerClass}
          >
            <Heart className="w-4 h-4 shrink-0" />
            Sanitario
            {terapieExtraAlertCount > 0 ? (
              <Badge className="bg-red-500 text-white text-[10px] px-1.5 min-w-[1.25rem] h-5">
                {terapieExtraAlertCount}
              </Badge>
            ) : null}
          </TabsTrigger>
          <TabsTrigger 
            value="pai" 
            className={mainTabTriggerClass}
          >
            <ClipboardList className="w-4 h-4 shrink-0" />
            PAI
          </TabsTrigger>
          <TabsTrigger 
            value="documenti" 
            className={mainTabTriggerClass}
          >
            <Paperclip className="w-4 h-4 shrink-0" />
            Documenti
          </TabsTrigger>
          <TabsTrigger
            value="costi-ricorrenti"
            className={mainTabTriggerClass}
          >
            <Repeat className="w-4 h-4 shrink-0" />
            Costi ricorrenti
          </TabsTrigger>
          <TabsTrigger 
            value="storico" 
            className={mainTabTriggerClass}
          >
            <History className="w-4 h-4 shrink-0" />
            Storico
          </TabsTrigger>
          {canFamily ? (
          <TabsTrigger
            value="family"
            className={mainTabTriggerClass}
          >
            <Sparkles className="w-4 h-4 shrink-0" />
            Family
          </TabsTrigger>
          ) : null}
        </TabsList>
          </div>

          <div className="px-4 md:px-5 lg:px-6 py-4 md:py-5">

        {/* TAB ANAGRAFICA */}
        <TabsContent value="anagrafica">
          {/* Metadati autore sezione anagrafica */}
          <SectionMetadata 
            createdBy={anagrafica?.createdBy}
            createdByName={anagrafica?.createdByName}
            createdAt={anagrafica?.createdAt}
            updatedBy={anagrafica?.updatedBy}
            updatedByName={anagrafica?.updatedByName}
            updatedAt={anagrafica?.updatedAt}
            className="mb-4"
          />
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-5">
            {/* Card Dati Personali */}
            <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader className="p-5 pb-3">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <CardTitle className="flex items-center gap-2 text-base">
                    <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-50">
                      <User className="h-3.5 w-3.5 text-violet-500" />
                    </span>
                    Dati Personali
                  </CardTitle>
                  {hasPermission("fascicolo:update") && (
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      className="h-8 rounded-xl border-violet-200 bg-violet-50 px-3 text-xs text-violet-600 shadow-none hover:bg-violet-100 shrink-0"
                      onClick={() => setShowCompilaDaIdentita(true)}
                      data-testid="btn-compila-da-identita"
                    >
                      <Sparkles className="w-4 h-4 mr-2" />
                      Compila da documento identità
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardContent className="space-y-4 p-5 pt-0">
                <div className="grid grid-cols-2 gap-x-5 gap-y-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Nome</Label>
                    {isEditing ? (
                      <Input
                        key={`ana-nome-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.nome || ""}
                        onChange={(e) => handleFieldChange("anagrafica", "nome", e.target.value)}
                        className="mt-1"
                      />
                    ) : (
                      <p className="font-medium">{anagrafica.nome}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Cognome</Label>
                    {isEditing ? (
                      <Input
                        key={`ana-cognome-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.cognome || ""}
                        onChange={(e) => handleFieldChange("anagrafica", "cognome", e.target.value)}
                        className="mt-1"
                      />
                    ) : (
                      <p className="font-medium">{anagrafica.cognome}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Data di nascita</Label>
                    {isEditing ? (
                      <DateFieldInput
                        key={`ana-data-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.data_nascita || ""}
                        onChange={(v) => handleFieldChange("anagrafica", "data_nascita", v)}
                        className="mt-1"
                      />
                    ) : (
                      <p className="font-medium">{anagrafica.data_nascita ? new Date(anagrafica.data_nascita).toLocaleDateString('it-IT') : 'N/D'}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Sesso</Label>
                    {isEditing ? (
                      <Select
                        key={`ana-sesso-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.sesso || ""}
                        onValueChange={(v) => handleFieldChange("anagrafica", "sesso", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="M">Maschio</SelectItem>
                          <SelectItem value="F">Femmina</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{anagrafica.sesso === 'M' ? 'Maschio' : 'Femmina'}</p>
                    )}
                  </div>
                  <div className="col-span-2">
                    <Label className="text-slate-500 text-xs">Codice Fiscale</Label>
                    {isEditing ? (
                      <div className="mt-1 space-y-1.5">
                        <div className="flex flex-col sm:flex-row gap-2">
                          <Input
                            ref={codiceFiscaleInputRef}
                            key={`ana-cf-${editSessionKey}`}
                            defaultValue={cartella?.anagrafica?.codice_fiscale || ""}
                            onChange={(e) => {
                              const v = e.target.value.toUpperCase();
                              e.target.value = v;
                              handleFieldChange("anagrafica", "codice_fiscale", v);
                            }}
                            className="font-mono flex-1"
                            maxLength={16}
                            placeholder="16 caratteri"
                            data-testid="input-codice-fiscale"
                          />
                          <Button
                            type="button"
                            variant="outline"
                            className="shrink-0 border-purple-300 text-purple-700 hover:bg-purple-50"
                            onClick={handleCalcolaCodiceFiscale}
                            title="Calcola dal nome, cognome, data, sesso e luogo di nascita"
                          >
                            <Calculator className="w-4 h-4 mr-2" />
                            Calcola CF
                          </Button>
                        </div>
                        <p className="text-xs text-slate-500">
                          Italia: comune di nascita dall&apos;elenco (con provincia). Estero: seleziona lo stato di nascita — comune 000000000 e provincia EE si impostano automaticamente.
                        </p>
                      </div>
                    ) : (
                      <p className="font-medium font-mono text-sm">{anagrafica.codice_fiscale}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Telefono</Label>
                    {isEditing ? (
                      <Input
                        key={`ana-tel-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.telefono || ""}
                        onChange={(e) => handleFieldChange("anagrafica", "telefono", e.target.value)}
                        className="mt-1"
                      />
                    ) : (
                      <p className="font-medium">{anagrafica.telefono || "Non specificato"}</p>
                    )}
                  </div>
                </div>
                
                <div className="border-t border-slate-100 pt-4">
                  <div className="mb-3 flex items-center gap-2">
                    <MapPin className="h-3.5 w-3.5 text-rose-400" />
                    <Label className="text-slate-500 text-xs">Indirizzo di residenza</Label>
                  </div>
                  {isEditing ? (
                    <div className="space-y-2">
                      <div>
                        <Label className="text-xs text-slate-400">Via / Piazza e n. civico</Label>
                        <Input
                          key={`ana-via-${editSessionKey}`}
                          defaultValue={cartella?.anagrafica?.indirizzo || ""}
                          onChange={(e) => handleFieldChange("anagrafica", "indirizzo", e.target.value)}
                          placeholder="Es. Via Roma 1"
                          className="mt-1"
                        />
                      </div>
                      <div className="grid grid-cols-3 gap-2">
                        <div>
                          <Label className="text-xs text-slate-400">CAP</Label>
                          <Input
                            key={`ana-cap-${editSessionKey}`}
                            defaultValue={cartella?.anagrafica?.cap || ""}
                            onChange={(e) => handleFieldChange("anagrafica", "cap", e.target.value)}
                            placeholder="00000"
                            maxLength={5}
                            className="mt-1 font-mono"
                          />
                        </div>
                        <div className="col-span-2">
                          <Label className="text-xs text-slate-400">Comune</Label>
                          <div className="mt-1">
                            <ComuneAutocomplete
                              value={cartella?.anagrafica?.citta || cartella?.anagrafica?.comune || ""}
                              onChange={(val) => handleFieldChange("anagrafica", "citta", val)}
                              onSelect={(comune) => {
                                handleFieldChange("anagrafica", "citta", comune.descrizione);
                                handleFieldChange("anagrafica", "provincia", comune.provincia || "");
                                setEditSedeProvincia(comune.provincia || "");
                              }}
                              placeholder="Cerca comune..."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w-24">
                        <Label className="text-xs text-slate-400">Provincia</Label>
                        <Input
                          value={editSedeProvincia}
                          onChange={(e) => {
                            const v = e.target.value.toUpperCase().slice(0, 2);
                            setEditSedeProvincia(v);
                            handleFieldChange("anagrafica", "provincia", v);
                          }}
                          placeholder="BG"
                          maxLength={2}
                          className="mt-1 font-mono w-16"
                        />
                      </div>
                    </div>
                  ) : (
                    <p className="font-medium">
                      {anagrafica.indirizzo_residenza ||
                        formatAddrResidenza(anagrafica.indirizzo, anagrafica.cap, anagrafica.citta, anagrafica.provincia) ||
                        "Non specificato"}
                    </p>
                  )}
                </div>
              </CardContent>
            </Card>

            {/* Card Dati Alloggiati Web */}
            <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader className="p-5 pb-3">
                <div className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2 text-base">
                    <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-50">
                      <Globe className="h-3.5 w-3.5 text-sky-500" />
                    </span>
                    Dati per Alloggiati Web
                  </CardTitle>
                  {!isEditing && (
                    <Button
                      onClick={handleCreaAlloggiatiWeb}
                      className="h-8 rounded-xl bg-[#3c56ae] px-3 text-xs shadow-none hover:bg-[#31478f]"
                      size="sm"
                    >
                      <Send className="w-4 h-4 mr-2" />
                      Crea scheda Alloggiati Web
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardContent className="space-y-4 p-5 pt-0">
                <div className="rounded-xl border border-violet-100 bg-violet-50/80 px-3 py-2.5 text-sm text-violet-900">
                  <div className="flex items-start gap-2">
                    <AlertCircle className="w-4 h-4 mt-0.5 shrink-0 text-violet-500" />
                    <div className="space-y-1">
                      <p className="font-medium text-violet-950">Ospite nato all&apos;estero (es. Svezia)</p>
                      <ul className="list-disc pl-4 text-xs sm:text-sm space-y-0.5 text-violet-900/90">
                        <li>
                          Seleziona lo <strong>stato di nascita</strong> dall&apos;elenco (non Italia): vengono impostati
                          automaticamente comune <strong>000000000</strong> e provincia <strong>EE</strong>.
                        </li>
                        <li>
                          Imposta anche la <strong>cittadinanza</strong> corretta e, di solito, il documento{" "}
                          <strong>Passaporto ordinario</strong>.
                        </li>
                        <li>
                          Il <strong>luogo di rilascio</strong> deve essere un <strong>comune italiano</strong> (es. comune
                          della struttura): il portale Alloggiati non accetta luoghi esteri.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {!isEditing && (
                  <div
                    className={`rounded-xl border p-4 ${
                      loadingAlloggiatiStato
                        ? "bg-slate-50 border-slate-200"
                        : alloggiatiStato?.presente
                          ? "bg-green-50 border-green-200"
                          : alloggiatiStato?.trovato
                            ? "bg-amber-50 border-amber-200"
                            : "bg-slate-50 border-slate-200"
                    }`}
                  >
                    {loadingAlloggiatiStato ? (
                      <div className="flex items-center gap-2 text-sm text-slate-500">
                        <Loader2 className="w-4 h-4 animate-spin" />
                        Verifica presenza in Alloggiati Web...
                      </div>
                    ) : alloggiatiStato?.presente ? (
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="space-y-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <UserCheck className="w-4 h-4 text-green-600" />
                            <span className="font-semibold text-green-800">Presente in Alloggiati Web</span>
                            {alloggiatiStato.stato && (
                              <Badge
                                className={
                                  alloggiatiStato.stato === "INVIATA"
                                    ? "bg-green-600 text-white"
                                    : alloggiatiStato.stato === "DA_REINVIARE"
                                      ? "bg-orange-500 text-white"
                                      : "bg-amber-500 text-white"
                                }
                              >
                                {alloggiatiStato.stato === "INVIATA"
                                  ? "Inviata"
                                  : alloggiatiStato.stato === "DA_REINVIARE"
                                    ? "Da reinviare"
                                    : "Da inviare"}
                              </Badge>
                            )}
                          </div>
                          {(alloggiatiStato.data_ultimo_invio || alloggiatiStato.data_prossimo_invio) && (
                            <div className="flex flex-wrap gap-2 mt-2">
                              {alloggiatiStato.data_ultimo_invio && (
                                <div className="rounded-lg bg-white/80 border border-green-200 px-3 py-2 min-w-[9.5rem]">
                                  <p className="text-[11px] font-medium uppercase tracking-wide text-green-600">
                                    Ultimo invio
                                  </p>
                                  <p className="text-sm font-semibold text-green-900 tabular-nums">
                                    {new Date(alloggiatiStato.data_ultimo_invio).toLocaleDateString("it-IT")}
                                  </p>
                                </div>
                              )}
                              {alloggiatiStato.data_prossimo_invio && (
                                <div className="rounded-lg bg-white/80 border border-green-200 px-3 py-2 min-w-[9.5rem]">
                                  <p className="text-[11px] font-medium uppercase tracking-wide text-green-600">
                                    Prossimo invio
                                  </p>
                                  <p className="text-sm font-semibold text-green-900 tabular-nums">
                                    {new Date(alloggiatiStato.data_prossimo_invio).toLocaleDateString("it-IT")}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <Link to="/alloggiati-web">
                          <Button variant="outline" size="sm" className="border-green-300 text-green-700 hover:bg-green-100">
                            <FileText className="w-4 h-4 mr-2" />
                            Apri Alloggiati Web
                          </Button>
                        </Link>
                      </div>
                    ) : alloggiatiStato?.trovato ? (
                      <div className="flex items-start gap-2 text-sm text-amber-800">
                        <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
                        <p>
                          L&apos;ospite risulta collegato ad Alloggiati Web ma non è più attivo nella lista ospiti.
                        </p>
                      </div>
                    ) : (
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-start gap-2 text-sm text-slate-600">
                          <AlertCircle className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" />
                          <p>
                            Non presente in Alloggiati Web. Usa il pulsante &quot;Crea scheda Alloggiati Web&quot; per registrarlo.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Comune di nascita</Label>
                    {isEditing ? (
                      <ComuneAutocomplete
                        key={`ana-comune-${editSessionKey}`}
                        value={cartella?.anagrafica?.comune_nascita_label || cartella?.anagrafica?.luogo_nascita || ""}
                        onChange={(val) => handleFieldChange("anagrafica", "comune_nascita_label", val)}
                        onSelect={(comune) => {
                          handleFieldChange("anagrafica", "comune_nascita", comune.codice);
                          handleFieldChange("anagrafica", "comune_nascita_label", comune.descrizione);
                          handleFieldChange("anagrafica", "comune_nascita_provincia", comune.provincia || "");
                        }}
                        placeholder={
                          isNatoAllEstero(
                            cartella?.anagrafica?.stato_nascita,
                            cartella?.anagrafica?.stato_nascita_label
                          )
                            ? "Estero: codice 000000000 (già impostato con lo stato)"
                            : "Cerca comune..."
                        }
                      />
                    ) : (
                      <p className="font-medium">
                        {anagrafica.comune_nascita_label || anagrafica.luogo_nascita || "Non specificato"}
                        {anagrafica.comune_nascita_provincia === "EE" && (
                          <span className="ml-2 text-xs text-slate-500">(prov. EE)</span>
                        )}
                      </p>
                    )}
                    {isEditing &&
                      isNatoAllEstero(
                        cartella?.anagrafica?.stato_nascita,
                        cartella?.anagrafica?.stato_nascita_label
                      ) && (
                        <p className="text-xs text-blue-700 mt-1">
                          Nato all&apos;estero: comune <span className="font-mono font-medium">000000000</span>, provincia{" "}
                          <span className="font-mono font-medium">EE</span>
                        </p>
                      )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Stato di nascita</Label>
                    {isEditing ? (
                      <>
                        <StatoAutocomplete
                          key={`ana-stato-nasc-${editSessionKey}`}
                          value={cartella?.anagrafica?.stato_nascita_label || "ITALIA"}
                          onChange={(val) => handleFieldChange("anagrafica", "stato_nascita_label", val)}
                          onSelect={(stato) => {
                            handleFieldChange("anagrafica", "stato_nascita", stato.codice);
                            handleFieldChange("anagrafica", "stato_nascita_label", stato.descrizione);
                            const nascitaEstero = campiNascitaPerStato(stato.codice, stato.descrizione);
                            if (nascitaEstero) {
                              Object.entries(nascitaEstero).forEach(([campo, valore]) => {
                                handleFieldChange("anagrafica", campo, valore);
                              });
                            } else {
                              const a = editDraftRef.current?.anagrafica || {};
                              if (a.comune_nascita === "000000000" || a.comune_nascita_provincia === "EE") {
                                handleFieldChange("anagrafica", "comune_nascita", "");
                                handleFieldChange("anagrafica", "comune_nascita_label", "");
                                handleFieldChange("anagrafica", "comune_nascita_provincia", "");
                                handleFieldChange("anagrafica", "luogo_nascita", "");
                              }
                            }
                            setCartella((prev) => ({
                              ...prev,
                              anagrafica: {
                                ...(prev?.anagrafica || {}),
                                ...(editDraftRef.current?.anagrafica || {}),
                              },
                            }));
                            setEditSessionKey((k) => k + 1);
                          }}
                          placeholder="Cerca stato (es. Svezia)..."
                        />
                        <p className="text-xs text-slate-500 mt-1">
                          Se diverso da Italia: comune <span className="font-mono">000000000</span> e provincia{" "}
                          <span className="font-mono">EE</span> si impostano da soli.
                        </p>
                      </>
                    ) : (
                      <p className="font-medium">{anagrafica.stato_nascita_label || "ITALIA"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Cittadinanza</Label>
                    {isEditing ? (
                      <StatoAutocomplete
                        key={`ana-citt-${editSessionKey}`}
                        value={cartella?.anagrafica?.cittadinanza_label || "ITALIA"}
                        onChange={(val) => handleFieldChange("anagrafica", "cittadinanza_label", val)}
                        onSelect={(stato) => {
                          handleFieldChange("anagrafica", "cittadinanza", stato.codice);
                          handleFieldChange("anagrafica", "cittadinanza_label", stato.descrizione);
                        }}
                        placeholder="Cerca cittadinanza..."
                      />
                    ) : (
                      <p className="font-medium">{anagrafica.cittadinanza_label || "ITALIA"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Tipo documento</Label>
                    {isEditing ? (
                      <Select
                        key={`ana-doc-tipo-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.tipo_documento || ""}
                        onValueChange={(v) => {
                          const doc = TIPI_DOCUMENTO.find(d => d.codice === v);
                          handleFieldChange("anagrafica", "tipo_documento", v);
                          handleFieldChange("anagrafica", "tipo_documento_label", doc?.descrizione || "");
                        }}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue placeholder="Seleziona documento..." />
                        </SelectTrigger>
                        <SelectContent>
                          {TIPI_DOCUMENTO.map(doc => (
                            <SelectItem key={doc.codice} value={doc.codice}>{doc.descrizione}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{anagrafica.tipo_documento_label || "Non specificato"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Numero documento</Label>
                    {isEditing ? (
                      <Input
                        key={`ana-doc-num-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.numero_documento || ""}
                        onChange={(e) => {
                          const v = e.target.value.toUpperCase();
                          e.target.value = v;
                          handleFieldChange("anagrafica", "numero_documento", v);
                        }}
                        className="mt-1 font-mono"
                        placeholder="Es. CA12345AB"
                      />
                    ) : (
                      <p className="font-medium font-mono">{anagrafica.numero_documento || "Non specificato"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Scadenza documento <span className="text-slate-400">(facoltativa)</span></Label>
                    {isEditing ? (
                      <DateFieldInput
                        key={`ana-doc-scad-${editSessionKey}`}
                        defaultValue={cartella?.anagrafica?.data_scadenza_documento || ""}
                        onChange={(v) => handleFieldChange("anagrafica", "data_scadenza_documento", v || "")}
                        className="mt-1"
                      />
                    ) : (
                      <p className="font-medium">
                        {anagrafica.data_scadenza_documento
                          ? new Date(anagrafica.data_scadenza_documento).toLocaleDateString("it-IT")
                          : "Non specificata"}
                      </p>
                    )}
                    {!isEditing && anagrafica.data_scadenza_documento && (() => {
                      const scad = new Date(anagrafica.data_scadenza_documento);
                      if (Number.isNaN(scad.getTime())) return null;
                      const oggi = new Date();
                      oggi.setHours(0, 0, 0, 0);
                      scad.setHours(0, 0, 0, 0);
                      const giorni = Math.ceil((scad - oggi) / (1000 * 60 * 60 * 24));
                      if (giorni > 30) return null;
                      if (giorni < 0) {
                        const gg = Math.abs(giorni);
                        return (
                          <Badge className="mt-1 bg-red-600 text-white">
                            Scaduto da {gg} {gg === 1 ? "giorno" : "giorni"}
                          </Badge>
                        );
                      }
                      return (
                        <Badge className={`mt-1 ${giorni <= 7 ? "bg-red-500" : "bg-amber-500"} text-white`}>
                          {giorni === 0 ? "Scade oggi" : `Scade tra ${giorni} ${giorni === 1 ? "giorno" : "giorni"}`}
                        </Badge>
                      );
                    })()}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Luogo rilascio</Label>
                    {isEditing ? (
                      <>
                        <Input
                          key={`ana-doc-luogo-${editSessionKey}`}
                          defaultValue={cartella?.anagrafica?.luogo_rilascio_documento || ""}
                          onChange={(e) => handleFieldChange("anagrafica", "luogo_rilascio_documento", e.target.value)}
                          className="mt-1"
                          placeholder="Es. Roma (comune italiano)"
                        />
                        <p className="text-xs text-slate-500 mt-1">
                          Anche con passaporto estero indicare un <strong>comune italiano</strong> (es. della struttura).
                        </p>
                      </>
                    ) : (
                      <p className="font-medium">{anagrafica.luogo_rilascio_documento || "Non specificato"}</p>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Card Contatti Familiari - Modificabile */}
            <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none lg:col-span-2">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2 text-lg">
                    <Users className="w-5 h-5 text-purple-600" />
                    Contatti Familiari
                  </CardTitle>
                  {isEditing && (
                    <Button variant="outline" size="sm" onClick={handleAddContatto}>
                      <Plus className="w-4 h-4 mr-2" />
                      Aggiungi contatto
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardContent>
                {isEditing ? (
                  <div className="space-y-4">
                    {contattiFamiliariDraft.map((contatto, idx) => (
                      <div key={`${contattiListRevision}-${idx}`} className="p-4 bg-slate-50 rounded-xl">
                        <div className="flex justify-end mb-2">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveContatto(idx)}
                            className="text-red-500 hover:text-red-700 hover:bg-red-50"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          <div>
                            <Label className="text-slate-500 text-xs">Nome completo</Label>
                            <Input
                              defaultValue={contatto.nome || ""}
                              onChange={(e) => handleUpdateContatto(idx, "nome", e.target.value)}
                              className="mt-1"
                              placeholder="Mario Rossi"
                            />
                          </div>
                          <div>
                            <Label className="text-slate-500 text-xs">Relazione</Label>
                            <Select
                              defaultValue={contatto.relazione || ""}
                              onValueChange={(v) => handleUpdateContatto(idx, "relazione", v)}
                            >
                              <SelectTrigger className="mt-1">
                                <SelectValue placeholder="Seleziona..." />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="Figlio/a">Figlio/a</SelectItem>
                                <SelectItem value="Coniuge">Coniuge</SelectItem>
                                <SelectItem value="Nipote">Nipote</SelectItem>
                                <SelectItem value="Fratello/Sorella">Fratello/Sorella</SelectItem>
                                <SelectItem value="Genitore">Genitore</SelectItem>
                                <SelectItem value="Tutore">Tutore</SelectItem>
                                <SelectItem value="Altro">Altro</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>
                          <div>
                            <Label className="text-slate-500 text-xs">Telefono</Label>
                            <Input
                              defaultValue={contatto.telefono || ""}
                              onChange={(e) => handleUpdateContatto(idx, "telefono", e.target.value)}
                              className="mt-1"
                              placeholder="+39 333 1234567"
                            />
                          </div>
                          <div>
                            <Label className="text-slate-500 text-xs">Email</Label>
                            <Input
                              defaultValue={contatto.email || ""}
                              onChange={(e) => handleUpdateContatto(idx, "email", e.target.value)}
                              className="mt-1"
                              placeholder="email@esempio.it"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    {contattiFamiliariDraft.length === 0 && (
                      <p className="text-slate-400 text-center py-8">
                        Nessun contatto. Clicca "Aggiungi contatto" per inserirne uno.
                      </p>
                    )}
                  </div>
                ) : (
                  anagrafica.contatti_familiari && anagrafica.contatti_familiari.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {anagrafica.contatti_familiari.map((contatto, idx) => {
                        const contattoEmailLog = contatto.email
                          ? emailFamiliariLog
                              .filter((log) => (log.recipient_email || "").toLowerCase() === contatto.email.toLowerCase())
                              .sort((a, b) => new Date(b.sent_at || 0) - new Date(a.sent_at || 0))
                          : [];
                        return (
                            <div key={idx} className="p-4 bg-slate-50 rounded-xl">
                              <div className="flex items-center justify-between mb-2">
                                <p className="font-semibold text-slate-900">{contatto.nome}</p>
                                <Badge variant="outline">{contatto.relazione}</Badge>
                              </div>
                              <div className="space-y-1 text-sm">
                                <div className="flex items-center gap-2 text-slate-600">
                                  <Phone className="w-3 h-3" />
                                  {contatto.telefono}
                                </div>
                                {contatto.email && (
                                  <div className="flex flex-wrap items-center gap-2 text-slate-600">
                                    <div className="flex min-w-0 items-center gap-2">
                                      <Mail className="w-3 h-3 shrink-0" />
                                      <span className="break-all">{contatto.email}</span>
                                    </div>
                                    <Button
                                      type="button"
                                      variant="outline"
                                      size="sm"
                                      className="h-7 border-blue-200 px-2 text-xs text-blue-700 hover:bg-blue-50"
                                      onClick={() => openFamiliareEmailDialog(contatto)}
                                    >
                                      <Send className="w-3 h-3 mr-1" />
                                      Scrivi
                                    </Button>
                                  </div>
                                )}
                                {contattoEmailLog.length > 0 && (
                                  <Button
                                    type="button"
                                    variant="outline"
                                    size="sm"
                                    className="mt-3 h-8 border-blue-200 text-xs text-blue-700 hover:bg-blue-50"
                                    onClick={() => openFamiliareEmailHistoryDialog(contatto)}
                                  >
                                    <Mail className="w-3 h-3 mr-1" />
                                    Storico email
                                    <Badge variant="secondary" className="ml-2 h-5 px-1.5 text-[10px]">
                                      {contattoEmailLog.length}
                                    </Badge>
                                  </Button>
                                )}
                              </div>
                            </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-slate-400 text-center py-8">Nessun contatto registrato</p>
                  )
                )}
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        {/* TAB AMMINISTRATIVA */}
        <TabsContent value="amministrativa">
          {/* Metadati autore sezione amministrativa */}
          <SectionMetadata 
            createdBy={amministrativa?.createdBy}
            createdByName={amministrativa?.createdByName}
            createdAt={amministrativa?.createdAt}
            updatedBy={amministrativa?.updatedBy}
            updatedByName={amministrativa?.updatedByName}
            updatedAt={amministrativa?.updatedAt}
            className="mb-4"
          />

          <Tabs
            value={amministrativaSection}
            onValueChange={handleAmministrativaSectionChange}
            className="space-y-4"
          >
            <TabsList className="w-full h-auto p-0 bg-transparent border-b border-slate-200 rounded-none justify-start gap-0 overflow-x-auto flex flex-nowrap">
              <TabsTrigger value="dati" className={amminSubTabClass}>
                <Briefcase className="w-4 h-4" />
                Dati amministrativi
              </TabsTrigger>
              <TabsTrigger value="uscite" className={amminSubTabClass}>
                <DoorOpen className="w-4 h-4" />
                Uscite temporanee
              </TabsTrigger>
              {canCentroDiurno && (
                <TabsTrigger value="centro-diurno" className={amminSubTabClass}>
                  <Sparkles className="w-4 h-4" />
                  Centro Diurno
                </TabsTrigger>
              )}
              {canFatturazione && (
                <>
                  <TabsTrigger value="destinatario" className={amminSubTabClass}>
                    <UserCheck className="w-4 h-4" />
                    Destinatario fatturazione
                  </TabsTrigger>
                  <TabsTrigger value="fatturazione" className={amminSubTabClass}>
                    <Receipt className="w-4 h-4" />
                    Fatturazione
                  </TabsTrigger>
                  <TabsTrigger value="storico-fatture" className={amminSubTabClass}>
                    <History className="w-4 h-4" />
                    Storico fatture
                  </TabsTrigger>
                </>
              )}
            </TabsList>
          </Tabs>

          <div role="tabpanel" hidden={amministrativaSection !== "dati"} className="mt-4">
          <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Briefcase className="w-5 h-5 text-purple-600" />
                Dati Amministrativi
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div>
                  <Label className="text-slate-500 text-xs">Camera assegnata</Label>
                  {isEditing ? (
                    loadingCamere ? (
                      <div className="flex items-center gap-2 text-sm text-slate-500 py-2 mt-1">
                        <Loader2 className="w-4 h-4 animate-spin" />
                        Caricamento camere...
                      </div>
                    ) : (
                      <Select
                        key={`room-${editSessionKey}`}
                        defaultValue={cartella?.room_id ? String(cartella.room_id) : "none"}
                        onValueChange={handleRoomIdDraftChange}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue placeholder="Da assegnare" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="none">Da assegnare</SelectItem>
                          {camereDisponibili.map((camera) => (
                            <SelectItem key={camera.id} value={camera.id}>
                              {camera.name} - {camera.type} ({camera.posti_liberi} {camera.posti_liberi === 1 ? "posto libero" : "posti liberi"}){camera.is_current ? " (attuale)" : ""}
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    )
                  ) : (
                    <p className="font-medium">
                      {formatCameraAssegnata(cartella?.camera) || cartella?.camera || "Da assegnare"}
                    </p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Data ingresso</Label>
                  {isEditing ? (
                    <DateFieldInput
                      key={`amm-data-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.data_ingresso || ""}
                      onChange={(v) => handleFieldChange("amministrativa", "data_ingresso", v)}
                      className="mt-1"
                    />
                  ) : (
                    <p className="font-medium">{amministrativa.data_ingresso ? new Date(amministrativa.data_ingresso).toLocaleDateString('it-IT') : 'N/D'}</p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Data di uscita</Label>
                  {isEditing ? (
                    <DateFieldInput
                      key={`amm-data-uscita-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.data_uscita || ""}
                      onChange={(v) => handleFieldChange("amministrativa", "data_uscita", v)}
                      className="mt-1"
                    />
                  ) : (
                    <p className="font-medium">
                      {amministrativa.data_uscita
                        ? new Date(amministrativa.data_uscita).toLocaleDateString("it-IT")
                        : "N/D"}
                    </p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Numero cartella</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-nc-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.numero_cartella || ""}
                      onChange={(e) => handleFieldChange("amministrativa", "numero_cartella", e.target.value)}
                      className="mt-1 font-mono"
                    />
                  ) : (
                    <p className="font-medium font-mono">{amministrativa.numero_cartella}</p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Tipo contratto</Label>
                  {isEditing ? (
                    <Select
                      key={`amm-contr-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.tipo_contratto || ""}
                      onValueChange={(v) => handleFieldChange("amministrativa", "tipo_contratto", v)}
                    >
                      <SelectTrigger className="mt-1">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Privato">Privato</SelectItem>
                        <SelectItem value="Convenzionato ASL">Convenzionato ASL</SelectItem>
                        <SelectItem value="Convenzione Comunale">Convenzione Comunale</SelectItem>
                        <SelectItem value="Misto">Misto</SelectItem>
                      </SelectContent>
                    </Select>
                  ) : (
                    <p className="font-medium">{amministrativa.tipo_contratto}</p>
                  )}
                </div>
                {canDatiContabili && (
                  <>
                <div>
                  <Label className="text-slate-500 text-xs">Retta mensile</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-retta-${editSessionKey}`}
                      type="number"
                      defaultValue={
                        cartella?.amministrativa?.retta_mensile != null &&
                        cartella?.amministrativa?.retta_mensile !== ""
                          ? String(cartella.amministrativa.retta_mensile)
                          : ""
                      }
                      onChange={(e) =>
                        handleFieldChange(
                          "amministrativa",
                          "retta_mensile",
                          parseFloat(e.target.value) || 0
                        )
                      }
                      className="mt-1"
                    />
                  ) : (
                    <p className="font-medium text-lg text-emerald-600">€ {(amministrativa.retta_mensile || 0).toLocaleString('it-IT')}</p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Tariffa giornaliera</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-tg-${editSessionKey}`}
                      type="number"
                      min="0"
                      step="0.01"
                      defaultValue={
                        cartella?.amministrativa?.tariffa_giornaliera != null
                          ? String(cartella.amministrativa.tariffa_giornaliera)
                          : ""
                      }
                      onChange={(e) =>
                        handleFieldChange(
                          "amministrativa",
                          "tariffa_giornaliera",
                          e.target.value === "" ? null : parseFloat(e.target.value) || 0
                        )
                      }
                      className="mt-1"
                      placeholder="€"
                    />
                  ) : (
                    <p className="font-medium text-slate-800">
                      {amministrativa.tariffa_giornaliera != null && amministrativa.tariffa_giornaliera !== ""
                        ? `€ ${Number(amministrativa.tariffa_giornaliera).toLocaleString('it-IT')}/g`
                        : "—"}
                    </p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Tariffa settimanale</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-ts-${editSessionKey}`}
                      type="number"
                      min="0"
                      step="0.01"
                      defaultValue={
                        cartella?.amministrativa?.tariffa_settimanale != null
                          ? String(cartella.amministrativa.tariffa_settimanale)
                          : ""
                      }
                      onChange={(e) =>
                        handleFieldChange(
                          "amministrativa",
                          "tariffa_settimanale",
                          e.target.value === "" ? null : parseFloat(e.target.value) || 0
                        )
                      }
                      className="mt-1"
                      placeholder="€"
                    />
                  ) : (
                    <p className="font-medium text-slate-800">
                      {amministrativa.tariffa_settimanale != null && amministrativa.tariffa_settimanale !== ""
                        ? `€ ${Number(amministrativa.tariffa_settimanale).toLocaleString('it-IT')}/sett.`
                        : "—"}
                    </p>
                  )}
                </div>
                <div>
                  <div className="flex items-center justify-between gap-2">
                    <Label className="text-slate-500 text-xs">Deposito cauzionale</Label>
                    {isEditing && (
                      <div className="flex items-center gap-2">
                        <span className="text-[11px] text-slate-500">
                          {editDepositoAbilitato ? "Abilitato" : "Disabilitato"}
                        </span>
                        <Switch
                          checked={editDepositoAbilitato}
                          onCheckedChange={(checked) => {
                            const on = checked === true;
                            setEditDepositoAbilitato(on);
                            handleFieldChange("amministrativa", "deposito_cauzionale_abilitato", on);
                            if (!on) {
                              handleFieldChange("amministrativa", "deposito_cauzionale", null);
                            }
                          }}
                          aria-label="Abilita deposito cauzionale"
                        />
                      </div>
                    )}
                  </div>
                  {isEditing ? (
                    editDepositoAbilitato ? (
                      <Input
                        key={`amm-dep-${editSessionKey}`}
                        type="number"
                        min="0.01"
                        step="0.01"
                        defaultValue={
                          cartella?.amministrativa?.deposito_cauzionale != null &&
                          cartella?.amministrativa?.deposito_cauzionale !== ""
                            ? String(cartella.amministrativa.deposito_cauzionale)
                            : ""
                        }
                        onChange={(e) => {
                          const v = e.target.value;
                          handleFieldChange(
                            "amministrativa",
                            "deposito_cauzionale",
                            v === "" ? null : parseFloat(v) || 0
                          );
                        }}
                        className="mt-1"
                        placeholder="Importo €"
                      />
                    ) : (
                      <p className="mt-1 text-sm text-slate-400">Non richiesto</p>
                    )
                  ) : (
                    <p className="font-medium text-slate-800">
                      {importoDepositoCauzionale(amministrativa) != null
                        ? `€ ${importoDepositoCauzionale(amministrativa).toLocaleString("it-IT", {
                            minimumFractionDigits: 2,
                          })}`
                        : "—"}
                    </p>
                  )}
                </div>
                <div>
                  <Label className="text-slate-500 text-xs">Ente pagante</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-ente-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.ente_pagante || ""}
                      onChange={(e) => handleFieldChange("amministrativa", "ente_pagante", e.target.value)}
                      className="mt-1"
                      placeholder="Es. ASL Roma 1"
                    />
                  ) : (
                    <p className="font-medium">{amministrativa.ente_pagante || "Non specificato"}</p>
                  )}
                </div>
                  </>
                )}
                <div>
                  <Label className="text-slate-500 text-xs">Tutore legale</Label>
                  {isEditing ? (
                    <Input
                      key={`amm-tut-${editSessionKey}`}
                      defaultValue={cartella?.amministrativa?.tutore_legale || ""}
                      onChange={(e) => handleFieldChange("amministrativa", "tutore_legale", e.target.value)}
                      className="mt-1"
                      placeholder="Nome tutore"
                    />
                  ) : (
                    <p className="font-medium">{amministrativa.tutore_legale || "Non presente"}</p>
                  )}
                </div>
              </div>

              {/* Flag residenza in struttura */}
              <div className="mt-6 rounded-xl border border-emerald-200 bg-emerald-50/60 p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center flex-shrink-0">
                    <Home className="w-5 h-5 text-emerald-700" aria-hidden />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-semibold text-slate-900 leading-tight">
                      Residente in struttura
                    </p>
                    <p className="text-xs text-slate-600 mt-1">
                      Indica se l&apos;ospite ha la residenza anagrafica presso questa struttura
                      (utile per gestione documentale, ISEE, dichiarazioni).
                    </p>
                    {isEditing ? (
                      <div className="flex items-start gap-2.5 mt-3">
                        <Checkbox
                          key={`amm-residente-${editSessionKey}`}
                          id={`amm-residente-${id}`}
                          defaultChecked={!!cartella?.amministrativa?.residente_in_struttura}
                          onCheckedChange={(v) =>
                            handleFieldChange("amministrativa", "residente_in_struttura", v === true)
                          }
                          className="mt-0.5"
                        />
                        <Label
                          htmlFor={`amm-residente-${id}`}
                          className="text-sm font-normal text-slate-800 leading-snug cursor-pointer"
                        >
                          L&apos;ospite è residente in struttura
                        </Label>
                      </div>
                    ) : (
                      <div className="mt-2">
                        {amministrativa.residente_in_struttura ? (
                          <Badge className="bg-emerald-600 hover:bg-emerald-600 text-white">
                            Sì, residente in struttura
                          </Badge>
                        ) : (
                          <span className="text-sm text-slate-600">Non residente</span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {canFatturazione && (
                <div className="mt-6">
                  <PreferenzeFatturazioneRetta
                    key={`pref-retta-${editSessionKey}`}
                    token={token}
                    strutturaId={cartella?.organizationId || user?.struttura_id || user?.zohoRecordId}
                    value={amministrativa.fatturazione_retta}
                    isEditing={isEditing}
                    onChange={(next) =>
                      handleFieldChange("amministrativa", "fatturazione_retta", next)
                    }
                  />
                </div>
              )}

              {canTrasferireOspite && !isEditing && (
                <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50/60 p-4">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div className="flex items-start gap-3 min-w-0">
                      <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
                        <ArrowRightLeft className="w-5 h-5 text-amber-700" aria-hidden />
                      </div>
                      <div className="min-w-0">
                        <p className="text-sm font-semibold text-slate-900">Trasferimento tra strutture</p>
                        <p className="text-xs text-slate-600 mt-1">
                          Sposta l&apos;ospite in un&apos;altra struttura del tuo account. I dati clinici
                          seguono l&apos;ospite; le fatture emesse restano qui con indicazione del trasferimento.
                        </p>
                      </div>
                    </div>
                    <Button
                      type="button"
                      variant="outline"
                      className="border-amber-300 text-amber-900 hover:bg-amber-100 shrink-0"
                      onClick={openTrasferisciDialog}
                    >
                      <ArrowRightLeft className="w-4 h-4 mr-2" />
                      Sposta in altra struttura
                    </Button>
                  </div>
                </div>
              )}

              {amministrativa.documenti && amministrativa.documenti.length > 0 && (
                <div className="mt-6 pt-6 border-t">
                  <Label className="text-slate-500 text-xs mb-3 block">Documenti allegati</Label>
                  <div className="flex flex-wrap gap-2">
                    {amministrativa.documenti.map((doc, idx) => (
                      <Badge key={idx} variant="outline" className="py-2 px-3">
                        <FileText className="w-3 h-3 mr-2" />
                        {doc}
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
          </div>

          <div role="tabpanel" hidden={amministrativaSection !== "uscite"} className="mt-0">
          <UsciteTemporaneeSection
            fascicoloId={id}
            usciteTemporanee={amministrativa?.uscite_temporanee || []}
            authHeaders={{ Authorization: `Bearer ${token}` }}
            onRefresh={reloadCartella}
            canEdit={hasPermission("fascicolo:update")}
          />
          </div>

          {canCentroDiurno && (
            <div role="tabpanel" hidden={amministrativaSection !== "centro-diurno"} className="mt-0">
              <CdPacchettoFascicoloSection
                fascicoloId={id}
                pacchetto={amministrativa?.pacchetto_centro_diurno}
                canManage={hasPermission("centro_diurno:manage")}
                token={token}
                onRefresh={reloadCartella}
              />
            </div>
          )}

          {canFatturazione && (
            <>
          <div role="tabpanel" hidden={amministrativaSection !== "destinatario"} className="mt-0">
            <DestinatarioFatturazioneSection
              isEditing={isEditing}
              editSessionKey={editSessionKey}
              destinatario={amministrativa.destinatario_fatturazione}
              amministrativa={amministrativa}
              anagrafica={cartella?.anagrafica}
              onChange={(next) => handleFieldChange("amministrativa", "destinatario_fatturazione", next)}
            />
          </div>

          <div
            role="tabpanel"
            hidden={!["fatturazione", "storico-fatture"].includes(amministrativaSection)}
            className="mt-4"
          >
            <FatturazioneOspite
              fascicoloId={cartella?.id}
              fascicoloOrganizationId={cartella?.organizationId}
              amministrativa={amministrativa}
              anagrafica={cartella?.anagrafica}
              section={amministrativaSection === "storico-fatture" ? "storico" : "fatturazione"}
            />
          </div>
            </>
          )}
        </TabsContent>

        {/* TAB SOCIALE */}
        <TabsContent value="sociale">
          <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Users className="w-5 h-5 text-purple-600" />
                Dati Sociali
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Stato civile</Label>
                    {isEditing ? (
                      <Select
                        key={`soc-stato-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.stato_civile || ""}
                        onValueChange={(v) => handleFieldChange("sociale", "stato_civile", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Celibe/Nubile">Celibe/Nubile</SelectItem>
                          <SelectItem value="Coniugato/a">Coniugato/a</SelectItem>
                          <SelectItem value="Vedovo/a">Vedovo/a</SelectItem>
                          <SelectItem value="Divorziato/a">Divorziato/a</SelectItem>
                          <SelectItem value="Separato/a">Separato/a</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{sociale.stato_civile}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Professione precedente</Label>
                    {isEditing ? (
                      <Input
                        key={`soc-prof-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.professione_precedente || ""}
                        onChange={(e) => handleFieldChange("sociale", "professione_precedente", e.target.value)}
                        className="mt-1"
                        placeholder="Es. Insegnante"
                      />
                    ) : (
                      <p className="font-medium">{sociale.professione_precedente || "Non specificata"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Titolo di studio</Label>
                    {isEditing ? (
                      <Select
                        key={`soc-titolo-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.titolo_studio || ""}
                        onValueChange={(v) => handleFieldChange("sociale", "titolo_studio", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue placeholder="Seleziona..." />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Licenza elementare">Licenza elementare</SelectItem>
                          <SelectItem value="Licenza media">Licenza media</SelectItem>
                          <SelectItem value="Diploma">Diploma</SelectItem>
                          <SelectItem value="Laurea">Laurea</SelectItem>
                          <SelectItem value="Altro">Altro</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{sociale.titolo_studio || "Non specificato"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Rete familiare</Label>
                    {isEditing ? (
                      <Select
                        key={`soc-rete-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.rete_familiare || ""}
                        onValueChange={(v) => handleFieldChange("sociale", "rete_familiare", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Presente e attiva">Presente e attiva</SelectItem>
                          <SelectItem value="Presente ma discontinua">Presente ma discontinua</SelectItem>
                          <SelectItem value="Assente">Assente</SelectItem>
                          <SelectItem value="Conflittuale">Conflittuale</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{sociale.rete_familiare}</p>
                    )}
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Storia personale</Label>
                    {isEditing ? (
                      <Textarea
                        key={`soc-storia-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.storia_personale || ""}
                        onChange={(e) => handleFieldChange("sociale", "storia_personale", e.target.value)}
                        className="mt-1"
                        rows={3}
                        placeholder="Breve storia personale..."
                      />
                    ) : (
                      <p className="text-slate-700">{sociale.storia_personale || "Non specificata"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Interessi e hobby</Label>
                    {isEditing ? (
                      <Textarea
                        key={`soc-hobby-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.interessi_hobby || ""}
                        onChange={(e) => handleFieldChange("sociale", "interessi_hobby", e.target.value)}
                        className="mt-1"
                        rows={2}
                        placeholder="Es. Lettura, giardinaggio..."
                      />
                    ) : (
                      <p className="text-slate-700">{sociale.interessi_hobby || "Non specificati"}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Preferenze alimentari</Label>
                    {isEditing ? (
                      <Textarea
                        key={`soc-pref-${editSessionKey}`}
                        defaultValue={cartella?.sociale?.preferenze_alimentari || ""}
                        onChange={(e) => handleFieldChange("sociale", "preferenze_alimentari", e.target.value)}
                        className="mt-1"
                        rows={2}
                        placeholder="Preferenze e restrizioni alimentari..."
                      />
                    ) : (
                      <p className="text-slate-700">{sociale.preferenze_alimentari || "Nessuna preferenza particolare"}</p>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t">
                <Label className="text-slate-500 text-xs">Note sociali</Label>
                {isEditing ? (
                  <Textarea
                    key={`soc-note-${editSessionKey}`}
                    defaultValue={cartella?.sociale?.note_sociali || ""}
                    onChange={(e) => handleFieldChange("sociale", "note_sociali", e.target.value)}
                    className="mt-2"
                    rows={3}
                    placeholder="Altre note..."
                  />
                ) : (
                  <p className="text-slate-700 mt-2">{sociale.note_sociali || "Nessuna nota"}</p>
                )}
              </div>
            </CardContent>
          </Card>

          {/* Sezione Presenza Diurna - visibile solo per ospiti diurni */}
          {isDiurno && (
            <Card className="mt-6 rounded-2xl border-slate-200 bg-amber-50/20 shadow-none hover:shadow-none">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg text-amber-800">
                  <Sun className="w-5 h-5 text-amber-600" />
                  Presenza Diurna
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <Label className="text-slate-500 text-xs">Giorni di presenza</Label>
                    {isEditing ? (
                      <div className="flex flex-wrap gap-1.5 mt-1">
                        {["Lun","Mar","Mer","Gio","Ven","Sab","Dom"].map((g) => {
                          const sel = (diurnoData.giorni_settimana || []).includes(g);
                          return (
                            <button
                              key={g}
                              type="button"
                              onClick={() => {
                                const current = diurnoData.giorni_settimana || [];
                                const updated = sel ? current.filter((d) => d !== g) : [...current, g];
                                handleFieldChange("diurno", "giorni_settimana", updated);
                              }}
                              className={`px-2.5 py-1 rounded text-xs font-medium border transition-colors ${
                                sel
                                  ? "bg-amber-500 text-white border-amber-500"
                                  : "bg-white text-slate-600 border-slate-200 hover:border-amber-300"
                              }`}
                            >
                              {g}
                            </button>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-1 mt-1">
                        {(diurnoData.giorni_settimana || []).length > 0
                          ? (diurnoData.giorni_settimana || []).map((g) => (
                              <span key={g} className="px-1.5 py-0.5 bg-amber-100 text-amber-700 text-[11px] rounded font-medium">{g}</span>
                            ))
                          : <p className="text-slate-400 text-sm">Nessun giorno specificato</p>
                        }
                      </div>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <Label className="text-slate-500 text-xs flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        Orario ingresso
                      </Label>
                      {isEditing ? (
                        <Input
                          key={`diurno-in-${editSessionKey}`}
                          type="time"
                          defaultValue={cartella?.diurno?.orario_ingresso || "08:00"}
                          onChange={(e) => handleFieldChange("diurno", "orario_ingresso", e.target.value)}
                          className="mt-1"
                        />
                      ) : (
                        <p className="font-medium text-slate-800">{diurnoData.orario_ingresso || "—"}</p>
                      )}
                    </div>
                    <div>
                      <Label className="text-slate-500 text-xs flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        Orario uscita
                      </Label>
                      {isEditing ? (
                        <Input
                          key={`diurno-out-${editSessionKey}`}
                          type="time"
                          defaultValue={cartella?.diurno?.orario_uscita || "18:00"}
                          onChange={(e) => handleFieldChange("diurno", "orario_uscita", e.target.value)}
                          className="mt-1"
                        />
                      ) : (
                        <p className="font-medium text-slate-800">{diurnoData.orario_uscita || "—"}</p>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </TabsContent>

        {/* TAB SANITARIO — forceMount: campi non controllati (terapie, diagnosi, patologie) restano nel DOM per i ref al Salvataggio */}
        <TabsContent
          value="sanitaria"
          forceMount
          className="data-[state=inactive]:hidden"
        >
          {/* Metadati autore sezione sanitaria */}
          <SectionMetadata 
            createdBy={sanitaria?.createdBy}
            createdByName={sanitaria?.createdByName}
            createdAt={sanitaria?.createdAt}
            updatedBy={sanitaria?.updatedBy}
            updatedByName={sanitaria?.updatedByName}
            updatedAt={sanitaria?.updatedAt}
            className="mb-4"
          />
          <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Heart className="w-5 h-5 text-red-500" />
                  Diagnosi e Patologie
                </CardTitle>
                {hasPermission("fascicolo:update") && documenti.length > 0 && (
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    className="border-violet-300 text-violet-700 hover:bg-violet-50"
                    onClick={() => setShowEstrazionePatologie(true)}
                  >
                    <Sparkles className="w-3.5 h-3.5 mr-1.5" />
                    Estrai con AI
                  </Button>
                )}
              </CardHeader>
              <CardContent className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4">
                <div className="space-y-4">
                <div>
                  <Label className="text-slate-500 text-xs">Diagnosi principale</Label>
                  {isEditing ? (
                    <Input
                      ref={diagnosiPrincipaleRef}
                      key={`san-diag1-${editSessionKey}`}
                      defaultValue={cartella?.sanitaria?.diagnosi_principale || ""}
                      className="mt-1"
                    />
                  ) : (
                    <p className="font-semibold text-slate-900">{sanitaria.diagnosi_principale}</p>
                  )}
                </div>
                
                <div>
                  <Label className="text-slate-500 text-xs">Diagnosi secondarie</Label>
                  {isEditing ? (
                    <Textarea
                      ref={diagnosiSecondarieRef}
                      key={`san-diag2-${editSessionKey}`}
                      defaultValue={(cartella?.sanitaria?.diagnosi_secondarie || []).join(
                        ", "
                      )}
                      className="mt-1"
                      placeholder="Separa con virgola: Diagnosi 1, Diagnosi 2..."
                      rows={2}
                    />
                  ) : (sanitaria.diagnosi_secondarie || []).some((d) =>
                      String(d ?? "").trim()
                    ) ? (
                    <div className="flex flex-wrap gap-2 mt-1">
                      {(sanitaria.diagnosi_secondarie || [])
                        .filter((d) => String(d ?? "").trim())
                        .map((d, idx) => (
                        <Badge key={idx} variant="outline">{d}</Badge>
                      ))}
                    </div>
                  ) : (
                    <p className="text-slate-400">Nessuna</p>
                  )}
                </div>
                
                <div>
                  <Label className="text-slate-500 text-xs">Patologie croniche</Label>
                  {isEditing ? (
                    <Textarea
                      ref={patologieCronicheRef}
                      key={`san-pat-${editSessionKey}`}
                      defaultValue={(cartella?.sanitaria?.patologie_croniche || []).join(
                        ", "
                      )}
                      className="mt-1"
                      placeholder="Separa con virgola: Patologia 1, Patologia 2..."
                      rows={2}
                    />
                  ) : (sanitaria.patologie_croniche || []).some((p) =>
                      String(p ?? "").trim()
                    ) ? (
                    <div className="flex flex-wrap gap-2 mt-1">
                      {(sanitaria.patologie_croniche || [])
                        .filter((p) => String(p ?? "").trim())
                        .map((p, idx) => (
                        <Badge key={idx} className="bg-orange-100 text-orange-700">{p}</Badge>
                      ))}
                    </div>
                  ) : (
                    <p className="text-slate-400">Nessuna</p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4 pt-4 border-t">
                  <div>
                    <Label className="text-slate-500 text-xs">Gruppo sanguigno</Label>
                    {isEditing ? (
                      <Select
                        key={`san-gs-${editSessionKey}`}
                        defaultValue={cartella?.sanitaria?.gruppo_sanguigno || ""}
                        onValueChange={(v) => handleFieldChange("sanitaria", "gruppo_sanguigno", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue placeholder="Seleziona..." />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="A+">A+</SelectItem>
                          <SelectItem value="A-">A-</SelectItem>
                          <SelectItem value="B+">B+</SelectItem>
                          <SelectItem value="B-">B-</SelectItem>
                          <SelectItem value="AB+">AB+</SelectItem>
                          <SelectItem value="AB-">AB-</SelectItem>
                          <SelectItem value="0+">0+</SelectItem>
                          <SelectItem value="0-">0-</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-bold text-lg text-red-600">{sanitaria.gruppo_sanguigno || 'N/D'}</p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Dieta</Label>
                    {isEditing ? (
                      <Select
                        key={`san-dieta-${editSessionKey}`}
                        defaultValue={cartella?.sanitaria?.dieta || "Normale"}
                        onValueChange={(v) => handleFieldChange("sanitaria", "dieta", v)}
                      >
                        <SelectTrigger className="mt-1">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Normale">Normale</SelectItem>
                          <SelectItem value="Ipocalorica">Ipocalorica</SelectItem>
                          <SelectItem value="Iposodica">Iposodica</SelectItem>
                          <SelectItem value="Diabetica">Diabetica</SelectItem>
                          <SelectItem value="Senza glutine">Senza glutine</SelectItem>
                          <SelectItem value="Senza lattosio">Senza lattosio</SelectItem>
                          <SelectItem value="Morbida/Frullata">Morbida/Frullata</SelectItem>
                        </SelectContent>
                      </Select>
                    ) : (
                      <p className="font-medium">{sanitaria.dieta || 'Normale'}</p>
                    )}
                  </div>
                </div>

                <div className="p-3 bg-red-50 rounded-xl">
                  <Label className="text-red-600 text-xs font-semibold flex items-center gap-1">
                    <AlertTriangle className="w-3 h-3" />
                    ALLERGIE
                  </Label>
                  {isEditing ? (
                    <Textarea
                      ref={allergieSanitariaRef}
                      key={`san-all-${editSessionKey}`}
                      defaultValue={(cartella?.sanitaria?.allergie || []).join(", ")}
                      className="mt-2 bg-white"
                      placeholder="Separa con virgola: Allergia 1, Allergia 2..."
                      rows={2}
                    />
                  ) : (sanitaria.allergie || []).some((a) => String(a ?? "").trim()) ? (
                    <div className="flex flex-wrap gap-2 mt-2">
                      {(sanitaria.allergie || [])
                        .filter((a) => String(a ?? "").trim())
                        .map((a, idx) => (
                        <Badge key={idx} className="bg-red-500 text-white">{a}</Badge>
                      ))}
                    </div>
                  ) : (
                    <p className="text-slate-500 mt-2">Nessuna allergia nota</p>
                  )}
                </div>
                </div>

                <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label className="text-slate-500 text-xs">Medico curante</Label>
                    {isEditing ? (
                      <DoctorSelect
                        key={`san-med-select-${editSessionKey}`}
                        token={token}
                        value={sanitariaEditing.doctor_id || ""}
                        displayName={sanitariaEditing.medico_curante}
                        onSelect={handleDoctorSelect}
                        onClear={handleDoctorClear}
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900">
                        {sanitaria.medico_curante?.trim() ? sanitaria.medico_curante : "N/D"}
                      </p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">ASL di riferimento</Label>
                    {isEditing ? (
                      <Input
                        key={`san-asl-${editSessionKey}`}
                        className="mt-1"
                        defaultValue={sanitariaEditing.asl_riferimento || ""}
                        onChange={(e) =>
                          handleFieldChange("sanitaria", "asl_riferimento", e.target.value)
                        }
                        placeholder="Es. ASL Roma 1"
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900">
                        {sanitaria.asl_riferimento?.trim() ? sanitaria.asl_riferimento : "N/D"}
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t">
                  <div className="md:col-span-2">
                    <Label className="text-slate-500 text-xs">Indirizzo studio medico</Label>
                    {isEditing ? (
                      <Input
                        key={`san-med-indirizzo-${editSessionKey}`}
                        className="mt-1"
                        defaultValue={sanitariaEditing.medico_curante_indirizzo_studio || ""}
                        onChange={(e) =>
                          handleFieldChange(
                            "sanitaria",
                            "medico_curante_indirizzo_studio",
                            e.target.value
                          )
                        }
                        placeholder="Via, CAP, città dello studio medico"
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900">
                        {sanitaria.medico_curante_indirizzo_studio?.trim()
                          ? sanitaria.medico_curante_indirizzo_studio
                          : "N/D"}
                      </p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Telefono medico curante</Label>
                    {isEditing ? (
                      <Input
                        key={`san-med-tel-${editSessionKey}`}
                        type="tel"
                        className="mt-1"
                        defaultValue={sanitariaEditing.medico_curante_telefono || ""}
                        onChange={(e) =>
                          handleFieldChange(
                            "sanitaria",
                            "medico_curante_telefono",
                            e.target.value
                          )
                        }
                        placeholder="Es. +39 …"
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900">
                        {sanitaria.medico_curante_telefono?.trim()
                          ? sanitaria.medico_curante_telefono
                          : "N/D"}
                      </p>
                    )}
                  </div>
                  <div>
                    <Label className="text-slate-500 text-xs">Email personale medico</Label>
                    {isEditing ? (
                      <Input
                        key={`san-med-email-${editSessionKey}`}
                        type="email"
                        className="mt-1"
                        defaultValue={sanitariaEditing.medico_curante_email_personale || ""}
                        onChange={(e) =>
                          handleFieldChange(
                            "sanitaria",
                            "medico_curante_email_personale",
                            e.target.value
                          )
                        }
                        placeholder="Email personale del medico"
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900 break-all">
                        {sanitaria.medico_curante_email_personale?.trim()
                          ? sanitaria.medico_curante_email_personale
                          : "N/D"}
                      </p>
                    )}
                  </div>
                  <div className="md:col-span-2">
                    <Label className="text-slate-500 text-xs">Email blisteraggio medico</Label>
                    {isEditing ? (
                      <Input
                        key={`san-med-email-blister-${editSessionKey}`}
                        type="email"
                        className="mt-1"
                        defaultValue={sanitariaEditing.medico_curante_email_blisteraggio || ""}
                        onChange={(e) =>
                          handleFieldChange(
                            "sanitaria",
                            "medico_curante_email_blisteraggio",
                            e.target.value
                          )
                        }
                        placeholder="Email per comunicazioni blisteraggio"
                      />
                    ) : (
                      <p className="font-medium mt-1 text-slate-900 break-all">
                        {sanitaria.medico_curante_email_blisteraggio?.trim()
                          ? sanitaria.medico_curante_email_blisteraggio
                          : "N/D"}
                      </p>
                    )}
                  </div>
                </div>
                </div>

                {/* RICHIESTA RSA — flag + allegati */}
                <div className="lg:col-span-2 rounded-xl border border-violet-200 bg-violet-50/60 p-4 space-y-3">
                  <div className="flex items-center gap-2">
                    <Home className="w-4 h-4 text-violet-600 flex-shrink-0" aria-hidden />
                    <span className="text-sm font-semibold text-slate-900 tracking-tight">
                      RICHIESTA RSA
                    </span>
                  </div>
                  <p className="text-xs text-slate-600">
                    Segnala se è stata avviata o è in corso la richiesta di ingresso in residenza
                    sanitaria (RSA). Puoi allegare modulistica o documentazione.
                  </p>
                  {isEditing ? (
                    <div className="flex items-start gap-3">
                      <Checkbox
                        key={`rsa-chk-${editSessionKey}`}
                        id={`richiesta-rsa-${id}`}
                        defaultChecked={!!cartella?.sanitaria?.richiesta_rsa}
                        onCheckedChange={(v) =>
                          handleFieldChange("sanitaria", "richiesta_rsa", v === true)
                        }
                        className="mt-0.5"
                      />
                      <Label
                        htmlFor={`richiesta-rsa-${id}`}
                        className="text-sm font-normal text-slate-800 leading-snug cursor-pointer"
                      >
                        Richiesta RSA indicata / in corso
                      </Label>
                    </div>
                  ) : (
                    <p className="text-sm">
                      <span className="text-slate-500 text-xs uppercase mr-2">Stato</span>
                      {sanitaria.richiesta_rsa ? (
                        <Badge className="bg-violet-600 hover:bg-violet-600">Sì</Badge>
                      ) : (
                        <span className="text-slate-600">No</span>
                      )}
                    </p>
                  )}
                  <div className="pt-2 border-t border-violet-200/80">
                    <Label className="text-slate-700 text-sm font-medium flex items-center gap-2 mb-2">
                      <Paperclip className="w-4 h-4 text-violet-600" />
                      Documenti richiesta RSA
                    </Label>
                    <p className="text-xs text-slate-600 mb-2">
                      Moduli, verbali o altro (PDF, immagini, Office)
                    </p>
                    <div className="mt-1">
                      {documenti?.filter((d) => d.sezione === "richiesta_rsa").length > 0 ? (
                        <div className="space-y-2">
                          {documenti
                            .filter((d) => d.sezione === "richiesta_rsa")
                            .map((doc) => (
                              <div
                                key={doc.file_id}
                                className="flex items-center gap-3 p-2 bg-white/80 rounded-lg border border-violet-100 hover:bg-violet-50/80 transition-colors"
                              >
                                <div className="w-9 h-9 rounded-lg bg-violet-100 flex items-center justify-center flex-shrink-0">
                                  {[".jpg", ".jpeg", ".png", ".gif"].includes(doc.file_ext) ? (
                                    <Image className="w-4 h-4 text-violet-700" />
                                  ) : (
                                    <File className="w-4 h-4 text-violet-700" />
                                  )}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="font-medium text-slate-900 text-sm truncate">
                                    {doc.file_name}
                                  </p>
                                  <p className="text-xs text-slate-500">
                                    {(doc.file_size / 1024).toFixed(1)} KB
                                  </p>
                                </div>
                                <div className="flex gap-1">
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => handleViewDocument(doc)}
                                    className="text-violet-700 hover:bg-violet-100"
                                    title="Visualizza"
                                  >
                                    <Eye className="w-4 h-4" />
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => handleDownloadDocument(doc)}
                                    className="text-emerald-600 hover:bg-emerald-100"
                                    title="Scarica"
                                  >
                                    <Download className="w-4 h-4" />
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => handleDeleteDocument(doc.file_id)}
                                    className="text-red-600 hover:bg-red-100"
                                    title="Elimina"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </Button>
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : null}
                      <input
                        ref={richiestaRsaFileInputRef}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                        className="hidden"
                        onChange={handleUploadRichiestaRsa}
                        id="richiesta-rsa-upload"
                      />
                      <label
                        htmlFor="richiesta-rsa-upload"
                        className={`inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-violet-300 bg-white text-violet-700 hover:bg-violet-50 h-9 px-4 mt-2 cursor-pointer ${uploadingRichiestaRsa ? "opacity-50 pointer-events-none" : ""}`}
                      >
                        {uploadingRichiestaRsa ? (
                          <Loader2 className="w-4 h-4 animate-spin" />
                        ) : (
                          <Upload className="w-4 h-4" />
                        )}
                        Allega documento
                      </label>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <CambioMedicoSection
              fascicoloId={id}
              token={token}
              canEdit={hasPermission("fascicolo:update")}
              onRefresh={reloadCartella}
              onMedicoCuranteChange={(medico) => {
                const draft = editDraftRef.current;
                if (!draft?.sanitaria) return;
                draft.sanitaria.doctor_id = medico?.doctor_id || null;
                draft.sanitaria.medico_curante = medico?.nome || "";
                draft.sanitaria.medico_curante_telefono = medico?.telefono || "";
                draft.sanitaria.medico_curante_email_personale = medico?.email || "";
                draft.sanitaria.medico_curante_email_blisteraggio = medico?.email_blisteraggio || "";
                draft.sanitaria.medico_curante_indirizzo_studio = medico?.indirizzo || "";
                if (medico?.asl) draft.sanitaria.asl_riferimento = medico.asl;
              }}
            />

            <Card className="mt-6 rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Send className="w-5 h-5 text-purple-600" />
                  Comunicazioni al medico curante
                </CardTitle>
              </CardHeader>
              <CardContent>
                {comunicazioniMediche.length === 0 ? (
                  <p className="text-sm text-slate-500">
                    Nessuna comunicazione registrata verso il medico/referente.
                  </p>
                ) : (
                  <div className="overflow-x-auto -mx-1">
                    <table className="w-full min-w-[640px] text-sm">
                      <thead>
                        <tr className="text-left text-xs text-slate-500 border-b border-slate-100">
                          <th className="pb-2 pr-3 font-medium">Data</th>
                          <th className="pb-2 pr-3 font-medium">Operatore</th>
                          <th className="pb-2 pr-3 font-medium">Destinatario</th>
                          <th className="pb-2 pr-3 font-medium">Oggetto</th>
                          <th className="pb-2 pr-3 font-medium">Allegati</th>
                          <th className="pb-2 pr-3 font-medium">Esito</th>
                          <th className="pb-2 font-medium text-right">Azioni</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-50">
                        {comunicazioniMediche.map((comm) => (
                          <tr key={comm.id || comm.sent_at} className="text-slate-700">
                            <td className="py-2.5 pr-3 whitespace-nowrap tabular-nums text-xs">
                              {comm.sent_at
                                ? new Date(comm.sent_at).toLocaleString("it-IT", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "—"}
                            </td>
                            <td className="py-2.5 pr-3 text-xs">
                              {comm.sent_by_name || "—"}
                            </td>
                            <td className="py-2.5 pr-3 text-xs">
                              <div className="max-w-[140px] truncate" title={comm.recipient_name}>
                                {comm.recipient_name || "—"}
                              </div>
                              {comm.recipient_email ? (
                                <div className="text-[10px] text-slate-400 truncate max-w-[140px]">
                                  {comm.recipient_email}
                                </div>
                              ) : null}
                            </td>
                            <td className="py-2.5 pr-3 text-xs max-w-[160px] truncate" title={comm.oggetto}>
                              {comm.oggetto || "—"}
                            </td>
                            <td className="py-2.5 pr-3 text-xs">
                              {comm.allegato?.nome ? (
                                <span className="inline-flex items-center gap-1 text-purple-700">
                                  <Paperclip className="w-3 h-3 shrink-0" />
                                  <span className="truncate max-w-[100px]">{comm.allegato.nome}</span>
                                </span>
                              ) : (
                                "—"
                              )}
                            </td>
                            <td className="py-2.5 pr-3">
                              <Badge
                                className={
                                  comm.esito === "inviata"
                                    ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-100"
                                    : "bg-red-100 text-red-800 hover:bg-red-100"
                                }
                              >
                                {comm.esito === "inviata" ? "Inviata" : "Fallita"}
                              </Badge>
                            </td>
                            <td className="py-2.5 text-right whitespace-nowrap">
                              <div className="flex items-center justify-end gap-0.5">
                                <Button
                                  type="button"
                                  variant="ghost"
                                  size="icon"
                                  className="h-7 w-7 text-slate-400 hover:text-purple-700"
                                  title="Visualizza comunicazione"
                                  onClick={() => {
                                    setSelectedComunicazioneMedica(comm);
                                    setShowComunicazioneMedicaModal(true);
                                  }}
                                >
                                  <Eye className="w-3.5 h-3.5" />
                                </Button>
                                {comm.allegato?.file_id ? (
                                  <Button
                                    type="button"
                                    variant="ghost"
                                    size="icon"
                                    className="h-7 w-7 text-slate-400 hover:text-purple-700"
                                    title="Scarica allegato"
                                    onClick={() => handleDownloadComunicazioneAllegato(comm.allegato)}
                                  >
                                    <Download className="w-3.5 h-3.5" />
                                  </Button>
                                ) : null}
                                <Button
                                  type="button"
                                  variant="ghost"
                                  size="icon"
                                  className="h-7 w-7 text-slate-400 hover:text-purple-700"
                                  title="Stampa / esporta"
                                  onClick={() => {
                                    setSelectedComunicazioneMedica(comm);
                                    setShowComunicazioneMedicaModal(true);
                                    setTimeout(() => window.print(), 300);
                                  }}
                                >
                                  <Printer className="w-3.5 h-3.5" />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardContent>
            </Card>

          <div className="mt-6">
            <TerapieInCorsoSection
              fascicoloId={id}
              terapieInCorso={cartella?.sanitaria?.terapie_in_corso || []}
              ospiteInfo={{
                nome: anagrafica.nome,
                cognome: anagrafica.cognome,
                data_nascita: anagrafica.data_nascita,
                sesso: anagrafica.sesso,
                codice_fiscale: anagrafica.codice_fiscale,
                camera: formatCameraAssegnata(cartella?.camera) || cartella?.camera,
                numero_cartella: amministrativa.numero_cartella,
              }}
              mode="admin"
              authHeaders={{ Authorization: `Bearer ${token}` }}
              onRefresh={reloadCartella}
              proposteRefreshSignal={proposteRefreshSignal}
            />
          </div>

            <Card className="mt-6 rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Activity className="w-5 h-5 text-blue-500" />
                  Ausili
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div>
                  <Label className="text-slate-500 text-xs">Ausili utilizzati</Label>
                  {isEditing ? (
                    <div className="mt-1">
                      <TagListEditor
                        values={editAusiliList}
                        onChange={setEditAusiliList}
                        placeholder="Es. Deambulatore — premi Invio o Aggiungi"
                      />
                    </div>
                  ) : (sanitaria.ausili_utilizzati || []).some((a) =>
                      String(a ?? "").trim()
                    ) ? (
                    <div className="flex flex-wrap gap-2 mt-2">
                      {(sanitaria.ausili_utilizzati || [])
                        .filter((a) => String(a ?? "").trim())
                        .map((a, idx) => (
                        <Badge key={idx} variant="outline" className="py-2">{a}</Badge>
                      ))}
                    </div>
                  ) : (
                    <p className="text-slate-400 mt-2">Nessun ausilio</p>
                  )}
                </div>
              </CardContent>
            </Card>

            <Card className="mt-6 rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardContent className="space-y-4 pt-6">
                {/* Allegati Terapie e Ausili (file/foto, senza scadenza) */}
                <div>
                  <Label className="text-slate-700 text-sm font-medium flex items-center gap-2 mb-2">
                    <Paperclip className="w-4 h-4 text-blue-500" />
                    Documenti Terapie e Ausili
                  </Label>
                  <p className="text-xs text-slate-500 mb-2">
                    Allegati relativi a terapie o ausili
                  </p>
                  <div className="mt-1">
                    {documenti?.filter((d) => d.sezione === "terapie_ausili").length > 0 ? (
                      <div className="space-y-2">
                        {documenti
                          .filter((d) => d.sezione === "terapie_ausili")
                          .map((doc) => (
                            <div
                              key={doc.file_id}
                              className="flex items-center gap-3 p-2 bg-slate-50 rounded-lg border hover:bg-slate-100 transition-colors"
                            >
                              <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                                {[".jpg", ".jpeg", ".png", ".gif"].includes(doc.file_ext) ? (
                                  <Image className="w-4 h-4 text-blue-600" />
                                ) : (
                                  <File className="w-4 h-4 text-blue-600" />
                                )}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-medium text-slate-900 text-sm truncate">
                                  {doc.file_name}
                                </p>
                                <p className="text-xs text-slate-500">
                                  {(doc.file_size / 1024).toFixed(1)} KB
                                </p>
                              </div>
                              <div className="flex gap-1">
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleViewDocument(doc)}
                                  className="text-blue-600 hover:bg-blue-100"
                                  title="Visualizza"
                                >
                                  <Eye className="w-4 h-4" />
                                </Button>
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleDownloadDocument(doc)}
                                  className="text-emerald-600 hover:bg-emerald-100"
                                  title="Scarica"
                                >
                                  <Download className="w-4 h-4" />
                                </Button>
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleDeleteDocument(doc.file_id)}
                                  className="text-red-600 hover:bg-red-100"
                                  title="Elimina"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              </div>
                            </div>
                          ))}
                      </div>
                    ) : null}
                    <input
                      ref={terapieAusiliFileInputRef}
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                      className="hidden"
                      onChange={handleUploadTerapieAusili}
                      id="terapie-ausili-upload"
                    />
                    <label
                      htmlFor="terapie-ausili-upload"
                      className={`inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-blue-300 bg-transparent text-blue-600 hover:bg-blue-50 h-9 px-4 mt-2 cursor-pointer ${uploadingTerapieAusili ? "opacity-50 pointer-events-none" : ""}`}
                    >
                      {uploadingTerapieAusili ? (
                        <Loader2 className="w-4 h-4 animate-spin" />
                      ) : (
                        <Upload className="w-4 h-4" />
                      )}
                      Carica file o foto
                    </label>
                  </div>
                </div>

                {/* Piani terapeutici */}
                <div className="pt-4 border-t">
                  <Label className="text-slate-700 text-sm font-medium flex items-center gap-2 mb-2">
                    <FileText className="w-4 h-4 text-blue-500" />
                    Piani terapeutici
                  </Label>
                  {isEditing ? (
                    <Textarea
                      ref={pianiTerapeuticiTestoRef}
                      key={`san-piani-txt-${editSessionKey}`}
                      defaultValue={cartella?.sanitaria?.piani_terapeutici_testo || ""}
                      className="mt-1"
                      placeholder="Inserisci testo del piano terapeutico..."
                      rows={4}
                    />
                  ) : (
                    <p className="text-slate-700 mt-2 whitespace-pre-wrap">{sanitaria.piani_terapeutici_testo || "Nessun testo inserito"}</p>
                  )}
                  {/* Lista file/foto piani terapeutici */}
                  <div className="mt-3">
                    {documenti?.filter(d => d.sezione === 'piani_terapeutici').length > 0 ? (
                      <div className="space-y-2">
                        {documenti.filter(d => d.sezione === 'piani_terapeutici').map((doc) => (
                          <div
                            key={doc.file_id}
                            className="flex items-center gap-3 p-2 bg-slate-50 rounded-lg border hover:bg-slate-100 transition-colors"
                          >
                            <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                              {['.jpg', '.jpeg', '.png', '.gif'].includes(doc.file_ext) ? (
                                <Image className="w-4 h-4 text-blue-600" />
                              ) : (
                                <File className="w-4 h-4 text-blue-600" />
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="font-medium text-slate-900 text-sm truncate">{doc.file_name}</p>
                              <p className="text-xs text-slate-500">{(doc.file_size / 1024).toFixed(1)} KB</p>
                              {doc.scadenza && (
                                (() => {
                                  const giorni = giorniAllaScadenza(doc.scadenza);
                                  const scadenzaLabel = new Date(doc.scadenza).toLocaleDateString('it-IT');
                                  return (
                                    <div className="text-xs mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-1">
                                      <span className="text-slate-500">Scadenza: {scadenzaLabel}</span>
                                      {giorni !== null && giorni < 0 && (
                                        <Badge variant="destructive" className="text-[10px]">Scaduto</Badge>
                                      )}
                                      {giorni !== null && giorni >= 0 && giorni <= 30 && (
                                        <Badge className="bg-amber-500 text-[10px]">Tra {giorni} gg</Badge>
                                      )}
                                    </div>
                                  );
                                })()
                              )}
                            </div>
                            <div className="flex gap-1">
                              <Button variant="ghost" size="icon" onClick={() => handleViewDocument(doc)} className="text-blue-600 hover:bg-blue-100" title="Visualizza">
                                <Eye className="w-4 h-4" />
                              </Button>
                              <Button variant="ghost" size="icon" onClick={() => handleDownloadDocument(doc)} className="text-emerald-600 hover:bg-emerald-100" title="Scarica">
                                <Download className="w-4 h-4" />
                              </Button>
                              <Button variant="ghost" size="icon" onClick={() => handleDeleteDocument(doc.file_id)} className="text-red-600 hover:bg-red-100" title="Elimina">
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null}
                    <div className="mt-2 flex flex-wrap items-center gap-3">
                      <div className="flex items-center gap-2">
                        <Label htmlFor="scadenza-piano-terapeutico" className="text-slate-600 text-xs whitespace-nowrap">Data di scadenza</Label>
                        <DateFieldInput
                          id="scadenza-piano-terapeutico"
                          value={scadenzaPianoTerapeutico}
                          onChange={setScadenzaPianoTerapeutico}
                          className="max-w-[11rem] [&_input]:rounded-md [&_input]:border-slate-300 [&_input]:text-sm"
                        />
                      </div>
                      <input
                        ref={pianiTerapeuticiFileInputRef}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                        className="hidden"
                        onChange={handleUploadPianoTerapeutico}
                        id="piani-terapeutici-upload"
                      />
                      <label
                      htmlFor="piani-terapeutici-upload"
                      className={`inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium border border-blue-300 bg-transparent text-blue-600 hover:bg-blue-50 h-9 px-4 mt-2 cursor-pointer ${uploadingPianiTerapeutici ? 'opacity-50 pointer-events-none' : ''}`}
                    >
                      {uploadingPianiTerapeutici ? (
                        <Loader2 className="w-4 h-4 animate-spin" />
                      ) : (
                        <Upload className="w-4 h-4" />
                      )}
                      Carica file o foto
                    </label>
                    </div>
                  </div>
                </div>
                
                <div className="pt-4 border-t">
                  <Label className="text-slate-500 text-xs">Note sanitarie</Label>
                  {isEditing ? (
                    <Textarea
                      ref={noteSanitarieRef}
                      key={`san-note-${editSessionKey}`}
                      defaultValue={cartella?.sanitaria?.note_sanitarie || ""}
                      className="mt-2"
                      rows={3}
                      placeholder="Note aggiuntive..."
                    />
                  ) : (
                    <p className="text-slate-700 mt-2">{sanitaria.note_sanitarie || "Nessuna nota"}</p>
                  )}
                </div>
              </CardContent>
            </Card>

          <div className="mt-6">
            <TerapieExtraSection
              fascicoloId={id}
              terapieExtra={cartella?.sanitaria?.terapie_extra || []}
              mode="admin"
              authHeaders={{ Authorization: `Bearer ${token}` }}
              onRefresh={reloadCartella}
              onAlertsChange={setTerapieExtraAlertCount}
            />
          </div>

          {/* Withings BPM Connect - Monitoraggio Pressione */}
          <div className="mt-6">
            <WithingsPressione fascicoloId={id} />
          </div>

          <div className="mt-6 space-y-6">
            <MonitoraggioVitale tipo="glicemia" fascicoloId={id} />
            <MonitoraggioVitale tipo="ossigenazione" fascicoloId={id} />
          </div>
        </TabsContent>

        {/* TAB PAI */}
        <TabsContent value="pai">
          <div className="space-y-6">
            {/* PAI Attivo */}
            {pai_attivo ? (
              <Card className="rounded-2xl border-slate-200 border-l-4 border-l-emerald-500 shadow-none hover:shadow-none">
                <CardHeader>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                    <CardTitle className="flex items-center gap-2 text-lg">
                      <ClipboardList className="w-5 h-5 text-emerald-600" />
                      PAI Attivo
                      <Badge className="bg-emerald-500 text-white">{pai_attivo.stato}</Badge>
                      {isPaiUpload(pai_attivo) && (
                        <Badge variant="outline" className="border-blue-400 text-blue-600 text-xs">
                          <Upload className="w-3 h-3 mr-1" />
                          da file
                        </Badge>
                      )}
                      {isPaiCartaceo(pai_attivo) && (
                        <Badge variant="outline" className="border-purple-400 text-purple-600 text-xs">
                          <ClipboardList className="w-3 h-3 mr-1" />
                          cartaceo
                        </Badge>
                      )}
                    </CardTitle>
                    <div className="flex flex-wrap items-center gap-2">
                      {isPaiUpload(pai_attivo) ? (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={handleOpenPaiFile}
                          className="border-blue-500 text-blue-600 hover:bg-blue-50"
                        >
                          <FileText className="w-4 h-4 sm:mr-1" />
                          <span className="hidden sm:inline">Apri file</span>
                        </Button>
                      ) : isPaiCartaceo(pai_attivo) ? (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleViewPai(pai_attivo)}
                          className="border-purple-500 text-purple-600 hover:bg-purple-50"
                        >
                          <Eye className="w-4 h-4 sm:mr-1" />
                          <span className="hidden sm:inline">Dettagli</span>
                        </Button>
                      ) : (
                        <>
                          <Button 
                            size="sm" 
                            variant="outline"
                            onClick={() => handleViewPai(pai_attivo)}
                            className="border-emerald-500 text-emerald-600 hover:bg-emerald-50"
                          >
                            <Eye className="w-4 h-4 sm:mr-1" />
                            <span className="hidden sm:inline">Visualizza</span>
                          </Button>
                          <Button 
                            size="sm" 
                            variant="outline"
                            onClick={() => handlePrintSavedPai(pai_attivo)}
                            className="border-purple-500 text-purple-600 hover:bg-purple-50"
                          >
                            <Printer className="w-4 h-4 sm:mr-1" />
                            <span className="hidden sm:inline">Stampa</span>
                          </Button>
                        </>
                      )}
                      <Button 
                        size="sm" 
                        onClick={() => setShowValutazioneModal(true)}
                        className="bg-purple-600 hover:bg-purple-700"
                      >
                        <Plus className="w-4 h-4 sm:mr-1" />
                        <span className="hidden sm:inline">Valutazione</span>
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div>
                      <Label className="text-slate-500 text-xs">Data redazione</Label>
                      <p className="font-medium">{new Date(pai_attivo.data_redazione).toLocaleDateString('it-IT')}</p>
                    </div>
                    <div>
                      <Label className="text-slate-500 text-xs">Scadenza</Label>
                      <p className="font-medium">{new Date(pai_attivo.data_scadenza).toLocaleDateString('it-IT')}</p>
                    </div>
                    <div>
                      <Label className="text-slate-500 text-xs">Redatto da</Label>
                      <p className="font-medium">{pai_attivo.redatto_da}</p>
                    </div>
                  </div>

                  {isPaiCartaceo(pai_attivo) && (
                    <p className="text-sm text-purple-700 mb-4 bg-purple-50 border border-purple-200 rounded-lg p-3">
                      PAI redatto in cartaceo e custodito in archivio fisico — nessun file digitale caricato.
                    </p>
                  )}

                  {/* Obiettivi */}
                  {!isPaiCartaceo(pai_attivo) && (
                  <div className="space-y-4">
                    <Label className="text-slate-900 font-semibold">Obiettivi assistenziali</Label>
                    {pai_attivo.obiettivi && pai_attivo.obiettivi.map((obj) => (
                      <div key={obj.id} className="p-4 bg-slate-50 rounded-xl">
                        <div className="flex items-start justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <Target className="w-4 h-4 text-purple-600" />
                            <Badge variant="outline">{obj.area}</Badge>
                          </div>
                          <Badge className={
                            obj.stato === 'Raggiunto' ? 'bg-emerald-500 text-white' :
                            obj.stato === 'In corso' ? 'bg-blue-500 text-white' :
                            'bg-slate-500 text-white'
                          }>
                            {obj.stato === 'Raggiunto' && <Check className="w-3 h-3 mr-1" />}
                            {obj.stato === 'In corso' && <Clock className="w-3 h-3 mr-1" />}
                            {obj.stato}
                          </Badge>
                        </div>
                        <p className="font-medium text-slate-900 mb-2">{obj.obiettivo}</p>
                        <div className="text-sm text-slate-600">
                          <p><span className="font-medium">Interventi:</span> {obj.interventi.join(', ')}</p>
                          <p><span className="font-medium">Frequenza:</span> {obj.frequenza}</p>
                          <p><span className="font-medium">Responsabile:</span> {obj.responsabile}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  )}

                  {pai_attivo.note_generali && (
                    <div className="mt-4 pt-4 border-t">
                      <Label className="text-slate-500 text-xs">Note generali</Label>
                      <p className="text-slate-700 mt-1">{pai_attivo.note_generali}</p>
                    </div>
                  )}
                </CardContent>
              </Card>
            ) : (
              <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
                <CardContent className="p-8 text-center">
                  <ClipboardList className="w-12 h-12 text-slate-300 mx-auto mb-4" />
                  <p className="text-slate-500 mb-4">Nessun PAI attivo</p>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Button 
                      className="bg-purple-600 hover:bg-purple-700"
                      onClick={openPaiWizard}
                      data-testid="btn-crea-pai"
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Crea nuovo PAI
                    </Button>
                    {!cartella?.pai_upload_usato && (
                      <Button
                        variant="outline"
                        className="border-purple-500 text-purple-600 hover:bg-purple-50"
                        onClick={() => setShowPaiUploadModal(true)}
                        data-testid="btn-carica-pai"
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        Carica PAI da file
                      </Button>
                    )}
                  </div>

                  {!cartella?.pai_upload_usato && hasPermission("pai:create") && (
                    <div className="mt-8 pt-6 border-t border-dashed border-slate-200 text-left max-w-xl mx-auto">
                      <p className="text-sm font-medium text-purple-900 mb-2">
                        PAI cartaceo già in archivio (senza upload)
                      </p>
                      <p className="text-xs text-slate-600 mb-4">
                        Se il PAI è redatto in cartaceo e custodito in archivio fisico, indica la data di redazione
                        e conferma l&apos;attestazione. La scadenza viene calcolata automaticamente (+180 giorni).
                      </p>
                      <div className="space-y-4 rounded-lg border border-purple-200 bg-purple-50/50 p-4">
                        <div className="flex items-start gap-2.5">
                          <Checkbox
                            id={`pai-cartaceo-${id}`}
                            checked={paiCartaceoAttestato}
                            onCheckedChange={(v) => setPaiCartaceoAttestato(v === true)}
                            className="mt-0.5"
                          />
                          <Label
                            htmlFor={`pai-cartaceo-${id}`}
                            className="text-sm font-normal text-slate-800 leading-snug cursor-pointer"
                          >
                            Confermo che il PAI redatto in cartaceo è in archivio fisico della struttura
                          </Label>
                        </div>
                        {paiCartaceoAttestato && (
                          <div className="space-y-2 pl-6">
                            <Label className="text-slate-600 text-xs">Data di redazione</Label>
                            <DateFieldInput
                              value={paiCartaceoDataRedazione}
                              onChange={setPaiCartaceoDataRedazione}
                              className="max-w-xs"
                            />
                            {paiCartaceoDataRedazione && (
                              <p className="text-xs text-slate-500">
                                Scadenza prevista:{" "}
                                <strong>
                                  {new Date(addDaysToIsoDate(paiCartaceoDataRedazione, 180)).toLocaleDateString("it-IT")}
                                </strong>
                              </p>
                            )}
                          </div>
                        )}
                        <Button
                          size="sm"
                          onClick={handleSavePaiCartaceo}
                          disabled={savingPaiCartaceo}
                          className="bg-purple-600 hover:bg-purple-700"
                        >
                          {savingPaiCartaceo ? "Salvataggio..." : "Salva attestazione PAI cartaceo"}
                        </Button>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            )}

            {pai_attivo && isPaiCartaceo(pai_attivo) && hasPermission("pai:create") && (
              <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
                <CardHeader>
                  <CardTitle className="text-base text-purple-900">Attestazione PAI cartaceo</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-sm text-slate-600">
                    Puoi aggiornare la data di redazione o rimuovere l&apos;attestazione se il PAI non è più valido.
                  </p>
                  <div className="flex items-start gap-2.5">
                    <Checkbox
                      id={`pai-cartaceo-edit-${id}`}
                      checked={paiCartaceoAttestato}
                      onCheckedChange={(v) => setPaiCartaceoAttestato(v === true)}
                      className="mt-0.5"
                    />
                    <Label
                      htmlFor={`pai-cartaceo-edit-${id}`}
                      className="text-sm font-normal text-slate-800 leading-snug cursor-pointer"
                    >
                      Confermo che il PAI redatto in cartaceo è in archivio fisico della struttura
                    </Label>
                  </div>
                  {paiCartaceoAttestato && (
                    <div className="space-y-2 pl-6">
                      <Label className="text-slate-600 text-xs">Data di redazione</Label>
                      <DateFieldInput
                        value={paiCartaceoDataRedazione}
                        onChange={setPaiCartaceoDataRedazione}
                        className="max-w-xs"
                      />
                      {paiCartaceoDataRedazione && (
                        <p className="text-xs text-slate-500">
                          Scadenza prevista:{" "}
                          <strong>
                            {new Date(addDaysToIsoDate(paiCartaceoDataRedazione, 180)).toLocaleDateString("it-IT")}
                          </strong>
                        </p>
                      )}
                    </div>
                  )}
                  <Button
                    size="sm"
                    onClick={handleSavePaiCartaceo}
                    disabled={savingPaiCartaceo}
                    className="bg-purple-600 hover:bg-purple-700"
                  >
                    {savingPaiCartaceo ? "Salvataggio..." : "Salva attestazione PAI cartaceo"}
                  </Button>
                </CardContent>
              </Card>
            )}


            {/* Valutazioni PAI */}
            {valutazioni && valutazioni.length > 0 && (
              <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-lg">
                    <Activity className="w-5 h-5 text-purple-600" />
                    Valutazioni PAI
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    {valutazioni.filter(v => !v.archiviata).map((val) => (
                      <div key={val.id} className="p-4 border rounded-xl hover:bg-slate-50 transition-colors">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                          <div className="flex items-center gap-2 flex-wrap">
                            <Calendar className="w-4 h-4 text-slate-400" />
                            <span className="font-medium">{new Date(val.data_valutazione).toLocaleDateString('it-IT')}</span>
                            <span className="text-slate-400 hidden sm:inline">•</span>
                            <span className="text-slate-600 text-sm">{val.valutatore}</span>
                          </div>
                          <div className="flex items-center gap-1.5 flex-wrap">
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => handleViewValutazione(val)}
                              className="border-purple-300 text-purple-600 hover:bg-purple-50 px-2 sm:px-3"
                            >
                              <Eye className="w-4 h-4 sm:mr-1" />
                              <span className="hidden sm:inline">Visualizza</span>
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => handlePrintValutazione(val)}
                              className="border-purple-300 text-purple-600 hover:bg-purple-50 px-2 sm:px-3"
                            >
                              <Printer className="w-4 h-4 sm:mr-1" />
                              <span className="hidden sm:inline">Stampa</span>
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => handleArchiviaValutazione(val.id)}
                              className="border-amber-300 text-amber-600 hover:bg-amber-50 px-2 sm:px-3"
                            >
                              <Archive className="w-4 h-4 sm:mr-1" />
                              <span className="hidden sm:inline">Archivia</span>
                            </Button>
                            <Badge className={
                              val.esito === 'Positivo' ? 'bg-emerald-500 text-white' :
                              val.esito === 'Parziale' ? 'bg-amber-500 text-white' :
                              'bg-red-500 text-white'
                            }>
                              {val.esito}
                            </Badge>
                          </div>
                        </div>
                        <p className="text-slate-700 mb-2">{val.note_generali || val.note}</p>
                        {val.raccomandazioni && (
                          <p className="text-sm text-slate-500 italic">
                            <span className="font-medium">Raccomandazioni:</span> {val.raccomandazioni}
                          </p>
                        )}
                      </div>
                    ))}
                    
                    {/* Valutazioni Archiviate */}
                    {valutazioni.filter(v => v.archiviata).length > 0 && (
                      <div className="mt-6 pt-6 border-t">
                        <h4 className="text-sm font-semibold text-slate-500 mb-3 flex items-center gap-2">
                          <Archive className="w-4 h-4" />
                          Valutazioni Archiviate ({valutazioni.filter(v => v.archiviata).length})
                        </h4>
                        <div className="space-y-3">
                          {valutazioni.filter(v => v.archiviata).map((val) => (
                            <div key={val.id} className="p-3 border rounded-lg bg-slate-50/50 opacity-75">
                              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                                <div className="flex items-center gap-2 flex-wrap">
                                  <Calendar className="w-4 h-4 text-slate-400" />
                                  <span className="text-sm">{new Date(val.data_valutazione).toLocaleDateString('it-IT')}</span>
                                  <span className="text-slate-400 hidden sm:inline">•</span>
                                  <span className="text-sm text-slate-500">{val.valutatore}</span>
                                  <Badge variant="outline" className="text-xs">
                                    {val.esito}
                                  </Badge>
                                </div>
                                <div className="flex items-center gap-1.5">
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    onClick={() => handleViewValutazione(val)}
                                    className="border-slate-300 text-slate-600 hover:bg-slate-100 h-8"
                                    title="Visualizza"
                                  >
                                    <Eye className="w-3 h-3" />
                                  </Button>
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    onClick={() => handleRipristinaValutazione(val.id)}
                                    className="border-emerald-300 text-emerald-600 hover:bg-emerald-50 h-8"
                                    title="Ripristina"
                                  >
                                    <RotateCcw className="w-3 h-3" />
                                  </Button>
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    onClick={() => handleDeleteValutazione(val.id)}
                                    className="border-red-300 text-red-600 hover:bg-red-50 h-8"
                                    title="Elimina definitivamente"
                                  >
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </TabsContent>

        {/* TAB STORICO */}
        {/* TAB DOCUMENTI */}
        <TabsContent value="documenti">
          <Card className="rounded-2xl border-slate-200 shadow-none hover:shadow-none">
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="flex items-center gap-2 text-lg">
                <Paperclip className="w-5 h-5 text-blue-600" />
                Documenti Allegati
              </CardTitle>
              <div className="flex flex-wrap justify-end gap-2">
                {cartella?.stato_ospite === "PRE_INGRESSO" && hasPermission("fascicolo:update") && (
                  <Button
                    type="button"
                    variant="outline"
                    className="border-emerald-300 text-emerald-700 hover:bg-emerald-50"
                    onClick={() => setShowRichiestaDocumentiDialog(true)}
                  >
                    <Send className="w-4 h-4 mr-2" />
                    {preIngressoCard?.portal_link ? "Reinvia link documenti" : "Richiedi documenti"}
                  </Button>
                )}
                {documenti.length > 0 && (
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => setShowStampaDocumentiDialog(true)}
                  >
                    <Printer className="w-4 h-4 mr-2" />
                    Stampa documenti
                  </Button>
                )}
                <Button
                  onClick={() => setShowUploadModal(true)}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  <Upload className="w-4 h-4 mr-2" />
                  Carica Documento
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {cartella?.stato_ospite === "PRE_INGRESSO" && (
                <div className="mb-8 rounded-xl border border-emerald-200 bg-emerald-50/70 p-4">
                  <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                    <div>
                      <h3 className="text-base font-semibold text-emerald-900 flex items-center gap-2">
                        <Mail className="w-5 h-5 text-emerald-700" />
                        Richiesta documentazione al familiare
                      </h3>
                      <p className="mt-1 text-sm text-emerald-800">
                        Controlla rapidamente cosa e' stato richiesto e cosa e' gia' arrivato dal link inviato al familiare.
                      </p>
                    </div>
                    {preIngressoCard?.portal_link && (
                      <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        className="shrink-0 border-emerald-300 text-emerald-700 hover:bg-emerald-100"
                        onClick={() => navigator.clipboard.writeText(preIngressoCard.portal_link).then(
                          () => toast.success("Link copiato negli appunti"),
                          () => toast.error("Impossibile copiare il link")
                        )}
                      >
                        Copia link caricamento
                      </Button>
                    )}
                  </div>

                  {requestedPreIngressoDocs.length > 0 ? (
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
                      {requestedPreIngressoFileDocs.map((doc) => (
                        <div key={doc.key} className="flex items-center justify-between rounded-lg border bg-white p-3">
                          <div className="min-w-0">
                            <p className="text-sm font-medium text-slate-900 truncate">{doc.label}</p>
                            <p className="text-xs text-slate-500">{LABEL_DOCUMENTO_SEZIONE[doc.sezione] || doc.sezione}</p>
                          </div>
                          <Badge className={doc.status === "received" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}>
                            {doc.status === "received" ? "Ricevuto" : "Mancante"}
                          </Badge>
                        </div>
                      ))}
                      {requestedPreIngressoTherapy && (
                        <div className="flex items-center justify-between rounded-lg border bg-white p-3">
                          <div className="min-w-0">
                            <p className="text-sm font-medium text-slate-900 truncate">{requestedPreIngressoTherapy.label}</p>
                            <p className="text-xs text-slate-500">Terapia</p>
                          </div>
                          <Badge className={preIngressoCard?.terapia?.ricevuta ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}>
                            {preIngressoCard?.terapia?.ricevuta ? "Ricevuta" : "Mancante"}
                          </Badge>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="mt-4 rounded-lg border border-dashed border-emerald-300 bg-white/70 p-4 text-sm text-emerald-800">
                      Nessun link documenti ancora inviato. Usa "Richiedi documenti" per selezionare la documentazione e inviarla al familiare.
                    </div>
                  )}
                </div>
              )}

              {/* SEZIONE: Contratto Firmato */}
              <div className="mb-8">
                <h3 className="text-base font-semibold text-slate-800 mb-4 flex items-center gap-2 pb-2 border-b">
                  <FileText className="w-5 h-5 text-emerald-600" />
                  Contratto Firmato
                </h3>
                <div className="bg-emerald-50 rounded-lg p-4 border border-emerald-200">
                  {documenti?.filter(d => d.sezione === 'contratto_firmato').length > 0 ? (
                    <div className="space-y-2">
                      {documenti.filter(d => d.sezione === 'contratto_firmato').map(doc => (
                        <div key={doc.file_id} className="flex items-center justify-between bg-white rounded p-3">
                          <div className="flex items-center gap-2">
                            <File className="w-4 h-4 text-emerald-600" />
                            <span className="truncate">{doc.file_name}</span>
                          </div>
                          <div className="flex gap-1">
                            <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => handleViewDocument(doc)}>
                              <Eye className="w-4 h-4" />
                            </Button>
                            {hasPermission("fascicolo:update") && isScanCleanable(doc) && (
                              <Button
                                variant="ghost"
                                size="icon"
                                className="h-8 w-8 text-violet-600"
                                title="Pulisci scansione"
                                onClick={() => { setPulisciScansioneDoc(doc); setShowPulisciScansione(true); }}
                              >
                                <Sparkles className="w-4 h-4" />
                              </Button>
                            )}
                            <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => handleDownloadDocument(doc)}>
                              <Download className="w-4 h-4" />
                            </Button>
                            <Button variant="ghost" size="icon" className="h-8 w-8 text-red-500" onClick={() => handleDeleteDocument(doc.file_id)}>
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : cartella?.contratto_cartaceo?.attestato ? (
                    <p className="text-sm text-emerald-700">
                      Nessun file caricato — contratto cartaceo attestato in archivio
                      {cartella.contratto_cartaceo.data_firma && (
                        <> (firma del {new Date(cartella.contratto_cartaceo.data_firma).toLocaleDateString("it-IT")})</>
                      )}
                    </p>
                  ) : (
                    <p className="text-sm text-emerald-700">Nessun contratto firmato caricato</p>
                  )}
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="mt-3 border-emerald-400 text-emerald-700 hover:bg-emerald-100"
                    onClick={() => { setUploadSezione('contratto_firmato'); setShowUploadModal(true); }}
                  >
                    <Upload className="w-3 h-3 mr-2" /> Carica Contratto Firmato
                  </Button>

                  <div className="mt-5 pt-4 border-t border-emerald-200 border-dashed">
                    <p className="text-sm font-medium text-emerald-900 mb-3">
                      Contratto cartaceo già in archivio (senza upload)
                    </p>
                    <p className="text-xs text-emerald-800 mb-4">
                      Se il contratto firmato è già custodito in cartaceo, indica la data di firma e conferma l&apos;attestazione.
                      L&apos;attestazione ha validità <strong>12 mesi</strong> dalla data di firma.
                    </p>
                    {hasPermission("fascicolo:update") ? (
                      <div className="space-y-4 rounded-lg border border-emerald-200 bg-white p-4">
                        <div className="flex items-start gap-2.5">
                          <Checkbox
                            id={`contratto-cartaceo-${id}`}
                            checked={contrattoCartaceoAttestato}
                            onCheckedChange={(v) => setContrattoCartaceoAttestato(v === true)}
                            className="mt-0.5"
                          />
                          <Label
                            htmlFor={`contratto-cartaceo-${id}`}
                            className="text-sm font-normal text-slate-800 leading-snug cursor-pointer"
                          >
                            Confermo che il contratto firmato in cartaceo è in archivio fisico della struttura
                          </Label>
                        </div>
                        {contrattoCartaceoAttestato && (
                          <div className="space-y-2 pl-6">
                            <Label className="text-slate-600 text-xs">Data firma cartacea</Label>
                            <DateFieldInput
                              value={contrattoCartaceoDataFirma}
                              onChange={setContrattoCartaceoDataFirma}
                              className="max-w-xs"
                            />
                            {contrattoCartaceoDataFirma && (
                              <p className="text-xs text-slate-600">
                                Scadenza attestazione:{" "}
                                <span className="font-medium">
                                  {new Date(addMonthsToIsoDate(contrattoCartaceoDataFirma, 12)).toLocaleDateString("it-IT")}
                                </span>{" "}
                                (12 mesi dalla firma)
                              </p>
                            )}
                          </div>
                        )}
                        <Button
                          size="sm"
                          className="bg-emerald-700 hover:bg-emerald-800"
                          onClick={handleSaveContrattoCartaceo}
                          disabled={savingContrattoCartaceo}
                        >
                          {savingContrattoCartaceo ? "Salvataggio..." : "Salva attestazione cartacea"}
                        </Button>
                        {cartella?.contratto_cartaceo?.attestato && (
                          <div className="text-xs text-slate-500 pt-1 border-t border-slate-100">
                            Ultima registrazione
                            {cartella.contratto_cartaceo.attestato_by_name
                              ? ` da ${cartella.contratto_cartaceo.attestato_by_name}`
                              : ""}
                            {cartella.contratto_cartaceo.scadenza && (
                              <>
                                {" "}
                                — validità fino al{" "}
                                {new Date(cartella.contratto_cartaceo.scadenza).toLocaleDateString("it-IT")}
                              </>
                            )}
                            {renderScadenzaBadge(cartella.contratto_cartaceo.scadenza)}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="rounded-lg border border-emerald-200 bg-white p-4 text-sm text-slate-700">
                        {cartella?.contratto_cartaceo?.attestato ? (
                          <>
                            <p>
                              Attestazione attiva — firma cartacea del{" "}
                              <span className="font-medium">
                                {cartella.contratto_cartaceo.data_firma
                                  ? new Date(cartella.contratto_cartaceo.data_firma).toLocaleDateString("it-IT")
                                  : "—"}
                              </span>
                            </p>
                            {cartella.contratto_cartaceo.scadenza && (
                              <p className="text-xs text-slate-500 mt-1">
                                Scadenza: {new Date(cartella.contratto_cartaceo.scadenza).toLocaleDateString("it-IT")}
                              </p>
                            )}
                            {renderScadenzaBadge(cartella.contratto_cartaceo.scadenza)}
                          </>
                        ) : (
                          <p>Nessuna attestazione contratto cartaceo registrata.</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* SEZIONE: Altri Documenti Fascicolo */}
              <div>
                <h3 className="text-base font-semibold text-slate-800 mb-1 flex items-center gap-2 pb-2 border-b">
                  <Paperclip className="w-5 h-5 text-slate-600" />
                  Altri Documenti
                </h3>
                <p className="text-xs text-slate-500 mb-4">
                  Sulle foto e sui PDF scansionati, l&apos;icona scintille ritaglia lo sfondo e raddrizza il foglio.
                </p>
              {documenti && documenti.filter(d => d.sezione !== 'contratto_firmato').length > 0 ? (
                <div className="space-y-3">
                  {/* Raggruppa per sezione */}
                  {sezioniAltriDocumenti(documenti).map(sezione => {
                    const docsSezione = documenti.filter(d => (d.sezione || 'generale') === sezione);
                    if (docsSezione.length === 0) return null;
                    return (
                      <div key={sezione} className="mb-6">
                        <h4 className="text-sm font-semibold text-slate-600 uppercase mb-3 flex items-center gap-2">
                          <Badge variant="outline">{LABEL_DOCUMENTO_SEZIONE[sezione] || sezione}</Badge>
                          <span className="text-xs text-slate-400">({docsSezione.length} doc.)</span>
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          {docsSezione.map((doc) => (
                            <div 
                              key={doc.file_id} 
                              className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg border hover:bg-slate-100 transition-colors"
                            >
                              <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                                {['.jpg', '.jpeg', '.png', '.gif'].includes(doc.file_ext) ? (
                                  <Image className="w-5 h-5 text-blue-600" />
                                ) : (
                                  <File className="w-5 h-5 text-blue-600" />
                                )}
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-medium text-slate-900 truncate">{doc.file_name}</p>
                                <p className="text-xs text-slate-500">
                                  {doc.descrizione || 'Nessuna descrizione'}
                                  {Number.isFinite(Number(doc.file_size)) && Number(doc.file_size) > 0
                                    ? ` • ${(Number(doc.file_size) / 1024).toFixed(1)} KB`
                                    : ''}
                                </p>
                              </div>
                              <div className="flex gap-1">
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleViewDocument(doc)}
                                  className="text-blue-600 hover:bg-blue-100"
                                  title="Visualizza"
                                >
                                  <Eye className="w-4 h-4" />
                                </Button>
                                {hasPermission("fascicolo:update") && isScanCleanable(doc) && (
                                  <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => { setPulisciScansioneDoc(doc); setShowPulisciScansione(true); }}
                                    className="text-violet-600 hover:bg-violet-100"
                                    title="Pulisci scansione"
                                  >
                                    <Sparkles className="w-4 h-4" />
                                  </Button>
                                )}
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleDownloadDocument(doc)}
                                  className="text-emerald-600 hover:bg-emerald-100"
                                  title="Scarica"
                                >
                                  <Download className="w-4 h-4" />
                                </Button>
                                <Button
                                  variant="ghost"
                                  size="icon"
                                  onClick={() => handleDeleteDocument(doc.file_id)}
                                  className="text-red-600 hover:bg-red-100"
                                  title="Elimina"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="text-center py-8">
                  <Paperclip className="w-10 h-10 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-400">Nessun altro documento allegato</p>
                </div>
              )}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="costi-ricorrenti">
          <CostiRicorrentiSection fascicoloId={id} token={token} />
        </TabsContent>

        {/* TAB STORICO - Audit Log */}
        <TabsContent value="storico">
          <AuditLogViewer fascicoloId={id} />
          
          {/* Storico legacy (se presente) */}
          {storico_modifiche && storico_modifiche.length > 0 && (
            <Card className="mt-4 rounded-2xl border-slate-200 shadow-none hover:shadow-none">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <History className="w-5 h-5 text-slate-400" />
                  Storico Precedente (Legacy)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {storico_modifiche.map((mod) => (
                    <div key={mod.id} className="flex items-start gap-4 p-3 bg-slate-50 rounded-lg">
                      <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0">
                        <FileText className="w-4 h-4 text-purple-600" />
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="font-medium text-slate-900">{mod.utente}</span>
                          <Badge variant="outline" className="text-xs">{mod.sezione}</Badge>
                        </div>
                        <p className="text-sm text-slate-600">{mod.descrizione}</p>
                        <p className="text-xs text-slate-400 mt-1">{mod.data}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </TabsContent>

        {canFamily ? (
        <TabsContent value="family">
          <FamilyFascicoloPanel fascicoloId={id} token={token} />
        </TabsContent>
        ) : null}
          </div>
          </div>
        </Card>
      </Tabs>

      {/* Dialog trasferimento ospite tra strutture */}
      <Dialog open={showTrasferisciDialog} onOpenChange={setShowTrasferisciDialog}>
        <DialogContent className="max-w-[95vw] sm:max-w-[520px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ArrowRightLeft className="w-5 h-5 text-amber-700" />
              Sposta ospite in altra struttura
            </DialogTitle>
            <DialogDescription>
              L&apos;ospite e tutti i dati collegati (PAI, diario, terapie, documenti) verranno
              spostati nella struttura selezionata. Dopo la conferma passerai automaticamente
              a quella struttura. Le fatture già emesse resteranno in{" "}
              <strong>{activeStruttura?.name || "questa struttura"}</strong> con indicazione del
              trasferimento.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div>
              <Label className="text-slate-600">Struttura di destinazione</Label>
              <Select value={trasferisciDestId} onValueChange={setTrasferisciDestId}>
                <SelectTrigger className="mt-1">
                  <SelectValue placeholder="Seleziona struttura" />
                </SelectTrigger>
                <SelectContent>
                  {struttureDestinazione.map((s) => (
                    <SelectItem key={s.id} value={s.id}>
                      {s.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-slate-600">Note (opzionale)</Label>
              <Textarea
                value={trasferisciNote}
                onChange={(e) => setTrasferisciNote(e.target.value)}
                placeholder="Motivo del trasferimento..."
                className="mt-1"
                rows={3}
              />
            </div>
            <div className="rounded-lg border border-blue-200 bg-blue-50/70 p-3 text-xs text-slate-700">
              Dopo il trasferimento, registra e invia l&apos;ospite ad{" "}
              <strong>Alloggiati Web</strong> nella nuova struttura. Gli invii già effettuati
              restano nello storico della struttura di origine.
            </div>
          </div>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              type="button"
              variant="outline"
              onClick={() => setShowTrasferisciDialog(false)}
              disabled={trasferendo}
            >
              Annulla
            </Button>
            <Button
              type="button"
              className="bg-amber-600 hover:bg-amber-700"
              onClick={handleTrasferisciOspite}
              disabled={trasferendo || !trasferisciDestId}
            >
              {trasferendo ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Trasferimento...
                </>
              ) : (
                <>
                  <ArrowRightLeft className="w-4 h-4 mr-2" />
                  Conferma trasferimento
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog invio email a familiare */}
      <Dialog
        open={Boolean(selectedFamiliareEmail)}
        onOpenChange={(open) => {
          if (!open) closeFamiliareEmailDialog();
        }}
      >
        <DialogContent className="max-w-[95vw] sm:max-w-[520px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Mail className="w-5 h-5 text-blue-600" />
              Invia email al familiare
            </DialogTitle>
            <DialogDescription>
              Destinatario: {selectedFamiliareEmail?.nome || "Familiare"} ({selectedFamiliareEmail?.email})
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-2">
            <div>
              <Label htmlFor="familiare-email-subject">Oggetto</Label>
              <Input
                id="familiare-email-subject"
                value={familiareEmailSubject}
                onChange={(e) => setFamiliareEmailSubject(e.target.value)}
                className="mt-2"
                disabled={sendingFamiliareEmail}
              />
            </div>
            <div>
              <Label htmlFor="familiare-email-text">Testo della mail</Label>
              <Textarea
                id="familiare-email-text"
                value={familiareEmailText}
                onChange={(e) => setFamiliareEmailText(e.target.value)}
                placeholder="Scrivi qui il messaggio da inviare al familiare..."
                rows={8}
                className="mt-2"
                disabled={sendingFamiliareEmail}
              />
            </div>
            <p className="text-xs text-slate-500">
              La mail verrà inviata da info@affidya.it.
            </p>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={closeFamiliareEmailDialog} disabled={sendingFamiliareEmail}>
              Annulla
            </Button>
            <Button
              onClick={handleSendFamiliareEmail}
              disabled={sendingFamiliareEmail || !familiareEmailSubject.trim() || !familiareEmailText.trim()}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {sendingFamiliareEmail ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Invio...
                </>
              ) : (
                <>
                  <Send className="w-4 h-4 mr-2" />
                  Invia mail
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog storico email familiare */}
      <Dialog
        open={Boolean(selectedFamiliareEmailHistory)}
        onOpenChange={(open) => {
          if (!open) setSelectedFamiliareEmailHistory(null);
        }}
      >
        <DialogContent className="max-w-[95vw] sm:max-w-[680px] max-h-[85vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <History className="w-5 h-5 text-blue-600" />
              Storico email inviate
            </DialogTitle>
            <DialogDescription>
              {selectedFamiliareEmailHistory?.nome || "Familiare"} ({selectedFamiliareEmailHistory?.email})
            </DialogDescription>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto space-y-3 py-2">
            {selectedFamiliareEmailHistoryLogs.length > 0 ? (
              selectedFamiliareEmailHistoryLogs.map((log) => (
                <div key={log.id || `${log.sent_at}-${log.subject}`} className="rounded-xl border border-slate-200 bg-white p-4">
                  <div className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between">
                    <div className="min-w-0">
                      <p className="font-semibold text-slate-900 break-words">{log.subject || "Senza oggetto"}</p>
                      <p className="text-xs text-slate-500">
                        {log.sent_at ? new Date(log.sent_at).toLocaleString("it-IT") : "Data non disponibile"} · {log.sent_by_name || "Operatore non specificato"}
                      </p>
                    </div>
                    {log.sent_by_email && (
                      <Badge variant="outline" className="w-fit shrink-0">
                        {log.sent_by_email}
                      </Badge>
                    )}
                  </div>
                  <p className="mt-3 whitespace-pre-wrap text-sm text-slate-700">{log.message || "Testo non disponibile"}</p>
                </div>
              ))
            ) : (
              <p className="py-8 text-center text-sm text-slate-500">Nessuna email inviata a questo contatto.</p>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setSelectedFamiliareEmailHistory(null)}>
              Chiudi
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Nuova Valutazione PAI - Verifica PPA */}
      <Dialog open={showValutazioneModal} onOpenChange={(open) => {
        setShowValutazioneModal(open);
        if (!open) resetValutazioneForm();
      }}>
        <DialogContent className="max-w-[95vw] sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardCheck className="w-5 h-5 text-purple-600" />
              {nuovaValutazione.id ? 'Modifica Verifica PAI' : 'Nuova Verifica PAI'}
            </DialogTitle>
            <DialogDescription>
              {nuovaValutazione.id 
                ? 'Modifica la valutazione periodica del Piano Assistenziale' 
                : 'Valutazione periodica del Piano Assistenziale Individualizzato'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            {/* Data valutazione */}
            <div className="flex items-center gap-4">
              <Label className="w-32">Data valutazione</Label>
              <DateFieldInput
                value={nuovaValutazione.data_valutazione}
                onChange={(v) =>
                  setNuovaValutazione({ ...nuovaValutazione, data_valutazione: v })
                }
                className="w-40"
              />
            </div>

            {/* Aree di valutazione */}
            {[
              { key: "area_nutrizione", label: "Area Nutrizione", icon: "🍽️", color: "emerald" },
              { key: "area_riposo", label: "Area Riposo", icon: "🛏️", color: "blue" },
              { key: "area_igiene", label: "Area Igiene", icon: "🚿", color: "cyan" },
              { key: "area_motoria", label: "Area Motoria", icon: "🚶", color: "orange" },
              { key: "area_educativa", label: "Area Educativa-Riabilitativa", icon: "📚", color: "purple" },
              { key: "area_psicosociale", label: "Area Psico-Sociale", icon: "💬", color: "pink" }
            ].map((area) => (
              <div key={area.key} className={`p-4 rounded-lg border-2 border-${area.color}-200 bg-${area.color}-50/50`}>
                <h4 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
                  <span>{area.icon}</span> {area.label}
                </h4>
                <div className="flex flex-wrap gap-3 mb-3">
                  {[
                    { value: "adeguato", label: "Adeguato", color: "bg-emerald-500" },
                    { value: "parz_adeguato", label: "Parz. Adeguato", color: "bg-amber-500" },
                    { value: "non_adeguato", label: "Non Adeguato", color: "bg-red-500" }
                  ].map((opt) => (
                    <label 
                      key={opt.value}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer border-2 transition-all ${
                        nuovaValutazione[area.key]?.stato === opt.value 
                          ? `${opt.color} text-white border-transparent` 
                          : 'bg-white border-slate-200 hover:border-slate-300'
                      }`}
                    >
                      <input 
                        type="radio"
                        name={area.key}
                        value={opt.value}
                        checked={nuovaValutazione[area.key]?.stato === opt.value}
                        onChange={(e) => setNuovaValutazione({
                          ...nuovaValutazione, 
                          [area.key]: { ...nuovaValutazione[area.key], stato: e.target.value }
                        })}
                        className="sr-only"
                      />
                      <span className="text-sm font-medium">{opt.label}</span>
                    </label>
                  ))}
                </div>
                <Textarea
                  value={nuovaValutazione[area.key]?.osservazioni || ""}
                  onChange={(e) => setNuovaValutazione({
                    ...nuovaValutazione, 
                    [area.key]: { ...nuovaValutazione[area.key], osservazioni: e.target.value }
                  })}
                  placeholder="Osservazioni..."
                  rows={2}
                  className="text-sm"
                />
              </div>
            ))}

            {/* Note generali */}
            <div className="p-4 rounded-lg border-2 border-slate-200 bg-slate-50">
              <Label className="font-semibold text-slate-800 mb-2 block">Note generali</Label>
              <Textarea
                value={nuovaValutazione.note_generali}
                onChange={(e) => setNuovaValutazione({...nuovaValutazione, note_generali: e.target.value})}
                placeholder="Note e osservazioni generali sulla valutazione..."
                rows={3}
              />
            </div>

            {/* Operatori */}
            <div className="p-4 rounded-lg border-2 border-purple-200 bg-purple-50/50">
              <Label className="font-semibold text-slate-800 mb-3 block">Operatori</Label>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div>
                  <Label className="text-xs text-slate-500">Educatore</Label>
                  <Input
                    value={nuovaValutazione.operatori?.educatore || ""}
                    onChange={(e) => setNuovaValutazione({
                      ...nuovaValutazione, 
                      operatori: { ...nuovaValutazione.operatori, educatore: e.target.value }
                    })}
                    placeholder="Nome educatore"
                    className="text-sm"
                  />
                </div>
                <div>
                  <Label className="text-xs text-slate-500">Assistente Sociale</Label>
                  <Input
                    value={nuovaValutazione.operatori?.assistente_sociale || ""}
                    onChange={(e) => setNuovaValutazione({
                      ...nuovaValutazione, 
                      operatori: { ...nuovaValutazione.operatori, assistente_sociale: e.target.value }
                    })}
                    placeholder="Nome assistente"
                    className="text-sm"
                  />
                </div>
                <div>
                  <Label className="text-xs text-slate-500">OSS</Label>
                  <Input
                    value={nuovaValutazione.operatori?.oss || ""}
                    onChange={(e) => setNuovaValutazione({
                      ...nuovaValutazione, 
                      operatori: { ...nuovaValutazione.operatori, oss: e.target.value }
                    })}
                    placeholder="Nome OSS"
                    className="text-sm"
                  />
                </div>
              </div>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => {
              setShowValutazioneModal(false);
              resetValutazioneForm();
            }}>
              Annulla
            </Button>
            <Button 
              onClick={handleSaveValutazione}
              className="bg-purple-600 hover:bg-purple-700"
            >
              <Save className="w-4 h-4 mr-2" />
              {nuovaValutazione.id ? 'Salva Modifiche' : 'Salva Valutazione'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Visualizza Valutazione PAI */}
      <Dialog open={showValutazioneViewModal} onOpenChange={setShowValutazioneViewModal}>
        <DialogContent className="max-w-[95vw] sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardCheck className="w-5 h-5 text-purple-600" />
              Dettaglio Verifica PAI
            </DialogTitle>
            <DialogDescription>
              Valutazione del {viewingValutazione?.data_valutazione ? new Date(viewingValutazione.data_valutazione).toLocaleDateString('it-IT') : ''}
            </DialogDescription>
          </DialogHeader>
          
          {viewingValutazione && (
            <div className="space-y-4 py-4">
              {/* Esito complessivo */}
              <div className={`p-4 rounded-lg text-center ${
                viewingValutazione.esito === 'Positivo' ? 'bg-emerald-100 text-emerald-700' :
                viewingValutazione.esito === 'Parziale' ? 'bg-amber-100 text-amber-700' :
                'bg-red-100 text-red-700'
              }`}>
                <span className="font-semibold text-lg">Esito Complessivo: {viewingValutazione.esito}</span>
              </div>

              {/* Aree di valutazione */}
              {[
                { key: "area_nutrizione", label: "Area Nutrizione", icon: "🍽️", color: "emerald" },
                { key: "area_riposo", label: "Area Riposo", icon: "🛏️", color: "blue" },
                { key: "area_igiene", label: "Area Igiene", icon: "🚿", color: "cyan" },
                { key: "area_motoria", label: "Area Motoria", icon: "🚶", color: "orange" },
                { key: "area_educativa", label: "Area Educativa-Riabilitativa", icon: "📚", color: "purple" },
                { key: "area_psicosociale", label: "Area Psico-Sociale", icon: "💬", color: "pink" }
              ].map((area) => {
                const areaData = viewingValutazione[area.key];
                const stato = areaData?.stato;
                return (
                  <div key={area.key} className="p-4 rounded-lg border bg-slate-50">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="font-semibold text-slate-800 flex items-center gap-2">
                        <span>{area.icon}</span> {area.label}
                      </h4>
                      <Badge className={
                        stato === 'adeguato' ? 'bg-emerald-500 text-white' :
                        stato === 'parz_adeguato' ? 'bg-amber-500 text-white' :
                        stato === 'non_adeguato' ? 'bg-red-500 text-white' :
                        'bg-slate-400 text-white'
                      }>
                        {stato === 'adeguato' ? 'Adeguato' :
                         stato === 'parz_adeguato' ? 'Parz. Adeguato' :
                         stato === 'non_adeguato' ? 'Non Adeguato' :
                         'Non valutato'}
                      </Badge>
                    </div>
                    {areaData?.osservazioni && (
                      <p className="text-sm text-slate-600 mt-2 p-2 bg-white rounded border">
                        <span className="font-medium">Osservazioni:</span> {areaData.osservazioni}
                      </p>
                    )}
                  </div>
                );
              })}

              {/* Note generali */}
              {(viewingValutazione.note_generali || viewingValutazione.note) && (
                <div className="p-4 rounded-lg border-2 border-purple-200 bg-purple-50/50">
                  <Label className="font-semibold text-slate-800 mb-2 block">Note generali</Label>
                  <p className="text-slate-700">{viewingValutazione.note_generali || viewingValutazione.note}</p>
                </div>
              )}

              {/* Operatori */}
              {viewingValutazione.operatori && (
                <div className="p-4 rounded-lg border bg-slate-50">
                  <Label className="font-semibold text-slate-800 mb-3 block">Operatori</Label>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {viewingValutazione.operatori.educatore && (
                      <div>
                        <Label className="text-xs text-slate-500">Educatore</Label>
                        <p className="font-medium">{viewingValutazione.operatori.educatore}</p>
                      </div>
                    )}
                    {viewingValutazione.operatori.assistente_sociale && (
                      <div>
                        <Label className="text-xs text-slate-500">Assistente Sociale</Label>
                        <p className="font-medium">{viewingValutazione.operatori.assistente_sociale}</p>
                      </div>
                    )}
                    {viewingValutazione.operatori.oss && (
                      <div>
                        <Label className="text-xs text-slate-500">OSS</Label>
                        <p className="font-medium">{viewingValutazione.operatori.oss}</p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowValutazioneViewModal(false)}>
              Chiudi
            </Button>
            <Button 
              onClick={() => {
                setShowValutazioneViewModal(false);
                handleEditValutazione(viewingValutazione);
              }}
              variant="outline"
              className="border-blue-300 text-blue-600 hover:bg-blue-50"
            >
              <Edit className="w-4 h-4 mr-2" />
              Modifica
            </Button>
            <Button 
              onClick={() => viewingValutazione && handlePrintValutazione(viewingValutazione)}
              className="bg-purple-600 hover:bg-purple-700"
            >
              <Printer className="w-4 h-4 mr-2" />
              Stampa
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Conferma Eliminazione */}
      <Dialog open={showAttivaOspiteDialog} onOpenChange={setShowAttivaOspiteDialog}>
        <DialogContent className="max-w-[420px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-emerald-700">
              <Check className="w-5 h-5" />
              Attiva ospite
            </DialogTitle>
            <DialogDescription>
              Confermi l&apos;attivazione dell&apos;ospite? Verranno collegati i moduli operativi
              (camera, deblistering, prima nota, fatturazione e profilo sanitario).
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => setShowAttivaOspiteDialog(false)}
              disabled={attivandoOspite}
            >
              Annulla
            </Button>
            <Button
              type="button"
              className="bg-emerald-600 hover:bg-emerald-700"
              onClick={handleAttivaOspite}
              disabled={attivandoOspite}
            >
              {attivandoOspite ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Attivazione...
                </>
              ) : (
                <>
                  <Check className="w-4 h-4 mr-2" />
                  Conferma attivazione
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={showDeleteConfirm} onOpenChange={setShowDeleteConfirm}>
        <DialogContent className="max-w-[400px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="w-5 h-5" />
              Conferma Eliminazione
            </DialogTitle>
            <DialogDescription>
              Sei sicuro di voler eliminare questa valutazione? L'operazione non è reversibile.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setShowDeleteConfirm(false)}>
              Annulla
            </Button>
            <Button 
              onClick={confirmDeleteValutazione}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Elimina
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <RichiestaDocumentiPreIngressoDialog
        open={showRichiestaDocumentiDialog}
        onOpenChange={setShowRichiestaDocumentiDialog}
        fascicolo={cartella}
        fascicoloId={id}
        token={token}
        preIngressoCard={preIngressoCard}
        onSent={handleRichiestaDocumentiSent}
      />

      <StampaDocumentiFascicoloDialog
        open={showStampaDocumentiDialog}
        onOpenChange={setShowStampaDocumentiDialog}
        fascicoloId={id}
        token={token}
        documenti={documenti}
        labelSezione={LABEL_DOCUMENTO_SEZIONE}
      />

      <EstrazionePatologieDialog
        open={showEstrazionePatologie}
        onOpenChange={setShowEstrazionePatologie}
        fascicoloId={id}
        token={token}
        documenti={documenti}
        onApply={handleApplicaPatologie}
      />

      <CompilaAnagraficaDaIdentitaDialog
        open={showCompilaDaIdentita}
        onOpenChange={setShowCompilaDaIdentita}
        fascicoloId={id}
        token={token}
        onApply={handleApplicaAnagraficaDaIdentita}
      />

      <PulisciScansioneDialog
        open={showPulisciScansione}
        onOpenChange={(v) => {
          setShowPulisciScansione(v);
          if (!v) setPulisciScansioneDoc(null);
        }}
        fascicoloId={id}
        token={token}
        documento={pulisciScansioneDoc}
        onApplied={(data) => {
          const oldId = pulisciScansioneDoc?.file_id;
          if (data?.replaced && data.document && oldId) {
            setDocumenti((prev) => prev.map((d) => (d.file_id === oldId ? { ...d, ...data.document } : d)));
            setSelectedDocument((s) => (s?.file_id === oldId ? { ...s, ...data.document } : s));
          } else if (data?.document) {
            setDocumenti((prev) => [...prev, data.document]);
          }
        }}
      />

      {/* Modal Upload Documento */}
      <Dialog open={showUploadModal} onOpenChange={(open) => { setShowUploadModal(open); if (!open) { setUploadSezione('generale'); setUploadDescrizione(''); } }}>
        <DialogContent className="max-w-[95vw] sm:max-w-[450px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Upload className={`w-5 h-5 ${uploadSezione === 'contratto_firmato' ? 'text-emerald-600' : 'text-blue-600'}`} />
              {uploadSezione === 'contratto_firmato' ? 'Carica Contratto Firmato' : 'Carica Documento'}
            </DialogTitle>
            <DialogDescription>
              {uploadSezione === 'contratto_firmato' ? 'Carica il file del contratto firmato' : 'Carica un file PDF, immagine o documento Office'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {uploadSezione !== 'contratto_firmato' && (
            <>
            <div className="space-y-2">
              <Label>Sezione di appartenenza</Label>
              <Select 
                value={uploadSezione} 
                onValueChange={setUploadSezione}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="generale">Generale</SelectItem>
                  <SelectItem value="anagrafica">Anagrafica</SelectItem>
                  <SelectItem value="amministrativa">Amministrativa</SelectItem>
                  <SelectItem value="sociale">Sociale</SelectItem>
                  <SelectItem value="sanitaria">Sanitaria</SelectItem>
                  <SelectItem value="terapie_ausili">Terapie e Ausili (allegati)</SelectItem>
                  <SelectItem value="richiesta_rsa">Richiesta RSA</SelectItem>
                  <SelectItem value="dietetica">Tabella Dietetica</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Descrizione (opzionale)</Label>
              <Input
                value={uploadDescrizione}
                onChange={(e) => setUploadDescrizione(e.target.value)}
                placeholder="Es: Carta d'identità, Certificato medico..."
              />
            </div>
            </>
            )}
            <div className="space-y-2">
              <Label>File</Label>
              <div className="border-2 border-dashed border-slate-200 rounded-lg p-6 text-center hover:border-blue-400 transition-colors">
                {uploading ? (
                    <div className="flex flex-col items-center">
                      <Loader2 className="w-8 h-8 text-blue-600 animate-spin mb-2" />
                      <span className="text-sm text-slate-600">Caricamento in corso...</span>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center">
                      <Upload className="w-8 h-8 text-slate-400 mb-2" />
                      <span className="text-sm text-slate-600">Carica un file oppure scatta una foto</span>
                      <span className="text-xs text-slate-400 mt-1">PDF, JPG, PNG, DOC, XLS (max 50 MB)</span>
                      <FilePickerButton
                        className="mt-3"
                        accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                        onChange={handleUploadDocument}
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowUploadModal(false)}>
              Annulla
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Export Cartella */}
      <Dialog open={showExportModal} onOpenChange={setShowExportModal}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Download className="w-5 h-5 text-purple-600" />
              Anteprima Fascicolo Assistenziale
            </DialogTitle>
            <DialogDescription>
              Visualizza l'intera cartella. Puoi stampare o salvare come PDF.
            </DialogDescription>
          </DialogHeader>
          
          <div className="keep-light flex-1 overflow-auto bg-white border rounded-lg p-4" style={{ maxHeight: '60vh' }}>
            <div dangerouslySetInnerHTML={{ __html: exportHtml }} />
          </div>
          
          <DialogFooter className="gap-2 pt-4">
            <Button variant="outline" onClick={() => setShowExportModal(false)}>
              Chiudi
            </Button>
            <Button onClick={handlePrintFromExport} className="bg-purple-600 hover:bg-purple-700 text-white">
              <Printer className="w-4 h-4 mr-2" />
              Stampa / Salva PDF
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal dettaglio comunicazione medico */}
      <Dialog
        open={showComunicazioneMedicaModal}
        onOpenChange={setShowComunicazioneMedicaModal}
      >
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          {selectedComunicazioneMedica && (
            <>
              <DialogHeader>
                <DialogTitle className="flex items-center gap-2">
                  <Send className="w-5 h-5 text-purple-600" />
                  Comunicazione al medico
                </DialogTitle>
                <DialogDescription>
                  {selectedComunicazioneMedica.sent_at
                    ? new Date(selectedComunicazioneMedica.sent_at).toLocaleString("it-IT")
                    : ""}
                  {selectedComunicazioneMedica.sent_by_name
                    ? ` · ${selectedComunicazioneMedica.sent_by_name}`
                    : ""}
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-3 text-sm">
                <div>
                  <Label className="text-xs text-slate-500">Destinatario</Label>
                  <p className="font-medium text-slate-900 mt-0.5">
                    {selectedComunicazioneMedica.recipient_name || "—"}
                  </p>
                  {selectedComunicazioneMedica.recipient_email ? (
                    <p className="text-slate-600 break-all">
                      {selectedComunicazioneMedica.recipient_email}
                    </p>
                  ) : null}
                </div>
                <div>
                  <Label className="text-xs text-slate-500">Oggetto</Label>
                  <p className="font-medium text-slate-900 mt-0.5">
                    {selectedComunicazioneMedica.oggetto || "—"}
                  </p>
                </div>
                <div>
                  <Label className="text-xs text-slate-500">Messaggio</Label>
                  <div className="mt-1 rounded-lg border border-slate-200 bg-slate-50/80 p-3 whitespace-pre-wrap text-slate-800">
                    {selectedComunicazioneMedica.messaggio || "—"}
                  </div>
                </div>
                {selectedComunicazioneMedica.allegato?.nome ? (
                  <div>
                    <Label className="text-xs text-slate-500">Allegato</Label>
                    <div className="mt-1 flex items-center gap-2">
                      <Paperclip className="w-4 h-4 text-purple-600" />
                      <span>{selectedComunicazioneMedica.allegato.nome}</span>
                      {selectedComunicazioneMedica.allegato.file_id ? (
                        <Button
                          type="button"
                          variant="outline"
                          size="sm"
                          className="h-7 ml-auto"
                          onClick={() =>
                            handleDownloadComunicazioneAllegato(selectedComunicazioneMedica.allegato)
                          }
                        >
                          <Download className="w-3.5 h-3.5 mr-1" />
                          Scarica
                        </Button>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                <div>
                  <Label className="text-xs text-slate-500">Esito</Label>
                  <div className="mt-1">
                    <Badge
                      className={
                        selectedComunicazioneMedica.esito === "inviata"
                          ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-100"
                          : "bg-red-100 text-red-800 hover:bg-red-100"
                      }
                    >
                      {selectedComunicazioneMedica.esito === "inviata" ? "Inviata" : "Fallita"}
                    </Badge>
                    {selectedComunicazioneMedica.error ? (
                      <p className="text-xs text-red-600 mt-1">{selectedComunicazioneMedica.error}</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => setShowComunicazioneMedicaModal(false)}>
                  Chiudi
                </Button>
                <Button
                  className="bg-purple-600 hover:bg-purple-700"
                  onClick={() => window.print()}
                >
                  <Printer className="w-4 h-4 mr-2" />
                  Stampa
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal Visualizzazione Documento */}
      <Dialog open={showDocumentModal} onOpenChange={setShowDocumentModal}>
        <DialogContent className="max-w-4xl max-h-[90vh] flex flex-col">
          {selectedDocument && (
            <>
              <DialogHeader className="flex-shrink-0">
                <DialogTitle className="flex items-center gap-2 pr-8">
                  <FileText className="w-5 h-5 text-purple-600" />
                  {selectedDocument.file_name}
                </DialogTitle>
                <DialogDescription>
                  {selectedDocument.descrizione || 'Documento allegato'} • {(selectedDocument.file_size / 1024).toFixed(1)} KB
                </DialogDescription>
              </DialogHeader>

              <div className="flex-1 overflow-hidden mt-4">
                {/* Toolbar */}
                <div className="flex justify-end gap-2 mb-3 flex-shrink-0">
                  {hasPermission("fascicolo:update") && isScanCleanable(selectedDocument) && (
                    <Button
                      variant="outline"
                      size="sm"
                      className="border-violet-200 text-violet-700"
                      onClick={() => {
                        setPulisciScansioneDoc(selectedDocument);
                        setShowDocumentModal(false);
                        setShowPulisciScansione(true);
                      }}
                    >
                      <Sparkles className="w-4 h-4 mr-2" />
                      Pulisci scansione
                    </Button>
                  )}
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handlePrintDocument}
                  >
                    <Printer className="w-4 h-4 mr-2" />
                    Stampa
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => handleDownloadDocument(selectedDocument)}
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Scarica
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => window.open(
                      appendAuthToUrl(
                        `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                        token
                      ),
                      '_blank'
                    )}
                  >
                    <Eye className="w-4 h-4 mr-2" />
                    Apri in nuova scheda
                  </Button>
                </div>
                
                {/* Document viewer - scrollable */}
                <div className="flex-1 rounded-xl overflow-hidden border bg-slate-50" style={{ minHeight: '400px', maxHeight: '55vh' }}>
                  {selectedDocument.file_type?.startsWith('image/') ? (
                    <div className="w-full h-full overflow-auto flex items-center justify-center p-4">
                      <img
                        src={appendAuthToUrl(
                          `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                          token
                        )}
                        alt={selectedDocument.file_name}
                        className="max-w-full h-auto object-contain"
                        style={{ maxHeight: '50vh' }}
                      />
                    </div>
                  ) : selectedDocument.file_type === 'application/pdf' ? (
                    isMobile ? (
                      /* Su mobile mostra direttamente i pulsanti */
                      <div className="flex flex-col items-center justify-center h-full p-8 text-center" style={{ minHeight: '400px' }}>
                        <FileText className="w-20 h-20 text-purple-400 mb-6" />
                        <h3 className="text-lg font-semibold text-slate-700 mb-2">
                          {selectedDocument.file_name}
                        </h3>
                        <p className="text-slate-500 mb-6">
                          Il documento PDF è pronto per la visualizzazione
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-xs">
                          <a
                            href={appendAuthToUrl(
                              `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                              token
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex-1"
                          >
                            <Button
                              className="w-full bg-purple-600 hover:bg-purple-700"
                              size="lg"
                            >
                              <Eye className="w-5 h-5 mr-2" />
                              Apri PDF
                            </Button>
                          </a>
                          <Button
                            variant="outline"
                            size="lg"
                            className="flex-1"
                            onClick={() => handleDownloadDocument(selectedDocument)}
                          >
                            <Download className="w-5 h-5 mr-2" />
                            Scarica
                          </Button>
                        </div>
                      </div>
                    ) : (
                      /* Su desktop prova con object/embed */
                      <object
                        data={`${appendAuthToUrl(
                          `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                          token
                        )}#toolbar=1&navpanes=0`}
                        type="application/pdf"
                        className="w-full h-full"
                        style={{ minHeight: '400px', height: '55vh' }}
                      >
                        {/* Fallback per browser senza supporto PDF */}
                        <div className="flex flex-col items-center justify-center h-full p-8 text-center">
                          <FileText className="w-16 h-16 text-purple-300 mb-4" />
                          <p className="text-slate-600 mb-4">
                            Il documento PDF "{selectedDocument.file_name}" è pronto.
                          </p>
                          <div className="flex gap-3">
                            <Button
                              onClick={() => window.open(
                                appendAuthToUrl(
                                  `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                                  token
                                ),
                                '_blank'
                              )}
                              className="bg-purple-600 hover:bg-purple-700"
                            >
                              <Eye className="w-4 h-4 mr-2" />
                              Apri PDF
                            </Button>
                            <Button
                              variant="outline"
                              onClick={() => handleDownloadDocument(selectedDocument)}
                            >
                              <Download className="w-4 h-4 mr-2" />
                              Scarica
                            </Button>
                          </div>
                        </div>
                      </object>
                    )
                  ) : (
                    <iframe
                      src={appendAuthToUrl(
                        `${API_URL}/api/upload/cartella/${id}/${selectedDocument.sezione}/${selectedDocument.file_id}`,
                        token
                      )}
                      title={selectedDocument.file_name}
                      className="w-full h-full"
                      style={{ minHeight: '400px', height: '55vh' }}
                    />
                  )}
                </div>
              </div>

              <DialogFooter className="flex-shrink-0 mt-4">
                <Button variant="outline" onClick={() => setShowDocumentModal(false)}>
                  Chiudi
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal PAI - Piano Personalizzato Assistenziale */}
      <Dialog open={showPaiModal} onOpenChange={setShowPaiModal}>
        <DialogContent className="max-w-[95vw] sm:max-w-[900px] max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="w-5 h-5 text-purple-600" />
              Piano Personalizzato Assistenziale (PAI)
            </DialogTitle>
            <DialogDescription>
              Compila il PAI per {cartella?.anagrafica?.nome} {cartella?.anagrafica?.cognome}
            </DialogDescription>
          </DialogHeader>
          
          {/* Step Indicator */}
          <div className="flex items-center justify-center gap-1 py-2 border-b">
            {PAI_WIZARD_STEPS.map((step, idx) => (
              <button
                key={idx}
                onClick={() => setPaiStep(idx)}
                className={`px-2 py-1 text-xs rounded-full transition-all ${
                  paiStep === idx 
                    ? 'bg-purple-600 text-white' 
                    : paiStep > idx 
                      ? 'bg-purple-200 text-purple-800' 
                      : 'bg-slate-100 text-slate-500'
                }`}
              >
                {idx + 1}. {step}
              </button>
            ))}
          </div>
          
          {/* Form Content - Scrollable */}
          <div className="flex-1 overflow-y-auto py-4 px-1">
            {/* Step 0: Dati Generali */}
            {paiStep === 0 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Dati Generali e Anagrafici</h3>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Data Redazione PAI</Label>
                    <DateFieldInput
                      value={paiData.data_redazione}
                      onChange={(v) => handlePaiFieldChange("data_redazione", v)}
                    />
                  </div>
                  <div>
                    <Label>Redatto da</Label>
                    <Input 
                      value={paiData.redatto_da}
                      onChange={(e) => handlePaiFieldChange('redatto_da', e.target.value)}
                      placeholder="Nome operatore"
                    />
                  </div>
                </div>
                
                <div>
                  <Label>Stato Civile</Label>
                  <Select value={paiData.stato_civile} onValueChange={(v) => handlePaiFieldChange('stato_civile', v)}>
                    <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="coniugato">Coniugato/a</SelectItem>
                      <SelectItem value="convivente">Convivente</SelectItem>
                      <SelectItem value="separato">Separato/Divorziato</SelectItem>
                      <SelectItem value="vedovo">Vedovo/a</SelectItem>
                      <SelectItem value="celibe">Celibe/Nubile</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Invalidità Civile</Label>
                    <Select value={paiData.invalidita_civile} onValueChange={(v) => handlePaiFieldChange('invalidita_civile', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="in_corso">In corso</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Indennità Accompagnamento</Label>
                    <Select value={paiData.indennita_accompagnamento} onValueChange={(v) => handlePaiFieldChange('indennita_accompagnamento', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="in_corso">In corso</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Certificazione L.104/92</Label>
                    <Select value={paiData.certificazione_104} onValueChange={(v) => handlePaiFieldChange('certificazione_104', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="in_corso">In corso</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Medico Curante</Label>
                    <Input 
                      value={paiData.medico_curante}
                      onChange={(e) => handlePaiFieldChange('medico_curante', e.target.value)}
                      placeholder="Nome medico"
                    />
                  </div>
                  <div>
                    <Label>Contatti Medico</Label>
                    <Input 
                      value={paiData.medico_contatti}
                      onChange={(e) => handlePaiFieldChange('medico_contatti', e.target.value)}
                      placeholder="Telefono"
                    />
                  </div>
                </div>
                
                <div>
                  <Label>Situazione personale e contesto familiare</Label>
                  <Textarea 
                    value={paiData.situazione_personale}
                    onChange={(e) => handlePaiFieldChange('situazione_personale', e.target.value)}
                    placeholder="Descrivi la situazione personale e familiare..."
                    rows={4}
                  />
                </div>
                
                <h4 className="font-medium text-slate-700 mt-4">Persona di riferimento 1</h4>
                <div className="grid grid-cols-3 gap-3">
                  <Input placeholder="Cognome" value={paiData.riferimento1_cognome} onChange={(e) => handlePaiFieldChange('riferimento1_cognome', e.target.value)} />
                  <Input placeholder="Nome" value={paiData.riferimento1_nome} onChange={(e) => handlePaiFieldChange('riferimento1_nome', e.target.value)} />
                  <Input placeholder="Parentela" value={paiData.riferimento1_parentela} onChange={(e) => handlePaiFieldChange('riferimento1_parentela', e.target.value)} />
                  <Input placeholder="Telefono" value={paiData.riferimento1_telefono} onChange={(e) => handlePaiFieldChange('riferimento1_telefono', e.target.value)} className="col-span-3" />
                </div>
              </div>
            )}
            
            {/* Step 1: Area Nutrizione */}
            {paiStep === 1 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Valutazione Area Nutrizione</h3>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Appetito</Label>
                    <Select value={paiData.appetito} onValueChange={(v) => handlePaiFieldChange('appetito', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="buono">Buono</SelectItem>
                        <SelectItem value="scarso">Scarso</SelectItem>
                        <SelectItem value="assente">Assente</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Percezione Sete</Label>
                    <Select value={paiData.percezione_sete} onValueChange={(v) => handlePaiFieldChange('percezione_sete', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="buona">Buona</SelectItem>
                        <SelectItem value="scarsa">Scarsa</SelectItem>
                        <SelectItem value="assente">Assente</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Masticazione</Label>
                    <Select value={paiData.masticazione} onValueChange={(v) => handlePaiFieldChange('masticazione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="con_protesi">Con protesi</SelectItem>
                        <SelectItem value="edentule">Edentule</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Deglutizione</Label>
                    <Select value={paiData.deglutizione} onValueChange={(v) => handlePaiFieldChange('deglutizione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="difficoltosa">Difficoltosa</SelectItem>
                        <SelectItem value="molto_difficoltosa">Molto difficoltosa</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Preparazione Cibi</Label>
                    <Select value={paiData.preparazione_cibi} onValueChange={(v) => handlePaiFieldChange('preparazione_cibi', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="macinato">Macinato</SelectItem>
                        <SelectItem value="frullato">Frullato</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div>
                  <Label>Tipo di Alimentazione</Label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {['libera', 'ipoglucidica', 'ipoproteica', 'iposodica', 'ipolipidica', 'ipocalorica', 'ipercalorica', 'enterale', 'parenterale'].map(tipo => (
                      <label key={tipo} className="flex items-center gap-1 text-sm bg-slate-100 px-2 py-1 rounded cursor-pointer">
                        <input 
                          type="checkbox"
                          checked={(paiData.alimentazione || []).includes(tipo)}
                          onChange={(e) => handlePaiCheckboxChange('alimentazione', tipo, e.target.checked)}
                        />
                        {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
                
                <h4 className="font-medium text-slate-700">Autonomia ai pasti</h4>
                <div className="grid grid-cols-3 gap-4">
                  {['colazione', 'pranzo', 'cena'].map(pasto => (
                    <div key={pasto} className="p-3 bg-slate-50 rounded-lg">
                      <Label className="capitalize">{pasto}</Label>
                      <Select 
                        value={paiData[`${pasto}_autonomia`]} 
                        onValueChange={(v) => handlePaiFieldChange(`${pasto}_autonomia`, v)}
                      >
                        <SelectTrigger className="mt-1"><SelectValue placeholder="Autonomia..." /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="autonomo">Autonomo</SelectItem>
                          <SelectItem value="assistito">Assistito</SelectItem>
                          <SelectItem value="dipendente">Tot. dipendente</SelectItem>
                        </SelectContent>
                      </Select>
                      <label className="flex items-center gap-2 mt-2 text-sm">
                        <input 
                          type="checkbox"
                          checked={paiData[`${pasto}_terapia`]}
                          onChange={(e) => handlePaiFieldChange(`${pasto}_terapia`, e.target.checked)}
                        />
                        Somm. terapia
                      </label>
                    </div>
                  ))}
                </div>
                
                <div>
                  <Label>Note Nutrizione</Label>
                  <Textarea 
                    value={paiData.note_nutrizione}
                    onChange={(e) => handlePaiFieldChange('note_nutrizione', e.target.value)}
                    placeholder="Note aggiuntive..."
                    rows={2}
                  />
                </div>
                <div>
                  <Label>Obiettivi Area Nutrizione</Label>
                  <Textarea 
                    value={paiData.obiettivi_nutrizione}
                    onChange={(e) => handlePaiFieldChange('obiettivi_nutrizione', e.target.value)}
                    placeholder="Obiettivi da raggiungere..."
                    rows={2}
                  />
                </div>
              </div>
            )}
            
            {/* Step 2: Area Riposo */}
            {paiStep === 2 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Valutazione Area Riposo</h3>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Sonno</Label>
                    <Select value={paiData.sonno} onValueChange={(v) => handlePaiFieldChange('sonno', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="disturbato">Disturbato</SelectItem>
                        <SelectItem value="condizionato_terapia">Condizionato dalla terapia</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Cambio Postura</Label>
                    <Select value={paiData.cambio_postura} onValueChange={(v) => handlePaiFieldChange('cambio_postura', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                        <SelectItem value="assistito">Assistito</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>N. Cuscini</Label>
                    <Select value={paiData.cuscini} onValueChange={(v) => handlePaiFieldChange('cuscini', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="nessuno">Nessuno</SelectItem>
                        <SelectItem value="uno">Uno</SelectItem>
                        <SelectItem value="due">Due</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Sponde Letto</Label>
                    <Select value={paiData.sponde_letto} onValueChange={(v) => handlePaiFieldChange('sponde_letto', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="una">Una</SelectItem>
                        <SelectItem value="due">Due</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Controllo Notturno</Label>
                    <Select value={paiData.controllo_notturno} onValueChange={(v) => handlePaiFieldChange('controllo_notturno', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="frequente">Frequente (ogni 2h)</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Posizione Seduta</Label>
                    <Select value={paiData.posizione_seduta} onValueChange={(v) => handlePaiFieldChange('posizione_seduta', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="sedia">Sedia</SelectItem>
                        <SelectItem value="poltrona">Poltrona</SelectItem>
                        <SelectItem value="carrozzina">Carrozzina</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Messa a Letto</Label>
                    <Select value={paiData.messa_a_letto} onValueChange={(v) => handlePaiFieldChange('messa_a_letto', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                        <SelectItem value="1_oss">1 O.S.S.</SelectItem>
                        <SelectItem value="2_oss">2 O.S.S.</SelectItem>
                        <SelectItem value="sollevatore">Uso sollevatore</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div>
                  <Label>Difficoltà Respiratoria</Label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {['nessuna', 'diurna', 'correlata_postura', 'correlata_malattia', 'correlata_attivita'].map(tipo => (
                      <label key={tipo} className="flex items-center gap-1 text-sm bg-slate-100 px-2 py-1 rounded cursor-pointer">
                        <input 
                          type="checkbox"
                          checked={(paiData.difficolta_respiratoria || []).includes(tipo)}
                          onChange={(e) => handlePaiCheckboxChange('difficolta_respiratoria', tipo, e.target.checked)}
                        />
                        {tipo.replace(/_/g, ' ').charAt(0).toUpperCase() + tipo.replace(/_/g, ' ').slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
                
                <div>
                  <Label>Obiettivi Area Riposo</Label>
                  <Textarea 
                    value={paiData.obiettivi_riposo}
                    onChange={(e) => handlePaiFieldChange('obiettivi_riposo', e.target.value)}
                    placeholder="Obiettivi da raggiungere..."
                    rows={2}
                  />
                </div>
              </div>
            )}
            
            {/* Step 3: Area Igiene */}
            {paiStep === 3 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Valutazione Area Igiene</h3>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Alzata del Mattino</Label>
                    <Select value={paiData.alzata_mattino} onValueChange={(v) => handlePaiFieldChange('alzata_mattino', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                        <SelectItem value="1_oss">1 O.S.S.</SelectItem>
                        <SelectItem value="2_oss">2 O.S.S.</SelectItem>
                        <SelectItem value="sollevatore">Uso sollevatore</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Vestizione</Label>
                    <Select value={paiData.vestizione} onValueChange={(v) => handlePaiFieldChange('vestizione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonoma">Autonoma</SelectItem>
                        <SelectItem value="con_aiuto">Con aiuto</SelectItem>
                        <SelectItem value="dipendente">Dipendente</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Igiene Superiore</Label>
                    <Select value={paiData.igiene_superiore} onValueChange={(v) => handlePaiFieldChange('igiene_superiore', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                        <SelectItem value="con_aiuto">Con aiuto</SelectItem>
                        <SelectItem value="a_letto">A letto</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Igiene Intima</Label>
                    <Select value={paiData.igiene_intima} onValueChange={(v) => handlePaiFieldChange('igiene_intima', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                        <SelectItem value="con_aiuto">Con aiuto</SelectItem>
                        <SelectItem value="a_letto">A letto</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Bagno Settimanale</Label>
                    <Select value={paiData.bagno_settimanale} onValueChange={(v) => handlePaiFieldChange('bagno_settimanale', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="vasca_sollevatore">Vasca con sollevatore</SelectItem>
                        <SelectItem value="vasca_barella">Vasca con barella</SelectItem>
                        <SelectItem value="doccia_sollevatore">Doccia con sollevatore</SelectItem>
                        <SelectItem value="doccia_sedia">Doccia con sedia</SelectItem>
                        <SelectItem value="non_possibile">Non possibile</SelectItem>
                        <SelectItem value="autonomo">Autonomo</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <h4 className="font-medium text-slate-700 mt-4">Continenza</h4>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Incontinenza Urinaria</Label>
                    <Select value={paiData.incontinenza_urinaria} onValueChange={(v) => handlePaiFieldChange('incontinenza_urinaria', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="episodica">Episodica</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Incontinenza Rettale</Label>
                    <Select value={paiData.incontinenza_rettale} onValueChange={(v) => handlePaiFieldChange('incontinenza_rettale', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si">Sì</SelectItem>
                        <SelectItem value="episodica">Episodica</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Usa il Bagno</Label>
                    <Select value={paiData.usa_bagno} onValueChange={(v) => handlePaiFieldChange('usa_bagno', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si_solo">Sì, da solo</SelectItem>
                        <SelectItem value="si_accompagnato">Sì, accompagnato</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Usa Catetere</Label>
                    <Select value={paiData.usa_catetere} onValueChange={(v) => handlePaiFieldChange('usa_catetere', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si">Sì</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Usa Pannolone</Label>
                    <Select value={paiData.usa_pannolone} onValueChange={(v) => handlePaiFieldChange('usa_pannolone', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="mutandina">Mutandina</SelectItem>
                        <SelectItem value="anatomico">Anatomico</SelectItem>
                        <SelectItem value="rettangolo">Rettangolo</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Allergie Pannolone</Label>
                    <Select value={paiData.allergie_pannolone} onValueChange={(v) => handlePaiFieldChange('allergie_pannolone', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si">Sì</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div>
                  <Label>Note Igiene</Label>
                  <Textarea 
                    value={paiData.note_igiene}
                    onChange={(e) => handlePaiFieldChange('note_igiene', e.target.value)}
                    placeholder="Note aggiuntive..."
                    rows={2}
                  />
                </div>
                <div>
                  <Label>Obiettivi Area Igiene</Label>
                  <Textarea 
                    value={paiData.obiettivi_igiene}
                    onChange={(e) => handlePaiFieldChange('obiettivi_igiene', e.target.value)}
                    placeholder="Obiettivi da raggiungere..."
                    rows={2}
                  />
                </div>
              </div>
            )}
            
            {/* Step 4: Area Motoria */}
            {paiStep === 4 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Valutazione Area Motoria</h3>
                
                <div>
                  <Label>Spostamenti</Label>
                  <Select value={paiData.spostamenti} onValueChange={(v) => handlePaiFieldChange('spostamenti', v)}>
                    <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="autonoma">Deambulazione autonoma</SelectItem>
                      <SelectItem value="con_aiuto">Con aiuto</SelectItem>
                      <SelectItem value="non_deambula">Non deambula</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <h4 className="font-medium text-slate-700">Ausili</h4>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { key: 'bastone', label: 'Bastone/Tripode' },
                    { key: 'girello', label: 'Girello' },
                    { key: 'carrozzina', label: 'Carrozzina' },
                    { key: 'cuscino_antidecubito', label: 'Cuscino antidecubito' },
                    { key: 'materasso_antidecubito', label: 'Materasso antidecubito' }
                  ].map(ausilio => (
                    <div key={ausilio.key} className="flex items-center gap-2 p-2 bg-slate-50 rounded">
                      <input 
                        type="checkbox"
                        checked={paiData.ausili?.[ausilio.key]?.usa || false}
                        onChange={(e) => setPaiData(prev => ({
                          ...prev,
                          ausili: {
                            ...prev.ausili,
                            [ausilio.key]: { ...prev.ausili?.[ausilio.key], usa: e.target.checked }
                          }
                        }))}
                      />
                      <span className="text-sm flex-1">{ausilio.label}</span>
                      <Select 
                        value={paiData.ausili?.[ausilio.key]?.proprietario || ''}
                        onValueChange={(v) => setPaiData(prev => ({
                          ...prev,
                          ausili: {
                            ...prev.ausili,
                            [ausilio.key]: { ...prev.ausili?.[ausilio.key], proprietario: v }
                          }
                        }))}
                        disabled={!paiData.ausili?.[ausilio.key]?.usa}
                      >
                        <SelectTrigger className="w-28 h-8"><SelectValue placeholder="Di chi?" /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="personale">Personale</SelectItem>
                          <SelectItem value="asl">ASL</SelectItem>
                          <SelectItem value="struttura">Struttura</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  ))}
                </div>
                
                <div>
                  <Label>Presidi Personalizzati</Label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {['scarpe_ortopediche', 'cintura_pelvica', 'busto', 'fascia_pettorale', 'altro'].map(tipo => (
                      <label key={tipo} className="flex items-center gap-1 text-sm bg-slate-100 px-2 py-1 rounded cursor-pointer">
                        <input 
                          type="checkbox"
                          checked={(paiData.presidi || []).includes(tipo)}
                          onChange={(e) => handlePaiCheckboxChange('presidi', tipo, e.target.checked)}
                        />
                        {tipo.replace(/_/g, ' ').charAt(0).toUpperCase() + tipo.replace(/_/g, ' ').slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
                
                <h4 className="font-medium text-slate-700">Programma quotidiano attività motoria</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Mattina</Label>
                    <Textarea 
                      value={paiData.programma_mattina}
                      onChange={(e) => handlePaiFieldChange('programma_mattina', e.target.value)}
                      placeholder="Attività previste la mattina..."
                      rows={3}
                    />
                  </div>
                  <div>
                    <Label>Pomeriggio</Label>
                    <Textarea 
                      value={paiData.programma_pomeriggio}
                      onChange={(e) => handlePaiFieldChange('programma_pomeriggio', e.target.value)}
                      placeholder="Attività previste il pomeriggio..."
                      rows={3}
                    />
                  </div>
                </div>
                
                <div>
                  <Label>Obiettivi Area Motoria</Label>
                  <Textarea 
                    value={paiData.obiettivi_motoria}
                    onChange={(e) => handlePaiFieldChange('obiettivi_motoria', e.target.value)}
                    placeholder="Obiettivi da raggiungere..."
                    rows={2}
                  />
                </div>
              </div>
            )}
            
            {/* Step 5: Area Educativa */}
            {paiStep === 5 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Valutazione Area Educativa</h3>
                
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Comprensione</Label>
                    <Select value={paiData.comprensione} onValueChange={(v) => handlePaiFieldChange('comprensione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="comprende_fatica">Comprende a fatica</SelectItem>
                        <SelectItem value="non_comprende">Non comprende</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Comunicazione</Label>
                    <Select value={paiData.comunicazione} onValueChange={(v) => handlePaiFieldChange('comunicazione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="disturbata">Disturbata</SelectItem>
                        <SelectItem value="non_possibile">Non possibile</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Vita di Relazione</Label>
                    <Select value={paiData.vita_relazione} onValueChange={(v) => handlePaiFieldChange('vita_relazione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="autonoma">Autonoma</SelectItem>
                        <SelectItem value="difficoltosa">Difficoltosa</SelectItem>
                        <SelectItem value="ostile">Ostile alle relazioni</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <h4 className="font-medium text-slate-700">Interessi e attitudini</h4>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { key: 'lettura', label: 'Lettura' },
                    { key: 'televisione', label: 'Televisione' },
                    { key: 'passatempi', label: 'Passatempi' },
                    { key: 'lavori_manuali', label: 'Lavori manuali' },
                    { key: 'uso_telefono', label: 'Uso del telefono' }
                  ].map(interesse => (
                    <div key={interesse.key} className="flex items-center gap-2">
                      <span className="text-sm w-32">{interesse.label}</span>
                      <Select 
                        value={paiData.interessi?.[interesse.key] || ''}
                        onValueChange={(v) => setPaiData(prev => ({
                          ...prev,
                          interessi: { ...prev.interessi, [interesse.key]: v }
                        }))}
                      >
                        <SelectTrigger className="flex-1"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="no">No</SelectItem>
                          <SelectItem value="si">Sì</SelectItem>
                          {interesse.key === 'uso_telefono' && (
                            <>
                              <SelectItem value="si_autonomo">Sì, autonomo</SelectItem>
                              <SelectItem value="si_assistito">Sì, assistito</SelectItem>
                            </>
                          )}
                        </SelectContent>
                      </Select>
                    </div>
                  ))}
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Esce dalla Struttura</Label>
                    <Select value={paiData.esce_struttura} onValueChange={(v) => handlePaiFieldChange('esce_struttura', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no">No</SelectItem>
                        <SelectItem value="si_solo">Sì, da solo</SelectItem>
                        <SelectItem value="si_accompagnato">Sì, accompagnato</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Luoghi Frequentati</Label>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {['bar', 'cinema', 'mercato', 'altro'].map(tipo => (
                        <label key={tipo} className="flex items-center gap-1 text-sm bg-slate-100 px-2 py-1 rounded cursor-pointer">
                          <input 
                            type="checkbox"
                            checked={(paiData.luoghi_frequentati || []).includes(tipo)}
                            onChange={(e) => handlePaiCheckboxChange('luoghi_frequentati', tipo, e.target.checked)}
                          />
                          {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Step 6: Osservazione */}
            {paiStep === 6 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Osservazione</h3>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Tono dell'Umore</Label>
                    <Select value={paiData.tono_umore} onValueChange={(v) => handlePaiFieldChange('tono_umore', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="normale">Normale</SelectItem>
                        <SelectItem value="saltuariamente_triste">Saltuariamente triste</SelectItem>
                        <SelectItem value="depresso">Stabilmente depresso</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Agitazione Psico-motoria</Label>
                    <Select value={paiData.agitazione} onValueChange={(v) => handlePaiFieldChange('agitazione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="assente">Assente</SelectItem>
                        <SelectItem value="episodica">Episodica</SelectItem>
                        <SelectItem value="giorno_notte">Presente giorno e notte</SelectItem>
                        <SelectItem value="solo_giorno">Solo di giorno</SelectItem>
                        <SelectItem value="solo_notte">Solo di notte</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Collaborazione</Label>
                    <Select value={paiData.collaborazione} onValueChange={(v) => handlePaiFieldChange('collaborazione', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="collaborante">Collaborante</SelectItem>
                        <SelectItem value="saltuariamente">Saltuariamente collaborante</SelectItem>
                        <SelectItem value="con_incoraggiamento">Collaborante con incoraggiamento</SelectItem>
                        <SelectItem value="non_collaborante">Non collaborante</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Orientamento</Label>
                    <Select value={paiData.orientamento} onValueChange={(v) => handlePaiFieldChange('orientamento', v)}>
                      <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="orientato">Orientato tempo e spazio</SelectItem>
                        <SelectItem value="saltuariamente_non">Saltuariamente non orientato</SelectItem>
                        <SelectItem value="orientato_struttura">Orientato in struttura</SelectItem>
                        <SelectItem value="non_orientato_tempo">Non orientato nel tempo</SelectItem>
                        <SelectItem value="non_orientato_spazio">Non orientato nello spazio</SelectItem>
                        <SelectItem value="disorientato">Disorientato</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                
                <div>
                  <Label>Memoria</Label>
                  <Select value={paiData.memoria} onValueChange={(v) => handlePaiFieldChange('memoria', v)}>
                    <SelectTrigger><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="buona">Buona, trattiene informazioni</SelectItem>
                      <SelectItem value="breve_termine">Perdita memoria a breve termine</SelectItem>
                      <SelectItem value="breve_lungo">Perdita memoria breve e lungo termine</SelectItem>
                      <SelectItem value="non_riconosce">Non ricorda/riconosce luoghi e persone</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                
                <div>
                  <Label>Ansia</Label>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {['moderata', 'grave', 'idee_conservative', 'in_terapia_antidepressiva', 'in_carico_dsm', 'ipocondria'].map(tipo => (
                      <label key={tipo} className="flex items-center gap-1 text-sm bg-slate-100 px-2 py-1 rounded cursor-pointer">
                        <input 
                          type="checkbox"
                          checked={(paiData.ansia || []).includes(tipo)}
                          onChange={(e) => handlePaiCheckboxChange('ansia', tipo, e.target.checked)}
                        />
                        {tipo.replace(/_/g, ' ').charAt(0).toUpperCase() + tipo.replace(/_/g, ' ').slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            )}
            
            {/* Step 7: Obiettivi */}
            {paiStep === 7 && (
              <div className="space-y-4">
                <h3 className="font-semibold text-purple-700 border-b pb-2">Obiettivi Generali</h3>
                
                <div className="space-y-3">
                  <label className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg cursor-pointer">
                    <input 
                      type="checkbox"
                      checked={paiData.obiettivo_socializzazione}
                      onChange={(e) => handlePaiFieldChange('obiettivo_socializzazione', e.target.checked)}
                      className="w-5 h-5"
                    />
                    <div>
                      <span className="font-medium">Incremento socializzazione</span>
                      <p className="text-sm text-slate-500">Incremento del livello di socializzazione all'interno della Comunità Alloggio</p>
                    </div>
                  </label>
                  
                  <label className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg cursor-pointer">
                    <input 
                      type="checkbox"
                      checked={paiData.obiettivo_mantenimento}
                      onChange={(e) => handlePaiFieldChange('obiettivo_mantenimento', e.target.checked)}
                      className="w-5 h-5"
                    />
                    <div>
                      <span className="font-medium">Mantenimento capacità residue</span>
                      <p className="text-sm text-slate-500">Mantenimento delle capacità residue dell'ospite</p>
                    </div>
                  </label>
                  
                  <label className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg cursor-pointer">
                    <input 
                      type="checkbox"
                      checked={paiData.obiettivo_autonomie}
                      onChange={(e) => handlePaiFieldChange('obiettivo_autonomie', e.target.checked)}
                      className="w-5 h-5"
                    />
                    <div>
                      <span className="font-medium">Rinforzo autonomie personali</span>
                      <p className="text-sm text-slate-500">Rinforzo delle autonomie personali quotidiane</p>
                    </div>
                  </label>
                </div>
                
                <div>
                  <Label>Obiettivi Specifici</Label>
                  <Textarea 
                    value={paiData.obiettivo_specifico}
                    onChange={(e) => handlePaiFieldChange('obiettivo_specifico', e.target.value)}
                    placeholder="Obiettivi specifici individuati per questo ospite..."
                    rows={3}
                  />
                </div>
                
                <div>
                  <Label>Note Generali</Label>
                  <Textarea 
                    value={paiData.note_generali}
                    onChange={(e) => handlePaiFieldChange('note_generali', e.target.value)}
                    placeholder="Note aggiuntive, osservazioni particolari..."
                    rows={4}
                  />
                </div>
                
                <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <h4 className="font-medium text-purple-800 mb-2">Promemoria</h4>
                  <ul className="text-sm text-purple-700 space-y-1">
                    <li>• Gli obiettivi sono verificati semestralmente</li>
                    <li>• Gli interventi nelle autonomie personali e motorie sono quotidiani</li>
                    <li>• Il coinvolgimento del nucleo familiare prevede colloqui mensili/bimestrali</li>
                    <li>• Lo stato di salute è monitorato periodicamente dal medico di famiglia</li>
                  </ul>
                </div>
              </div>
            )}

            {/* Step 8: Firme */}
            {paiStep === 8 && (
              <PaiFirmeStep
                ref={paiFirmeStepRef}
                firmeState={paiFirmeState}
                onFirmeChange={setPaiFirmeState}
                defaultSignerName={user?.name || ""}
              />
            )}
          </div>
          
          <DialogFooter className="border-t pt-4">
            <div className="flex items-center justify-between w-full">
              <Button 
                variant="outline" 
                onClick={() => paiStep > 0 ? setPaiStep(paiStep - 1) : setShowPaiModal(false)}
              >
                {paiStep === 0 ? 'Annulla' : 'Indietro'}
              </Button>
              
              <div className="flex gap-2">
                <Button 
                  variant="outline"
                  onClick={handlePrintPai}
                >
                  <Printer className="w-4 h-4 mr-2" />
                  Stampa
                </Button>
                
                {paiStep < 8 ? (
                  <Button 
                    onClick={() => setPaiStep(paiStep + 1)}
                    className="bg-purple-600 hover:bg-purple-700"
                  >
                    Avanti
                  </Button>
                ) : (
                  <Button 
                    onClick={handleSavePai}
                    disabled={savingPai}
                    className="bg-purple-600 hover:bg-purple-700"
                  >
                    {savingPai ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Salvataggio...
                      </>
                    ) : (
                      <>
                        <Save className="w-4 h-4 mr-2" />
                        Salva PAI
                      </>
                    )}
                  </Button>
                )}
              </div>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Visualizzazione PAI Salvato */}
      <Dialog open={showPaiViewModal} onOpenChange={setShowPaiViewModal}>
        <DialogContent className="max-w-[95vw] sm:max-w-[900px] max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ClipboardList className="w-5 h-5 text-purple-600" />
              Piano Personalizzato Assistenziale (PAI)
            </DialogTitle>
            <DialogDescription>
              PAI di {cartella?.anagrafica?.nome} {cartella?.anagrafica?.cognome} - 
              Redatto il {viewingPai?.data_redazione ? new Date(viewingPai.data_redazione).toLocaleDateString('it-IT') : '-'}
            </DialogDescription>
          </DialogHeader>
          
          <div className="flex-1 overflow-y-auto py-4 px-1">
            {viewingPai && <PaiViewBody pai={viewingPai} fascicoloId={id} token={token} />}
          </div>
          
          <DialogFooter className="border-t pt-4">
            <Button variant="outline" onClick={() => setShowPaiViewModal(false)}>
              Chiudi
            </Button>
            {viewingPai && !isPaiEsterno(viewingPai) && (
              <>
                <Button 
                  onClick={() => {
                    setShowPaiViewModal(false);
                    setShowPaiModal(true);
                  }}
                  variant="outline"
                  className="border-blue-300 text-blue-600 hover:bg-blue-50"
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Modifica PAI
                </Button>
                <Button 
                  onClick={() => handlePrintSavedPai(viewingPai)}
                  className="bg-purple-600 hover:bg-purple-700"
                >
                  <Printer className="w-4 h-4 mr-2" />
                  Stampa PAI
                </Button>
              </>
            )}
            {viewingPai && isPaiUpload(viewingPai) && (
              <Button
                onClick={handleOpenPaiFile}
                className="bg-blue-600 hover:bg-blue-700"
              >
                <FileText className="w-4 h-4 mr-2" />
                Apri file PAI
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modale upload PAI da file */}
      <Dialog open={showPaiUploadModal} onOpenChange={setShowPaiUploadModal}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Upload className="w-5 h-5 text-purple-600" />
              Carica PAI da file
            </DialogTitle>
            <DialogDescription>
              Carica un file PAI già redatto. Questa operazione è consentita una sola volta per fascicolo.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-2">
            <div className="space-y-1">
              <Label htmlFor="pai-upload-file">
                File <span className="text-red-500">*</span>
              </Label>
              <Input
                id="pai-upload-file"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx"
                onChange={(e) => setPaiUploadFile(e.target.files?.[0] || null)}
              />
              <p className="text-xs text-slate-500">Formati ammessi: PDF, immagini, Word, Excel. Max 50 MB.</p>
            </div>

            <div className="space-y-1">
              <Label htmlFor="pai-data-redazione">
                Data di redazione <span className="text-red-500">*</span>
              </Label>
              <DateFieldInput
                id="pai-data-redazione"
                value={paiUploadData.data_redazione}
                onChange={(v) =>
                  setPaiUploadData((prev) => ({ ...prev, data_redazione: v }))
                }
              />
            </div>

            <div className="space-y-1">
              <Label htmlFor="pai-data-scadenza">
                Data di scadenza <span className="text-slate-400 text-xs">(opzionale — se vuota: redazione +180gg)</span>
              </Label>
              <DateFieldInput
                id="pai-data-scadenza"
                value={paiUploadData.data_scadenza}
                onChange={(v) =>
                  setPaiUploadData((prev) => ({ ...prev, data_scadenza: v }))
                }
              />
            </div>

            <div className="space-y-1">
              <Label htmlFor="pai-note-generali">Note</Label>
              <Textarea
                id="pai-note-generali"
                placeholder="Note opzionali..."
                value={paiUploadData.note_generali}
                onChange={(e) => setPaiUploadData(prev => ({ ...prev, note_generali: e.target.value }))}
                rows={3}
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowPaiUploadModal(false)} disabled={savingPaiUpload}>
              Annulla
            </Button>
            <Button
              onClick={handleSavePaiUpload}
              disabled={savingPaiUpload || !paiUploadFile || !paiUploadData.data_redazione}
              className="bg-purple-600 hover:bg-purple-700"
            >
              {savingPaiUpload ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Caricamento...</>
              ) : (
                <><Upload className="w-4 h-4 mr-2" />Carica PAI</>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
    </>
  );
}
